import _taggedTemplateLiteral from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/taggedTemplateLiteral";
import _toConsumableArray from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/slicedToArray";
import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;
import 'core-js/modules/es.object.assign.js';
import { createContext, useReducer, useMemo, useContext, useState, useRef, useEffect, useCallback } from 'react';
import { useMutation, useLazyQuery, ApolloProvider } from 'react-apollo';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/es.array.reduce.js';
import { Modal } from '@wds/modal';
import { createUseStyles, ThemeProvider } from 'react-jss';
import { T, t, FormattedDateTime, FormattedNumber } from '@sm/intl';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Grid } from '@wds/grid';
import { Typography } from '@wds/typography';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'core-js/modules/es.symbol.description.js';
import ErrorCard from '@sm/webassets/dist/components/ErrorCard';
import { Input } from '@wds/input';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.string.trim.js';
import 'core-js/modules/es.array.flat-map.js';
import 'core-js/modules/es.array.unscopables.flat-map.js';
import { USER_EVENTS } from '@sm/metrics';
import { merge, isEqual, startCase } from 'lodash';
import { IconCheckCircle, IconFlag, IconMoreAndroid, IconInsights, IconFaceHappy, IconFaceSad, IconFaceNeutral, IconHelpFilled, IconWarningFilled, IconCheck, IconLightbulb, IconCaretDown, IconArrowLeft } from '@wds/icons';
import { Chip } from '@wds/chip';
import { gql } from 'graphql-tag';
import SkeletonLoader from '@sm/webassets/dist/components/SkeletonLoader';
import { List } from '@wds/list';
import { Menu } from '@wds/menu';
import { SelectMenu } from '@wds/select-menu';
import { Checkbox } from '@wds/checkbox';
import { sanitizeString } from '@sm/utils';
import 'core-js/modules/es.string.starts-with.js';
import { Toast } from '@wds/toast';
import { ProgressCircle } from '@wds/progress-circle';
import classNames from 'classnames';
import { DonutChart as DonutChart$1 } from '@sm/question-ui/charts';
import { Pagination } from '@wds/pagination';
import createBrowserApolloClient from '@sm/apollo-clients/dist/browser';
import { WrenchTheme } from '@wds/styles';
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var OECTagType = /*#__PURE__*/function (OECTagType) {
  OECTagType["OECMODEL"] = "OECMODEL";
  OECTagType["OECUSER"] = "OECUSER";
  OECTagType["SENTIMENT"] = "SENTIMENT";
  OECTagType["USER"] = "USER";
  return OECTagType;
}({});
var OECDiscardKeywordsModal = /*#__PURE__*/function (OECDiscardKeywordsModal) {
  OECDiscardKeywordsModal["HIDE_KEYWORDS_MODAL"] = "HIDE_KEYWORDS_MODAL";
  OECDiscardKeywordsModal["SHOW_KEYWORDS_MODAL_BACK"] = "SHOW_KEYWORDS_MODAL_BACK";
  OECDiscardKeywordsModal["SHOW_KEYWORDS_MODAL_CLOSED"] = "SHOW_KEYWORDS_MODAL_CLOSED";
  return OECDiscardKeywordsModal;
}({});
var OECSentiment = /*#__PURE__*/function (OECSentiment) {
  OECSentiment["SM_NEGATIVE"] = "SM_NEGATIVE";
  OECSentiment["SM_NEUTRAL"] = "SM_NEUTRAL";
  OECSentiment["SM_NOT_ENABLED"] = "SM_NOT_ENABLED";
  OECSentiment["SM_POSITIVE"] = "SM_POSITIVE";
  OECSentiment["SM_UNDETECTED"] = "SM_UNDETECTED";
  return OECSentiment;
}({});
var OECJobState = /*#__PURE__*/function (OECJobState) {
  OECJobState["QUEUED"] = "QUEUED";
  OECJobState["FAILED"] = "FAILED";
  OECJobState["IN_PROGRESS"] = "IN_PROGRESS";
  OECJobState["SUCCESS"] = "SUCCESS";
  return OECJobState;
}({});
var SORT_BY = /*#__PURE__*/function (SORT_BY) {
  SORT_BY["DATE"] = "DATE";
  SORT_BY["ALPHABETICALLY"] = "ALPHABETICAL";
  return SORT_BY;
}({});
var OECCreatedSource = /*#__PURE__*/function (OECCreatedSource) {
  OECCreatedSource["THEMES"] = "themes";
  OECCreatedSource["AUTO_TAGGING"] = "autotagging";
  return OECCreatedSource;
}({});
var TRAINING_STEP = /*#__PURE__*/function (TRAINING_STEP) {
  TRAINING_STEP["KEYWORD_GENERATION"] = "keyword_generation";
  TRAINING_STEP["KEYWORD_FETCHING"] = "keyword_fetching";
  TRAINING_STEP["KEYWORDS_LOADED"] = "keywords_loaded";
  TRAINING_STEP["KEYWORDS_VIEWING"] = "keywords_view";
  TRAINING_STEP["TRAINING_IN_PROGRESS"] = "training_in_progress";
  TRAINING_STEP["TRAINING_FINISHED"] = "training_finished";
  TRAINING_STEP["TRAINING_ERROR"] = "training_error";
  return TRAINING_STEP;
}({});
var OECTrainingStatus = /*#__PURE__*/function (OECTrainingStatus) {
  OECTrainingStatus["NOT_TRAINED"] = "NOT_TRAINED";
  OECTrainingStatus["REQUIRES_RETRAINING"] = "REQUIRES_RETRAINING";
  OECTrainingStatus["TRAINING_COMPLETE"] = "TRAINING_COMPLETE";
  return OECTrainingStatus;
}({});
var OECRetrainStepProgress = /*#__PURE__*/function (OECRetrainStepProgress) {
  OECRetrainStepProgress["HIDE_STEP"] = "HIDE_STEP";
  OECRetrainStepProgress["STEP_IN_PROGRESS"] = "STEP_IN_PROGRESS";
  OECRetrainStepProgress["STEP_COMPLETE"] = "STEP_COMPLETE";
  return OECRetrainStepProgress;
}({});
var BLUE_CHECK = '#2CB2F1';
var BORDER_COLOR = '#D0D2D3';
var BACKGROUND_COLOR_HOVER = '#FFFFFF';
var BORDER_COLOR_HOVER = '#9DA5AA';
var RESPONSE_PAGE_SIZE = 20;
var ALL_FILTER_ID = '-1';
var ALL_RESPONSES = 'All Responses';
var MIN_NUMBER_OF_THEMES = 2;
var PERCENT_TO_TAG = 5;
var NUMBER_OF_RESPONSES = 5;
var SIGNIFICANT_CHANGES_FOR_RETRAIN = 10;
var MAX_SEEN_COUNT_UPDATE_AUTOTAGGING_MODAL = 1;
var COLD_START_ENABLED = false;
var USE_CASES = {
  employee_engagement: 'ex',
  customer_satisfaction: 'cx',
  concept_testing: 'ctm',
  none: 'none'
};
var USE_CASE_NONE = USE_CASES.none;
var Z_INDEX = 2000;
var generalInitState = {
  surveyId: '',
  questionId: '',
  isSolutions: false,
  error: false,
  showDiscardKeywordsModal: OECDiscardKeywordsModal.HIDE_KEYWORDS_MODAL,
  showUpdateAutotaggingModal: false,
  updateAutotaggingModalSeenCount: 0
};
var stimuliInitState = {
  stimuli: []
};
var filtersInitState = {
  searchInput: '',
  sortValue: SORT_BY.DATE,
  filterDisabled: false,
  selectedThemes: [],
  selectedStimuli: [],
  selectedSentiment: []
};
var responsesInitState = {
  responses: [],
  responsesError: false,
  responsesLoading: false,
  responsesPageSize: RESPONSE_PAGE_SIZE,
  responsesPage: 0,
  responsesCount: 0,
  responsesTotal: 0,
  responsesChanged: false,
  significantChangesResponses: 0,
  showSA: false,
  saStats: {
    negative: 0,
    neutral: 0,
    positive: 0,
    undetected: 0
  }
};
var feedbackInitState = {
  autotaggingPredictionId: null,
  keywordPredictionId: null,
  jobId: null
};
var trainingInitState = {
  trainingStep: TRAINING_STEP.KEYWORD_GENERATION,
  unsavedKeywords: [],
  generatedKeywords: [],
  summaryCounts: null,
  trainingError: false,
  trainingComplete: false,
  showTrainingScreen: false,
  shouldRefetchOnOpen: false,
  showTrainingErrorToast: false
};
var retrainingInitState = {
  trainingStatus: OECTrainingStatus.NOT_TRAINED,
  notEnoughThemesCreated: false,
  notEnoughResponsesTagged: false,
  applyThemeToMoreResponses: false,
  notEnoughThemesCreatedStep: OECRetrainStepProgress.HIDE_STEP,
  notEnoughResponsesTaggedStep: OECRetrainStepProgress.HIDE_STEP,
  applyThemeToMoreResponsesStep: OECRetrainStepProgress.HIDE_STEP
};
var themesInitState = {
  keywords: [],
  keywordsLoading: false,
  keywordsError: false,
  initialThemes: [],
  themes: [],
  themesLoading: false,
  themesError: false,
  themesAdded: false,
  themesDeleted: false,
  themesChanged: false
};
var themesReuseInitState = {
  previouslyUsedThemes: [],
  suggestedThemes: {},
  useCases: [],
  selectedUseCase: null,
  selectedReusedThemes: []
};
Object.assign({}, generalInitState, themesInitState, retrainingInitState, responsesInitState, stimuliInitState, filtersInitState, trainingInitState, feedbackInitState, themesReuseInitState);
var STIMULI_ACTION = /*#__PURE__*/function (STIMULI_ACTION) {
  STIMULI_ACTION["SET_STIMULI"] = "SET_STIMULI";
  STIMULI_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return STIMULI_ACTION;
}({});
var GENERAL_ACTION = /*#__PURE__*/function (GENERAL_ACTION) {
  GENERAL_ACTION["SET_ERROR"] = "SET_ERROR";
  GENERAL_ACTION["SET_SHOW_DISCARD_KEYWORDS_MODAL"] = "SET_SHOW_DISCARD_KEYWORDS_MODAL";
  GENERAL_ACTION["SET_SHOW_UPDATE_AUTOTAGGING_MODAL"] = "SET_SHOW_UPDATE_AUTOTAGGING_MODAL";
  GENERAL_ACTION["SET_UPDATE_AUTOTAGGING_MODAL_SEEN_COUNT"] = "SET_UPDATE_AUTOTAGGING_MODAL_SEEN_COUNT";
  GENERAL_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return GENERAL_ACTION;
}({});
var FILTERS_ACTION = /*#__PURE__*/function (FILTERS_ACTION) {
  FILTERS_ACTION["SET_SEARCH"] = "SET_SEARCH";
  FILTERS_ACTION["SET_SORT_BY"] = "SET_SORT_BY";
  FILTERS_ACTION["SET_DISABLED"] = "SET_DISABLED";
  FILTERS_ACTION["SET_SELECTED_THEMES"] = "SET_SELECTED_THEMES";
  FILTERS_ACTION["SET_SELECTED_STIMULI"] = "SET_SELECTED_STIMULI";
  FILTERS_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  FILTERS_ACTION["SET_SELECTED_SENTIMENT"] = "SET_SELECTED_SENTIMENT";
  return FILTERS_ACTION;
}({});
var THEMES_ACTION = /*#__PURE__*/function (THEMES_ACTION) {
  THEMES_ACTION["SET_INITIAL_THEMES"] = "SET_INITIAL_THEMES";
  THEMES_ACTION["SET_THEMES"] = "SET_THEMES";
  THEMES_ACTION["SET_KEYWORDS"] = "SET_KEYWORDS";
  THEMES_ACTION["SET_KEYWORDS_LOADING"] = "SET_KEYWORDS_LOADING";
  THEMES_ACTION["SET_KEYWORDS_ERROR"] = "SET_KEYWORDS_ERROR";
  THEMES_ACTION["SET_THEMES_LOADING"] = "SET_THEMES_LOADING";
  THEMES_ACTION["SET_THEMES_ERROR"] = "SET_THEMES_ERROR";
  THEMES_ACTION["ADD_THEME"] = "ADD_THEME";
  THEMES_ACTION["SET_THEMES_ADDED"] = "SET_THEMES_ADDED";
  THEMES_ACTION["SET_THEMES_DELETED"] = "SET_THEMES_DELETED";
  THEMES_ACTION["SET_THEMES_CHANGED"] = "SET_THEMES_CHANGED";
  THEMES_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return THEMES_ACTION;
}({});
var THEMES_REUSE_ACTION = /*#__PURE__*/function (THEMES_REUSE_ACTION) {
  THEMES_REUSE_ACTION["SET_PREVIOUSLY_USED_THEMES"] = "SET_PREVIOUSLY_USED_THEMES";
  THEMES_REUSE_ACTION["SET_SUGGESTED_THEMES"] = "SET_SUGGESTED_THEMES";
  THEMES_REUSE_ACTION["SET_SUGGESTED_THEMES_FOR_RESPONSE"] = "SET_SUGGESTED_THEMES_FOR_RESPONSE";
  THEMES_REUSE_ACTION["SET_USE_CASES"] = "SET_USE_CASES";
  THEMES_REUSE_ACTION["SET_SELECTED_USE_CASE"] = "SET_SELECTED_USE_CASE";
  THEMES_REUSE_ACTION["SET_SELECTED_REUSED_THEMES"] = "SET_SELECTED_REUSED_THEMES";
  THEMES_REUSE_ACTION["ADD_REUSED_THEME"] = "ADD_REUSED_THEME";
  THEMES_REUSE_ACTION["REMOVE_REUSED_THEME"] = "REMOVE_REUSED_THEME";
  THEMES_REUSE_ACTION["ADD_PREVIOUSLY_USED_THEME"] = "ADD_PREVIOUSLY_USED_THEME";
  THEMES_REUSE_ACTION["REMOVE_PREVIOUSLY_USED_THEME"] = "REMOVE_PREVIOUSLY_USED_THEME";
  THEMES_REUSE_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return THEMES_REUSE_ACTION;
}({});
var RESPONSES_ACTION = /*#__PURE__*/function (RESPONSES_ACTION) {
  RESPONSES_ACTION["SET_RESPONSES"] = "SET_RESPONSES";
  RESPONSES_ACTION["SET_RESPONSES_ERROR"] = "SET_RESPONSES_ERROR";
  RESPONSES_ACTION["SET_RESPONSES_LOADING"] = "SET_RESPONSES_LOADING";
  RESPONSES_ACTION["SET_RESPONSES_PAGE_SIZE"] = "SET_RESPONSES_PAGE_SIZE";
  RESPONSES_ACTION["SET_RESPONSES_PAGE"] = "SET_RESPONSES_PAGE";
  RESPONSES_ACTION["SET_RESPONSES_COUNT"] = "SET_RESPONSES_COUNT";
  RESPONSES_ACTION["SET_RESPONSES_TOTAL"] = "SET_RESPONSES_TOTAL";
  RESPONSES_ACTION["SET_RESPONSES_CHANGED"] = "SET_RESPONSES_CHANGED";
  RESPONSES_ACTION["SET_SHOW_SA"] = "SET_SHOW_SA";
  RESPONSES_ACTION["SET_SA_STATS"] = "SET_SA_STATS";
  RESPONSES_ACTION["SET_SIGNIFICANT_CHANGES_TO_RESPONSES"] = "SET_SIGNIFICANT_CHANGES_TO_RESPONSES";
  RESPONSES_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return RESPONSES_ACTION;
}({});
var TRAINING_ACTION = /*#__PURE__*/function (TRAINING_ACTION) {
  TRAINING_ACTION["SET_TRAINING_STATUS"] = "SET_TRAINING_STATUS";
  TRAINING_ACTION["SET_UNSAVED_KEYWORDS"] = "SET_UNSAVED_KEYWORDS";
  TRAINING_ACTION["SET_GENERATED_KEYWORDS"] = "SET_GENERATED_KEYWORDS";
  TRAINING_ACTION["SET_SUMMARY_COUNTS"] = "SET_SUMMARY_COUNTS";
  TRAINING_ACTION["SET_TRAINING_ERROR"] = "SET_TRAINING_ERROR";
  TRAINING_ACTION["SET_TRAINING_COMPLETE"] = "SET_TRAINING_COMPLETE";
  TRAINING_ACTION["SET_SHOW_TRAINING_SCREEN"] = "SET_SHOW_TRAINING_SCREEN";
  TRAINING_ACTION["SET_SHOULD_REFETCH_ON_OPEN"] = "SET_SHOULD_REFETCH_ON_OPEN";
  TRAINING_ACTION["SET_SHOW_TRAINING_ERROR_TOAST"] = "SET_SHOW_TRAINING_ERROR_TOAST";
  TRAINING_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return TRAINING_ACTION;
}({});
var RETRAINING_ACTION = /*#__PURE__*/function (RETRAINING_ACTION) {
  RETRAINING_ACTION["SET_TRAINING_STATUS"] = "SET_TRAINING_STATUS";
  RETRAINING_ACTION["SET_NOT_ENOUGH_THEMES_CREATED"] = "SET_NOT_ENOUGH_THEMES_CREATED";
  RETRAINING_ACTION["SET_NOT_ENOUGH_RESPONSES_TAGGED"] = "SET_NOT_ENOUGH_RESPONSES_TAGGED";
  RETRAINING_ACTION["SET_APPLY_THEME_TO_MORE_RESPONSES"] = "SET_APPLY_THEME_TO_MORE_RESPONSES";
  RETRAINING_ACTION["SET_NOT_ENOUGH_THEMES_CREATED_STEP"] = "SET_NOT_ENOUGH_THEMES_CREATED_STEP";
  RETRAINING_ACTION["SET_NOT_ENOUGH_RESPONSES_TAGGED_STEP"] = "SET_NOT_ENOUGH_RESPONSES_TAGGED_STEP";
  RETRAINING_ACTION["SET_APPLY_THEME_TO_MORE_RESPONSES_STEP"] = "SET_APPLY_THEME_TO_MORE_RESPONSES_STEP";
  RETRAINING_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return RETRAINING_ACTION;
}({});
var FEEDBACK_ACTION = /*#__PURE__*/function (FEEDBACK_ACTION) {
  FEEDBACK_ACTION["SET_AUTOTAGGING_PREDICTION_ID"] = "SET_AUTOTAGGING_PREDICTION_ID";
  FEEDBACK_ACTION["SET_KEYWORD_PREDICTION_ID"] = "SET_KEYWORD_PREDICTION_ID";
  FEEDBACK_ACTION["SET_JOB_ID"] = "SET_JOB_ID";
  FEEDBACK_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  return FEEDBACK_ACTION;
}({});
var wrapActions = function wrapActions(_ref) {
  var dispatch = _ref.dispatch,
    actions = _ref.actions;
  return Object.keys(actions).reduce(function (acc, key) {
    return Object.assign({}, acc, _defineProperty({}, key, actions[key](dispatch)));
  },
  // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
  {});
};
var filterValues = function filterValues(values, allowed) {
  if (!values) {
    return values;
  }
  var allowedKeys = Object.keys(allowed);
  return Object.keys(values).filter(function (key) {
    return allowedKeys.includes(key);
  }).reduce(function (acc, key) {
    return Object.assign({}, acc, _defineProperty({}, key, values[key]));
  }, {});
};
var getPropertyFromPayload = function getPropertyFromPayload(propName, payload) {
  if (propName in payload && (payload == null ? void 0 : payload[propName]) !== undefined) {
    return payload == null ? void 0 : payload[propName];
  }
  return undefined;
};
var getActionTypeKey$6 = function getActionTypeKey$6(actionType) {
  switch (actionType) {
    case GENERAL_ACTION.SET_ERROR:
      {
        return 'error';
      }
    case GENERAL_ACTION.SET_SHOW_DISCARD_KEYWORDS_MODAL:
      {
        return 'showDiscardKeywordsModal';
      }
    case GENERAL_ACTION.SET_SHOW_UPDATE_AUTOTAGGING_MODAL:
      {
        return 'showUpdateAutotaggingModal';
      }
    case GENERAL_ACTION.SET_UPDATE_AUTOTAGGING_MODAL_SEEN_COUNT:
      {
        return 'updateAutotaggingModalSeenCount';
      }
    case GENERAL_ACTION.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
var reducer$8 = function reducer$8(state, action) {
  var type = action.type,
    payload = action.payload;
  var k = getActionTypeKey$6(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign({}, state, payload);
      }
    case '':
      {
        throw new Error("Unknown action: ".concat(type));
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign({}, state, _defineProperty({}, k, getPropertyFromPayload(k, payload)));
      }
  }
};
var setError = function setError(dispatch) {
  return function (error) {
    return dispatch({
      type: GENERAL_ACTION.SET_ERROR,
      payload: {
        error: error
      }
    });
  };
};
var setShowDiscardKeywordsModal = function setShowDiscardKeywordsModal(dispatch) {
  return function (val) {
    return dispatch({
      type: GENERAL_ACTION.SET_SHOW_DISCARD_KEYWORDS_MODAL,
      payload: {
        showDiscardKeywordsModal: val
      }
    });
  };
};
var setShowUpdateAutotaggingModal = function setShowUpdateAutotaggingModal(dispatch) {
  return function (val) {
    return dispatch({
      type: GENERAL_ACTION.SET_SHOW_UPDATE_AUTOTAGGING_MODAL,
      payload: {
        showUpdateAutotaggingModal: val
      }
    });
  };
};
var setUpdateAutotaggingModalSeenCount = function setUpdateAutotaggingModalSeenCount(dispatch) {
  return function (val) {
    return dispatch({
      type: GENERAL_ACTION.SET_UPDATE_AUTOTAGGING_MODAL_SEEN_COUNT,
      payload: {
        updateAutotaggingModalSeenCount: val
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$8 = function setMultiple$8(dispatch) {
  return function (payload) {
    return dispatch({
      type: GENERAL_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var generalActions = {
  setError: setError,
  setShowDiscardKeywordsModal: setShowDiscardKeywordsModal,
  setShowUpdateAutotaggingModal: setShowUpdateAutotaggingModal,
  setUpdateAutotaggingModalSeenCount: setUpdateAutotaggingModalSeenCount,
  setMultiple: setMultiple$8
};
var GeneralContext = /*#__PURE__*/createContext({});
GeneralContext.displayName = 'GeneralContext';
var GeneralContextActions = /*#__PURE__*/createContext({});
GeneralContextActions.displayName = 'GeneralContextActions';
var GeneralContextProvider = function GeneralContextProvider(_ref2) {
  var value = _ref2.value,
    children = _ref2.children;
  var _useReducer = useReducer(reducer$8, Object.assign({}, generalInitState, value)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: generalActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(GeneralContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(GeneralContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useGeneral = function useGeneral() {
  var context = useContext(GeneralContext);
  if (!(context != null && context.state)) {
    throw new Error('useGeneral must be used within a Provider');
  }
  return context.state;
};
var useGeneralActions = function useGeneralActions() {
  var context = useContext(GeneralContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useGeneralActions must be used within a Provider');
  }
  return context.actions;
};
var reducer$7 = function reducer$7(state, action) {
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case THEMES_ACTION.SET_INITIAL_THEMES:
      {
        if (!('initialThemes' in payload && payload.initialThemes !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          initialThemes: payload.initialThemes
        });
      }
    case THEMES_ACTION.SET_THEMES:
      {
        if (!('themes' in payload && payload.themes !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          themes: payload.themes
        });
      }
    case THEMES_ACTION.SET_KEYWORDS:
      {
        if (!('keywords' in payload && payload.keywords !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          keywords: payload.keywords
        });
      }
    case THEMES_ACTION.SET_KEYWORDS_LOADING:
      {
        if (!('keywordsLoading' in payload && payload.keywordsLoading !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          keywordsLoading: payload.keywordsLoading
        });
      }
    case THEMES_ACTION.SET_KEYWORDS_ERROR:
      {
        if (!('keywordsError' in payload && payload.keywordsError !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          keywordsError: payload.keywordsError
        });
      }
    case THEMES_ACTION.SET_THEMES_LOADING:
      {
        if (!('themesLoading' in payload && payload.themesLoading !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          themesLoading: payload.themesLoading
        });
      }
    case THEMES_ACTION.SET_THEMES_ERROR:
      {
        if (!('themesError' in payload && payload.themesError !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          themesError: payload.themesError
        });
      }
    case THEMES_ACTION.ADD_THEME:
      {
        if (!('theme' in payload && payload.theme !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          themes: [].concat(_toConsumableArray(state.themes), [payload.theme])
        });
      }
    case THEMES_ACTION.SET_THEMES_CHANGED:
      {
        if (!('themesChanged' in payload && payload.themesChanged !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          themesChanged: payload.themesChanged
        });
      }
    case THEMES_ACTION.SET_THEMES_ADDED:
      {
        if (!('themesAdded' in payload && payload.themesAdded !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          themesAdded: payload.themesAdded
        });
      }
    case THEMES_ACTION.SET_THEMES_DELETED:
      {
        if (!('themesDeleted' in payload && payload.themesDeleted !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          themesDeleted: payload.themesDeleted
        });
      }
    // sometimes we need to update multiple state values at once
    case THEMES_ACTION.SET_MULTIPLE:
      {
        return Object.assign({}, state, payload);
      }
  }
  throw new Error("Unknown action: ".concat(type));
};
var setInitialThemes = function setInitialThemes(dispatch) {
  return function (themes) {
    return dispatch({
      type: THEMES_ACTION.SET_INITIAL_THEMES,
      payload: {
        initialThemes: themes
      }
    });
  };
};
var setThemes = function setThemes(dispatch) {
  return function (themes) {
    return dispatch({
      type: THEMES_ACTION.SET_THEMES,
      payload: {
        themes: themes
      }
    });
  };
};
var setKeywords = function setKeywords(dispatch) {
  return function (keywords) {
    return dispatch({
      type: THEMES_ACTION.SET_KEYWORDS,
      payload: {
        keywords: keywords
      }
    });
  };
};
var setKeywordsLoading = function setKeywordsLoading(dispatch) {
  return function (loading) {
    return dispatch({
      type: THEMES_ACTION.SET_KEYWORDS_LOADING,
      payload: {
        keywordsLoading: loading
      }
    });
  };
};
var setKeywordsError = function setKeywordsError(dispatch) {
  return function (error) {
    return dispatch({
      type: THEMES_ACTION.SET_KEYWORDS_ERROR,
      payload: {
        keywordsError: error
      }
    });
  };
};
var setThemesLoading = function setThemesLoading(dispatch) {
  return function (loading) {
    return dispatch({
      type: THEMES_ACTION.SET_THEMES_LOADING,
      payload: {
        themesLoading: loading
      }
    });
  };
};
var setThemesError = function setThemesError(dispatch) {
  return function (error) {
    return dispatch({
      type: THEMES_ACTION.SET_THEMES_ERROR,
      payload: {
        themesError: error
      }
    });
  };
};
var addTheme = function addTheme(dispatch) {
  return function (theme) {
    return dispatch({
      type: THEMES_ACTION.ADD_THEME,
      payload: {
        theme: theme
      }
    });
  };
};
var setThemesChanged = function setThemesChanged(dispatch) {
  return function (val) {
    return dispatch({
      type: THEMES_ACTION.SET_THEMES_CHANGED,
      payload: {
        themesChanged: val
      }
    });
  };
};
var setThemesAdded = function setThemesAdded(dispatch) {
  return function (val) {
    return dispatch({
      type: THEMES_ACTION.SET_THEMES_ADDED,
      payload: {
        themesAdded: val
      }
    });
  };
};
var setThemesDeleted = function setThemesDeleted(dispatch) {
  return function (val) {
    return dispatch({
      type: THEMES_ACTION.SET_THEMES_DELETED,
      payload: {
        themesDeleted: val
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$7 = function setMultiple$7(dispatch) {
  return function (payload) {
    return dispatch({
      type: THEMES_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var themesActions = {
  setInitialThemes: setInitialThemes,
  setThemes: setThemes,
  setKeywords: setKeywords,
  setKeywordsLoading: setKeywordsLoading,
  setKeywordsError: setKeywordsError,
  setThemesLoading: setThemesLoading,
  setThemesError: setThemesError,
  addTheme: addTheme,
  setThemesChanged: setThemesChanged,
  setThemesAdded: setThemesAdded,
  setThemesDeleted: setThemesDeleted,
  setMultiple: setMultiple$7
};
var ThemesContext = /*#__PURE__*/createContext({});
ThemesContext.displayName = 'ThemeContext';
var ThemesContextActions = /*#__PURE__*/createContext({});
ThemesContextActions.displayName = 'ThemeContextActions';
var ThemesContextProvider = function ThemesContextProvider(_ref3) {
  var value = _ref3.value,
    children = _ref3.children;
  var _useReducer3 = useReducer(reducer$7, Object.assign({}, themesInitState, value)),
    _useReducer4 = _slicedToArray(_useReducer3, 2),
    state = _useReducer4[0],
    dispatch = _useReducer4[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: themesActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(ThemesContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(ThemesContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useThemes = function useThemes() {
  var context = useContext(ThemesContext);
  if (!(context != null && context.state)) {
    throw new Error('useThemes must be used within a Provider');
  }
  return context.state;
};
var useThemesActions = function useThemesActions() {
  var context = useContext(ThemesContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useThemesActions must be used within a Provider');
  }
  return context.actions;
};
var setResponses = function setResponses(dispatch) {
  return function (responses) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES,
      payload: {
        responses: responses
      }
    });
  };
};
var setResponsesLoading = function setResponsesLoading(dispatch) {
  return function (loading) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES_LOADING,
      payload: {
        responsesLoading: loading
      }
    });
  };
};
var setResponsesError = function setResponsesError(dispatch) {
  return function (error) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES_ERROR,
      payload: {
        responsesError: error
      }
    });
  };
};
var setResponsesPageSize = function setResponsesPageSize(dispatch) {
  return function (pageSize) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES_PAGE_SIZE,
      payload: {
        responsesPageSize: pageSize
      }
    });
  };
};
var setResponsesPage = function setResponsesPage(dispatch) {
  return function (page) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES_PAGE,
      payload: {
        responsesPage: page
      }
    });
  };
};
var setResponsesCount = function setResponsesCount(dispatch) {
  return function (count) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES_COUNT,
      payload: {
        responsesCount: count
      }
    });
  };
};
var setResponsesTotal = function setResponsesTotal(dispatch) {
  return function (total) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES_TOTAL,
      payload: {
        responsesTotal: total
      }
    });
  };
};
var setResponsesChanged = function setResponsesChanged(dispatch) {
  return function (val) {
    return dispatch({
      type: RESPONSES_ACTION.SET_RESPONSES_CHANGED,
      payload: {
        responsesChanged: val
      }
    });
  };
};
var setShowSA = function setShowSA(dispatch) {
  return function (val) {
    return dispatch({
      type: RESPONSES_ACTION.SET_SHOW_SA,
      payload: {
        showSA: val
      }
    });
  };
};
var setSaStats = function setSaStats(dispatch) {
  return function (saStats) {
    return dispatch({
      type: RESPONSES_ACTION.SET_SA_STATS,
      payload: {
        saStats: saStats
      }
    });
  };
};
var setSignificantChangesToResponses = function setSignificantChangesToResponses(dispatch) {
  return function (val) {
    return dispatch({
      type: RESPONSES_ACTION.SET_SIGNIFICANT_CHANGES_TO_RESPONSES,
      payload: {
        significantChangesResponses: val
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$6 = function setMultiple$6(dispatch) {
  return function (payload) {
    return dispatch({
      type: RESPONSES_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var responsesActions = {
  setResponses: setResponses,
  setResponsesLoading: setResponsesLoading,
  setResponsesError: setResponsesError,
  setResponsesPageSize: setResponsesPageSize,
  setResponsesPage: setResponsesPage,
  setResponsesCount: setResponsesCount,
  setResponsesTotal: setResponsesTotal,
  setResponsesChanged: setResponsesChanged,
  setShowSA: setShowSA,
  setSaStats: setSaStats,
  setSignificantChangesToResponses: setSignificantChangesToResponses,
  setMultiple: setMultiple$6
};
var getActionTypeKey$5 = function getActionTypeKey$5(actionType) {
  switch (actionType) {
    case RESPONSES_ACTION.SET_RESPONSES:
      {
        return 'responses';
      }
    case RESPONSES_ACTION.SET_RESPONSES_LOADING:
      {
        return 'responsesLoading';
      }
    case RESPONSES_ACTION.SET_RESPONSES_ERROR:
      {
        return 'responsesError';
      }
    case RESPONSES_ACTION.SET_RESPONSES_PAGE_SIZE:
      {
        return 'responsesPageSize';
      }
    case RESPONSES_ACTION.SET_RESPONSES_PAGE:
      {
        return 'responsesPage';
      }
    case RESPONSES_ACTION.SET_RESPONSES_COUNT:
      {
        return 'responsesCount';
      }
    case RESPONSES_ACTION.SET_RESPONSES_TOTAL:
      {
        return 'responsesTotal';
      }
    case RESPONSES_ACTION.SET_RESPONSES_CHANGED:
      {
        return 'responsesChanged';
      }
    case RESPONSES_ACTION.SET_SIGNIFICANT_CHANGES_TO_RESPONSES:
      {
        return 'significantChangesResponses';
      }
    case RESPONSES_ACTION.SET_SHOW_SA:
      {
        return 'showSA';
      }
    case RESPONSES_ACTION.SET_SA_STATS:
      {
        return 'saStats';
      }
    case RESPONSES_ACTION.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
var reducer$6 = function reducer$6(state, action) {
  var type = action.type,
    payload = action.payload;
  var k = getActionTypeKey$5(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign({}, state, payload);
      }
    case '':
      {
        throw new Error("Unknown action: ".concat(type));
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign({}, state, _defineProperty({}, k, getPropertyFromPayload(k, payload)));
      }
  }
};
var ResponsesContext = /*#__PURE__*/createContext({});
ResponsesContext.displayName = 'ResponsesContext';
var ResponsesContextActions = /*#__PURE__*/createContext({});
ResponsesContext.displayName = 'ResponsesContextActions';
var ResponsesContextProvider = function ResponsesContextProvider(_ref4) {
  var value = _ref4.value,
    children = _ref4.children;
  var _useReducer5 = useReducer(reducer$6, Object.assign({}, responsesInitState, value)),
    _useReducer6 = _slicedToArray(_useReducer5, 2),
    state = _useReducer6[0],
    dispatch = _useReducer6[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: responsesActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(ResponsesContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(ResponsesContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useResponses = function useResponses() {
  var context = useContext(ResponsesContext);
  if (!(context != null && context.state)) {
    throw new Error('useResponses must be used within a Provider');
  }
  return context.state;
};
var useResponsesActions = function useResponsesActions() {
  var context = useContext(ResponsesContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useResponsesActions must be used within a Provider');
  }
  return context.actions;
};
var getActionTypeKey$4 = function getActionTypeKey$4(actionType) {
  switch (actionType) {
    case STIMULI_ACTION.SET_STIMULI:
      {
        return 'stimuli';
      }
    case STIMULI_ACTION.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
var reducer$5 = function reducer$5(state, action) {
  var type = action.type,
    payload = action.payload;
  var k = getActionTypeKey$4(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign({}, state, payload);
      }
    case '':
      {
        throw new Error("Unknown action: ".concat(type));
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign({}, state, _defineProperty({}, k, getPropertyFromPayload(k, payload)));
      }
  }
};
var setStimuli = function setStimuli(dispatch) {
  return function (stimuli) {
    return dispatch({
      type: STIMULI_ACTION.SET_STIMULI,
      payload: {
        stimuli: stimuli
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$5 = function setMultiple$5(dispatch) {
  return function (payload) {
    return dispatch({
      type: STIMULI_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var stimuliActions = {
  setStimuli: setStimuli,
  setMultiple: setMultiple$5
};
var StimuliContext = /*#__PURE__*/createContext({});
StimuliContext.displayName = 'StimuliContext';
var StimuliContextActions = /*#__PURE__*/createContext({});
StimuliContextActions.displayName = 'StimuliContextActions';
var StimuliContextProvider = function StimuliContextProvider(_ref5) {
  var value = _ref5.value,
    children = _ref5.children;
  var _useReducer7 = useReducer(reducer$5, Object.assign({}, stimuliInitState, value)),
    _useReducer8 = _slicedToArray(_useReducer7, 2),
    state = _useReducer8[0],
    dispatch = _useReducer8[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: stimuliActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(StimuliContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(StimuliContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useStimuli = function useStimuli() {
  var context = useContext(StimuliContext);
  if (!(context != null && context.state)) {
    throw new Error('useStimuli must be used within a Provider');
  }
  return context.state;
};
var getActionTypeKey$3 = function getActionTypeKey$3(actionType) {
  switch (actionType) {
    case FILTERS_ACTION.SET_SEARCH:
      {
        return 'searchInput';
      }
    case FILTERS_ACTION.SET_SORT_BY:
      {
        return 'sortValue';
      }
    case FILTERS_ACTION.SET_DISABLED:
      {
        return 'filterDisabled';
      }
    case FILTERS_ACTION.SET_SELECTED_THEMES:
      {
        return 'selectedThemes';
      }
    case FILTERS_ACTION.SET_SELECTED_STIMULI:
      {
        return 'selectedStimuli';
      }
    case FILTERS_ACTION.SET_SELECTED_SENTIMENT:
      {
        return 'selectedSentiment';
      }
    case FILTERS_ACTION.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
var reducer$4 = function reducer$4(state, action) {
  var type = action.type,
    payload = action.payload;
  var k = getActionTypeKey$3(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign({}, state, payload);
      }
    case '':
      {
        throw new Error("Unknown action: ".concat(type));
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign({}, state, _defineProperty({}, k, getPropertyFromPayload(k, payload)));
      }
  }
};
var setSearch = function setSearch(dispatch) {
  return function (search) {
    return dispatch({
      type: FILTERS_ACTION.SET_SEARCH,
      payload: {
        searchInput: search
      }
    });
  };
};
var setSortBy = function setSortBy(dispatch) {
  return function (sort) {
    return dispatch({
      type: FILTERS_ACTION.SET_SORT_BY,
      payload: {
        sortValue: sort
      }
    });
  };
};
var setFilterDisabled = function setFilterDisabled(dispatch) {
  return function (disabled) {
    return dispatch({
      type: FILTERS_ACTION.SET_DISABLED,
      payload: {
        filterDisabled: disabled
      }
    });
  };
};
var setSelectedThemes = function setSelectedThemes(dispatch) {
  return function (selected) {
    return dispatch({
      type: FILTERS_ACTION.SET_SELECTED_THEMES,
      payload: {
        selectedThemes: selected
      }
    });
  };
};
var setSelectedStimuli = function setSelectedStimuli(dispatch) {
  return function (selected) {
    return dispatch({
      type: FILTERS_ACTION.SET_SELECTED_STIMULI,
      payload: {
        selectedStimuli: selected
      }
    });
  };
};
var setSelectedSentiment = function setSelectedSentiment(dispatch) {
  return function (selected) {
    return dispatch({
      type: FILTERS_ACTION.SET_SELECTED_SENTIMENT,
      payload: {
        selectedSentiment: selected
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$4 = function setMultiple$4(dispatch) {
  return function (payload) {
    return dispatch({
      type: FILTERS_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var filtersActions = {
  setSearch: setSearch,
  setSortBy: setSortBy,
  setFilterDisabled: setFilterDisabled,
  setSelectedThemes: setSelectedThemes,
  setSelectedStimuli: setSelectedStimuli,
  setMultiple: setMultiple$4,
  setSelectedSentiment: setSelectedSentiment
};
var FiltersContext = /*#__PURE__*/createContext({});
FiltersContext.displayName = 'FiltersContext';
var FiltersContextActions = /*#__PURE__*/createContext({});
FiltersContextActions.displayName = 'FiltersContextActions';
var FiltersContextProvider = function FiltersContextProvider(_ref6) {
  var value = _ref6.value,
    children = _ref6.children;
  var _useReducer9 = useReducer(reducer$4, Object.assign({}, filtersInitState, value)),
    _useReducer10 = _slicedToArray(_useReducer9, 2),
    state = _useReducer10[0],
    dispatch = _useReducer10[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: filtersActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(FiltersContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(FiltersContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useFilters = function useFilters() {
  var context = useContext(FiltersContext);
  if (!(context != null && context.state)) {
    throw new Error('useFilters must be used within a Provider');
  }
  return context.state;
};
var useFiltersActions = function useFiltersActions() {
  var context = useContext(FiltersContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useFiltersActions must be used within a Provider');
  }
  return context.actions;
};
var getActionTypeKey$2 = function getActionTypeKey$2(actionType) {
  switch (actionType) {
    case TRAINING_ACTION.SET_TRAINING_STATUS:
      {
        return 'trainingStep';
      }
    case TRAINING_ACTION.SET_UNSAVED_KEYWORDS:
      {
        return 'unsavedKeywords';
      }
    case TRAINING_ACTION.SET_GENERATED_KEYWORDS:
      {
        return 'generatedKeywords';
      }
    case TRAINING_ACTION.SET_SHOW_TRAINING_SCREEN:
      {
        return 'showTrainingScreen';
      }
    case TRAINING_ACTION.SET_SUMMARY_COUNTS:
      {
        return 'summaryCounts';
      }
    case TRAINING_ACTION.SET_TRAINING_COMPLETE:
      {
        return 'trainingComplete';
      }
    case TRAINING_ACTION.SET_TRAINING_ERROR:
      {
        return 'trainingError';
      }
    case TRAINING_ACTION.SET_SHOULD_REFETCH_ON_OPEN:
      {
        return 'shouldRefetchOnOpen';
      }
    case TRAINING_ACTION.SET_SHOW_TRAINING_ERROR_TOAST:
      {
        return 'showTrainingErrorToast';
      }
    case TRAINING_ACTION.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
var reducer$3 = function reducer$3(state, action) {
  var type = action.type,
    payload = action.payload;
  var k = getActionTypeKey$2(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign({}, state, payload);
      }
    case '':
      {
        throw new Error("Unknown action: ".concat(type));
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign({}, state, _defineProperty({}, k, getPropertyFromPayload(k, payload)));
      }
  }
};
var setTrainingStep = function setTrainingStep(dispatch) {
  return function (step) {
    return dispatch({
      type: TRAINING_ACTION.SET_TRAINING_STATUS,
      payload: {
        trainingStep: step
      }
    });
  };
};
var setTrainingError = function setTrainingError(dispatch) {
  return function (error) {
    return dispatch({
      type: TRAINING_ACTION.SET_TRAINING_ERROR,
      payload: {
        trainingError: error
      }
    });
  };
};
var setTrainingComplete = function setTrainingComplete(dispatch) {
  return function (complete) {
    return dispatch({
      type: TRAINING_ACTION.SET_TRAINING_COMPLETE,
      payload: {
        trainingComplete: complete
      }
    });
  };
};
var setShowTrainingScreen = function setShowTrainingScreen(dispatch) {
  return function (show) {
    return dispatch({
      type: TRAINING_ACTION.SET_SHOW_TRAINING_SCREEN,
      payload: {
        showTrainingScreen: show
      }
    });
  };
};
var setUnsavedKeywords = function setUnsavedKeywords(dispatch) {
  return function (keywords) {
    return dispatch({
      type: TRAINING_ACTION.SET_UNSAVED_KEYWORDS,
      payload: {
        unsavedKeywords: keywords
      }
    });
  };
};
var setGeneratedKeywords = function setGeneratedKeywords(dispatch) {
  return function (keywords) {
    return dispatch({
      type: TRAINING_ACTION.SET_GENERATED_KEYWORDS,
      payload: {
        generatedKeywords: keywords
      }
    });
  };
};
var setSummaryCounts = function setSummaryCounts(dispatch) {
  return function (counts) {
    return dispatch({
      type: TRAINING_ACTION.SET_SUMMARY_COUNTS,
      payload: {
        summaryCounts: counts
      }
    });
  };
};
var setShouldRefetchOnOpen = function setShouldRefetchOnOpen(dispatch) {
  return function (val) {
    return dispatch({
      type: TRAINING_ACTION.SET_SHOULD_REFETCH_ON_OPEN,
      payload: {
        shouldRefetchOnOpen: val
      }
    });
  };
};
var setShowTrainingErrorToast = function setShowTrainingErrorToast(dispatch) {
  return function (val) {
    return dispatch({
      type: TRAINING_ACTION.SET_SHOW_TRAINING_ERROR_TOAST,
      payload: {
        showTrainingErrorToast: val
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$3 = function setMultiple$3(dispatch) {
  return function (payload) {
    return dispatch({
      type: TRAINING_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var trainingActions = {
  setTrainingStep: setTrainingStep,
  setTrainingError: setTrainingError,
  setTrainingComplete: setTrainingComplete,
  setShowTrainingScreen: setShowTrainingScreen,
  setUnsavedKeywords: setUnsavedKeywords,
  setGeneratedKeywords: setGeneratedKeywords,
  setSummaryCounts: setSummaryCounts,
  setShouldRefetchOnOpen: setShouldRefetchOnOpen,
  setShowTrainingErrorToast: setShowTrainingErrorToast,
  setMultiple: setMultiple$3
};
var TrainingContext = /*#__PURE__*/createContext({});
TrainingContext.displayName = 'TrainingContext';
var TrainingContextActions = /*#__PURE__*/createContext({});
TrainingContextActions.displayName = 'TrainingContextActions';
var TrainingContextProvider = function TrainingContextProvider(_ref7) {
  var value = _ref7.value,
    children = _ref7.children;
  var _useReducer11 = useReducer(reducer$3, Object.assign({}, trainingInitState, value)),
    _useReducer12 = _slicedToArray(_useReducer11, 2),
    state = _useReducer12[0],
    dispatch = _useReducer12[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: trainingActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(TrainingContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(TrainingContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useTraining = function useTraining() {
  var context = useContext(TrainingContext);
  if (!(context != null && context.state)) {
    throw new Error('useTraining must be used within a Provider');
  }
  return context.state;
};
var useTrainingActions = function useTrainingActions() {
  var context = useContext(TrainingContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useTrainingActions must be used within a Provider');
  }
  return context.actions;
};
var getActionTypeKey$1 = function getActionTypeKey$1(actionType) {
  switch (actionType) {
    case RETRAINING_ACTION.SET_TRAINING_STATUS:
      {
        return 'trainingStatus';
      }
    case RETRAINING_ACTION.SET_NOT_ENOUGH_THEMES_CREATED:
      {
        return 'notEnoughThemesCreated';
      }
    case RETRAINING_ACTION.SET_NOT_ENOUGH_RESPONSES_TAGGED:
      {
        return 'notEnoughResponsesTagged';
      }
    case RETRAINING_ACTION.SET_APPLY_THEME_TO_MORE_RESPONSES:
      {
        return 'applyThemeToMoreResponses';
      }
    case RETRAINING_ACTION.SET_NOT_ENOUGH_THEMES_CREATED_STEP:
      {
        return 'notEnoughThemesCreatedStep';
      }
    case RETRAINING_ACTION.SET_NOT_ENOUGH_RESPONSES_TAGGED_STEP:
      {
        return 'notEnoughResponsesTaggedStep';
      }
    case RETRAINING_ACTION.SET_APPLY_THEME_TO_MORE_RESPONSES_STEP:
      {
        return 'applyThemeToMoreResponsesStep';
      }
    case RETRAINING_ACTION.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
var reducer$2 = function reducer$2(state, action) {
  var type = action.type,
    payload = action.payload;
  var k = getActionTypeKey$1(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign({}, state, payload);
      }
    case '':
      {
        throw new Error("Unknown action: ".concat(type));
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign({}, state, _defineProperty({}, k, getPropertyFromPayload(k, payload)));
      }
  }
};
var setTrainingStatus = function setTrainingStatus(dispatch) {
  return function (status) {
    return dispatch({
      type: RETRAINING_ACTION.SET_TRAINING_STATUS,
      payload: {
        trainingStatus: status
      }
    });
  };
};
var setNotEnoughThemesCreated = function setNotEnoughThemesCreated(dispatch) {
  return function (val) {
    return dispatch({
      type: RETRAINING_ACTION.SET_NOT_ENOUGH_THEMES_CREATED,
      payload: {
        notEnoughThemesCreated: val
      }
    });
  };
};
var setNotEnoughResponsesTagged = function setNotEnoughResponsesTagged(dispatch) {
  return function (val) {
    return dispatch({
      type: RETRAINING_ACTION.SET_NOT_ENOUGH_RESPONSES_TAGGED,
      payload: {
        notEnoughResponsesTagged: val
      }
    });
  };
};
var setApplyThemeToMoreResponses = function setApplyThemeToMoreResponses(dispatch) {
  return function (val) {
    return dispatch({
      type: RETRAINING_ACTION.SET_APPLY_THEME_TO_MORE_RESPONSES,
      payload: {
        applyThemeToMoreResponses: val
      }
    });
  };
};
var setNotEnoughThemesCreatedStep = function setNotEnoughThemesCreatedStep(dispatch) {
  return function (val) {
    return dispatch({
      type: RETRAINING_ACTION.SET_NOT_ENOUGH_THEMES_CREATED_STEP,
      payload: {
        notEnoughThemesCreatedStep: val
      }
    });
  };
};
var setNotEnoughResponsesTaggedStep = function setNotEnoughResponsesTaggedStep(dispatch) {
  return function (val) {
    return dispatch({
      type: RETRAINING_ACTION.SET_NOT_ENOUGH_RESPONSES_TAGGED_STEP,
      payload: {
        notEnoughResponsesTaggedStep: val
      }
    });
  };
};
var setApplyThemeToMoreResponsesStep = function setApplyThemeToMoreResponsesStep(dispatch) {
  return function (val) {
    return dispatch({
      type: RETRAINING_ACTION.SET_APPLY_THEME_TO_MORE_RESPONSES_STEP,
      payload: {
        applyThemeToMoreResponsesStep: val
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$2 = function setMultiple$2(dispatch) {
  return function (payload) {
    return dispatch({
      type: RETRAINING_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var retrainingActions = {
  setTrainingStatus: setTrainingStatus,
  setNotEnoughThemesCreated: setNotEnoughThemesCreated,
  setNotEnoughResponsesTagged: setNotEnoughResponsesTagged,
  setApplyThemeToMoreResponses: setApplyThemeToMoreResponses,
  setNotEnoughThemesCreatedStep: setNotEnoughThemesCreatedStep,
  setNotEnoughResponsesTaggedStep: setNotEnoughResponsesTaggedStep,
  setApplyThemeToMoreResponsesStep: setApplyThemeToMoreResponsesStep,
  setMultiple: setMultiple$2
};
var RetrainingContext = /*#__PURE__*/createContext({});
RetrainingContext.displayName = 'RetrainingContext';
var RetrainingContextActions = /*#__PURE__*/createContext({});
RetrainingContextActions.displayName = 'RetrainingContextActions';
var RetrainingContextProvider = function RetrainingContextProvider(_ref8) {
  var value = _ref8.value,
    children = _ref8.children;
  var _useReducer13 = useReducer(reducer$2, Object.assign({}, retrainingInitState, value)),
    _useReducer14 = _slicedToArray(_useReducer13, 2),
    state = _useReducer14[0],
    dispatch = _useReducer14[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: retrainingActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(RetrainingContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(RetrainingContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useRetraining = function useRetraining() {
  var context = useContext(RetrainingContext);
  if (!(context != null && context.state)) {
    throw new Error('useRetraining must be used within a Provider');
  }
  return context.state;
};
var useRetrainingActions = function useRetrainingActions() {
  var context = useContext(RetrainingContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useRetrainingActions must be used within a Provider');
  }
  return context.actions;
};
var getActionTypeKey = function getActionTypeKey(actionType) {
  switch (actionType) {
    case FEEDBACK_ACTION.SET_AUTOTAGGING_PREDICTION_ID:
      {
        return 'autotaggingPredictionId';
      }
    case FEEDBACK_ACTION.SET_KEYWORD_PREDICTION_ID:
      {
        return 'keywordPredictionId';
      }
    case FEEDBACK_ACTION.SET_JOB_ID:
      {
        return 'jobId';
      }
    case FEEDBACK_ACTION.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
var reducer$1 = function reducer$1(state, action) {
  var type = action.type,
    payload = action.payload;
  var k = getActionTypeKey(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign({}, state, payload);
      }
    case '':
      {
        throw new Error("Unknown action: ".concat(type));
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign({}, state, _defineProperty({}, k, getPropertyFromPayload(k, payload)));
      }
  }
};
var setAutotaggingPredictionId = function setAutotaggingPredictionId(dispatch) {
  return function (predictionId) {
    return dispatch({
      type: FEEDBACK_ACTION.SET_AUTOTAGGING_PREDICTION_ID,
      payload: {
        autotaggingPredictionId: predictionId
      }
    });
  };
};
var setKeywordPredictionId = function setKeywordPredictionId(dispatch) {
  return function (predictionId) {
    return dispatch({
      type: FEEDBACK_ACTION.SET_KEYWORD_PREDICTION_ID,
      payload: {
        keywordPredictionId: predictionId
      }
    });
  };
};
var setJobId = function setJobId(dispatch) {
  return function (jobId) {
    return dispatch({
      type: FEEDBACK_ACTION.SET_JOB_ID,
      payload: {
        jobId: jobId
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple$1 = function setMultiple$1(dispatch) {
  return function (payload) {
    return dispatch({
      type: FEEDBACK_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var feedbackActions = {
  setAutotaggingPredictionId: setAutotaggingPredictionId,
  setKeywordPredictionId: setKeywordPredictionId,
  setJobId: setJobId,
  setMultiple: setMultiple$1
};
var FeedbackContext = /*#__PURE__*/createContext({});
FeedbackContext.displayName = 'FeedbackContext';
var FeedbackContextActions = /*#__PURE__*/createContext({});
FeedbackContextActions.displayName = 'FeedbackContextActions';
var FeedbackContextProvider = function FeedbackContextProvider(_ref9) {
  var value = _ref9.value,
    children = _ref9.children;
  var _useReducer15 = useReducer(reducer$1, Object.assign({}, feedbackInitState, value)),
    _useReducer16 = _slicedToArray(_useReducer15, 2),
    state = _useReducer16[0],
    dispatch = _useReducer16[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: feedbackActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(FeedbackContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(FeedbackContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useFeedback = function useFeedback() {
  var context = useContext(FeedbackContext);
  if (!(context != null && context.state)) {
    throw new Error('useFeedback must be used within a Provider');
  }
  return context.state;
};
var useFeedbackActions = function useFeedbackActions() {
  var context = useContext(FeedbackContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useFeedbackActions must be used within a Provider');
  }
  return context.actions;
};
var reducer = function reducer(state, action) {
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case THEMES_REUSE_ACTION.SET_SUGGESTED_THEMES:
      {
        if (!('suggestedThemes' in payload && payload.suggestedThemes !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          suggestedThemes: Object.assign({}, state.suggestedThemes, payload.suggestedThemes)
        });
      }
    case THEMES_REUSE_ACTION.SET_SUGGESTED_THEMES_FOR_RESPONSE:
      {
        if (!('suggested' in payload && payload.suggested !== undefined) && !('responseTextId' in payload && payload.responseTextId !== undefined)) {
          break;
        }

        // update themes for this response
        var newSuggestedThemes = Object.assign({}, state.suggestedThemes);
        newSuggestedThemes[payload.responseTextId] = payload.suggested;
        return Object.assign({}, state, {
          suggestedThemes: newSuggestedThemes
        });
      }
    case THEMES_REUSE_ACTION.SET_PREVIOUSLY_USED_THEMES:
      {
        if (!('previouslyUsedThemes' in payload && payload.previouslyUsedThemes !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          previouslyUsedThemes: payload.previouslyUsedThemes
        });
      }
    case THEMES_REUSE_ACTION.SET_USE_CASES:
      {
        if (!('useCases' in payload && payload.useCases !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          useCases: payload.useCases
        });
      }
    case THEMES_REUSE_ACTION.SET_SELECTED_USE_CASE:
      {
        if (!('selectedUseCase' in payload && payload.selectedUseCase !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          selectedUseCase: payload.selectedUseCase
        });
      }
    case THEMES_REUSE_ACTION.SET_SELECTED_REUSED_THEMES:
      {
        if (!('selectedReusedThemes' in payload && payload.selectedReusedThemes !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          selectedReusedThemes: payload.selectedReusedThemes
        });
      }
    case THEMES_REUSE_ACTION.ADD_REUSED_THEME:
      {
        if (!('reusedTheme' in payload && payload.reusedTheme !== undefined)) {
          break;
        }
        return Object.assign({}, state, !state.selectedReusedThemes.includes(payload.reusedTheme) && {
          selectedReusedThemes: [].concat(_toConsumableArray(state.selectedReusedThemes), [payload.reusedTheme])
        });
      }
    case THEMES_REUSE_ACTION.REMOVE_REUSED_THEME:
      {
        if (!('reusedTheme' in payload && payload.reusedTheme !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          selectedReusedThemes: state.selectedReusedThemes.filter(function (s) {
            return s !== payload.reusedTheme;
          })
        });
      }
    case THEMES_REUSE_ACTION.ADD_PREVIOUSLY_USED_THEME:
      {
        if (!('previouslyUsedTheme' in payload && payload.previouslyUsedTheme !== undefined)) {
          break;
        }
        return Object.assign({}, state, !state.previouslyUsedThemes.includes(payload.previouslyUsedTheme) && {
          previouslyUsedThemes: [payload.previouslyUsedTheme].concat(_toConsumableArray(state.previouslyUsedThemes))
        });
      }
    case THEMES_REUSE_ACTION.REMOVE_PREVIOUSLY_USED_THEME:
      {
        if (!('previouslyUsedTheme' in payload && payload.previouslyUsedTheme !== undefined)) {
          break;
        }
        return Object.assign({}, state, {
          previouslyUsedThemes: state.previouslyUsedThemes.filter(function (s) {
            return s !== payload.previouslyUsedTheme;
          })
        });
      }
    // sometimes we need to update multiple state values at once
    case THEMES_REUSE_ACTION.SET_MULTIPLE:
      {
        return Object.assign({}, state, payload);
      }
  }
  throw new Error("Unknown action: ".concat(type));
};
var setSuggestedThemes = function setSuggestedThemes(dispatch) {
  return function (themes) {
    return dispatch({
      type: THEMES_REUSE_ACTION.SET_SUGGESTED_THEMES,
      payload: {
        suggestedThemes: themes
      }
    });
  };
};
var setSuggestedThemesForResponse = function setSuggestedThemesForResponse(dispatch) {
  return function (suggested, responseTextId) {
    return dispatch({
      type: THEMES_REUSE_ACTION.SET_SUGGESTED_THEMES_FOR_RESPONSE,
      payload: {
        suggested: suggested,
        responseTextId: responseTextId
      }
    });
  };
};
var setUseCases = function setUseCases(dispatch) {
  return function (useCases) {
    return dispatch({
      type: THEMES_REUSE_ACTION.SET_USE_CASES,
      payload: {
        useCases: useCases
      }
    });
  };
};
var setPreviouslyUsedThemes = function setPreviouslyUsedThemes(dispatch) {
  return function (previouslyUsedThemes) {
    return dispatch({
      type: THEMES_REUSE_ACTION.SET_PREVIOUSLY_USED_THEMES,
      payload: {
        previouslyUsedThemes: previouslyUsedThemes
      }
    });
  };
};
var setSelectedUseCase = function setSelectedUseCase(dispatch) {
  return function (selectedUseCase) {
    return dispatch({
      type: THEMES_REUSE_ACTION.SET_SELECTED_USE_CASE,
      payload: {
        selectedUseCase: selectedUseCase
      }
    });
  };
};
var setSelectedReusedThemes = function setSelectedReusedThemes(dispatch) {
  return function (selectedReusedThemes) {
    return dispatch({
      type: THEMES_REUSE_ACTION.SET_SELECTED_REUSED_THEMES,
      payload: {
        selectedReusedThemes: selectedReusedThemes
      }
    });
  };
};
var addReusedTheme = function addReusedTheme(dispatch) {
  return function (reusedTheme) {
    return dispatch({
      type: THEMES_REUSE_ACTION.ADD_REUSED_THEME,
      payload: {
        reusedTheme: reusedTheme
      }
    });
  };
};
var removeReusedTheme = function removeReusedTheme(dispatch) {
  return function (reusedTheme) {
    return dispatch({
      type: THEMES_REUSE_ACTION.REMOVE_REUSED_THEME,
      payload: {
        reusedTheme: reusedTheme
      }
    });
  };
};
var addPreviouslyUsedTheme = function addPreviouslyUsedTheme(dispatch) {
  return function (previouslyUsedTheme) {
    return dispatch({
      type: THEMES_REUSE_ACTION.ADD_PREVIOUSLY_USED_THEME,
      payload: {
        previouslyUsedTheme: previouslyUsedTheme
      }
    });
  };
};
var removePreviouslyUsedTheme = function removePreviouslyUsedTheme(dispatch) {
  return function (previouslyUsedTheme) {
    return dispatch({
      type: THEMES_REUSE_ACTION.REMOVE_PREVIOUSLY_USED_THEME,
      payload: {
        previouslyUsedTheme: previouslyUsedTheme
      }
    });
  };
};

// sometimes we need to update multiple state values at once
var setMultiple = function setMultiple(dispatch) {
  return function (payload) {
    return dispatch({
      type: THEMES_REUSE_ACTION.SET_MULTIPLE,
      payload: payload
    });
  };
};
var themesReuseActions = {
  setSuggestedThemes: setSuggestedThemes,
  setSuggestedThemesForResponse: setSuggestedThemesForResponse,
  setPreviouslyUsedThemes: setPreviouslyUsedThemes,
  setUseCases: setUseCases,
  setSelectedUseCase: setSelectedUseCase,
  setSelectedReusedThemes: setSelectedReusedThemes,
  addReusedTheme: addReusedTheme,
  removeReusedTheme: removeReusedTheme,
  addPreviouslyUsedTheme: addPreviouslyUsedTheme,
  removePreviouslyUsedTheme: removePreviouslyUsedTheme,
  setMultiple: setMultiple
};
var ThemesReuseContext = /*#__PURE__*/createContext({});
ThemesReuseContext.displayName = 'ThemesReuseContext';
var ThemesReuseContextActions = /*#__PURE__*/createContext({});
ThemesReuseContextActions.displayName = 'ThemesReuseContextActions';
var ThemesReuseContextProvider = function ThemesReuseContextProvider(_ref10) {
  var value = _ref10.value,
    children = _ref10.children;
  var _useReducer17 = useReducer(reducer, Object.assign({}, themesReuseInitState, value)),
    _useReducer18 = _slicedToArray(_useReducer17, 2),
    state = _useReducer18[0],
    dispatch = _useReducer18[1];
  var actions = useMemo(function () {
    return wrapActions({
      dispatch: dispatch,
      actions: themesReuseActions
    });
  }, [dispatch]);
  return /*#__PURE__*/jsx(ThemesReuseContext.Provider, {
    value: {
      state: state
    },
    children: /*#__PURE__*/jsx(ThemesReuseContextActions.Provider, {
      value: {
        actions: actions
      },
      children: children
    })
  });
};
var useThemesReuse = function useThemesReuse() {
  var context = useContext(ThemesReuseContext);
  if (!(context != null && context.state)) {
    throw new Error('useThemesReuse must be used within a Provider');
  }
  return context.state;
};
var useThemesReuseActions = function useThemesReuseActions() {
  var context = useContext(ThemesReuseContextActions);
  if (!(context != null && context.actions)) {
    throw new Error('useThemesReuseActions must be used within a Provider');
  }
  return context.actions;
};
var Provider = function Provider(_ref11) {
  var values = _ref11.values,
    children = _ref11.children;
  return /*#__PURE__*/jsx(GeneralContextProvider, {
    value: filterValues(values, generalInitState),
    children: /*#__PURE__*/jsx(ThemesContextProvider, {
      value: filterValues(values, themesInitState),
      children: /*#__PURE__*/jsx(ResponsesContextProvider, {
        value: filterValues(values, responsesInitState),
        children: /*#__PURE__*/jsx(StimuliContextProvider, {
          value: filterValues(values, stimuliInitState),
          children: /*#__PURE__*/jsx(FiltersContextProvider, {
            value: filterValues(values, filtersInitState),
            children: /*#__PURE__*/jsx(FeedbackContextProvider, {
              value: filterValues(values, feedbackInitState),
              children: /*#__PURE__*/jsx(TrainingContextProvider, {
                value: filterValues(values, trainingInitState),
                children: /*#__PURE__*/jsx(RetrainingContextProvider, {
                  value: filterValues(values, retrainingInitState),
                  children: /*#__PURE__*/jsx(ThemesReuseContextProvider, {
                    value: filterValues(values, themesReuseInitState),
                    children: children
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};

// potentially overriding changes.
var OpenEndedCodingContext = /*#__PURE__*/createContext({
  // handlers
  filterResponses: function filterResponses() {},
  setShowOecModal: function setShowOecModal() {},
  setResponsesPage: function setResponsesPage() {},
  deleteThemeHandler: function deleteThemeHandler() {},
  updateThemeHandler: function updateThemeHandler() {},
  createThemeHandler: function createThemeHandler() {},
  reloadResponses: function reloadResponses() {},
  getKeywords: function getKeywords() {},
  handleTrainingFinished: function handleTrainingFinished() {},
  handleRemoveThemesFromResponse: function handleRemoveThemesFromResponse() {},
  handleAddThemesToResponse: function handleAddThemesToResponse() {},
  handleCreateThemeForResponse: function handleCreateThemeForResponse() {},
  setShouldRefetch: function setShouldRefetch() {}
});
OpenEndedCodingContext.displayName = 'OpenEndedCodingContext';
var COPY$B = {
  title: {
    id: 'OpenEndedCoding.FiveHundredError.title',
    defaultMessage: 'It looks like we slipped!',
    description: '[Type: Header][Vis: med] - OEC five hundred title'
  },
  description: {
    id: 'OpenEndedCoding.FiveHundredError.description',
    defaultMessage: 'Sorry about that! Please try refreshing the page. If this keeps happening, the issue may be on our end: <a href="https://surveymonkey.statuspage.io/" target="_blank">check our status page</a> for details.',
    description: '[Type: Header][Vis: med] - OEC five hundred description'
  }
};
var useStyles$o = createUseStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: "".concat(theme.spacing[7], "px ").concat(theme.spacing[3], "px")
    }
  };
});
var FiveHundredError = function FiveHundredError(_ref12) {
  var title = _ref12.title;
  var classes = useStyles$o();
  return /*#__PURE__*/jsxs(Box, {
    className: classes.container,
    children: [/*#__PURE__*/jsx(ErrorCard, {
      iconOnly: true
    }), /*#__PURE__*/jsx(Box, {
      mt: 4,
      children: /*#__PURE__*/jsx(Typography, {
        variant: "sectionTitle",
        align: "center",
        children: title != null ? title : /*#__PURE__*/jsx(T, {
          desc: COPY$B.title
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mt: 5,
      mx: 3,
      children: /*#__PURE__*/jsx(Typography, {
        variant: "body",
        align: "center",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$B.description,
          html: true
        })
      })
    })]
  });
};
var useStyles$n = createUseStyles(function (theme) {
  return {
    button: {
      all: 'unset',
      padding: 0,
      border: 'none',
      backgroundColor: theme.palette.transparent,
      color: theme.palette.link.main,
      fontSize: "".concat(theme.type.fontSize.bodySm, "px"),
      '&:hover, &:focus': {
        cursor: 'pointer'
      }
    }
  };
});
var LinkStyleButton = function LinkStyleButton(_ref13) {
  var children = _ref13.children,
    _ref13$onClick = _ref13.onClick,
    _onClick = _ref13$onClick === void 0 ? function () {
      return null;
    } : _ref13$onClick;
  var classes = useStyles$n();
  return /*#__PURE__*/jsx("button", {
    type: "button",
    className: classes.button,
    onClick: _onClick,
    children: children
  });
};
var getThemesPerResponse$1 = function getThemesPerResponse$1(themes) {
  var responsesWithThemes = {};

  // function to update the responses with the new theme
  var addThemeToResponse = function addThemeToResponse(responseTextId, themeId, tagType) {
    var newTheme = {
      id: themeId,
      tagType: tagType
    };
    if (responseTextId in responsesWithThemes) {
      responsesWithThemes[responseTextId] = [].concat(_toConsumableArray(responsesWithThemes[responseTextId]), [newTheme]);
    } else {
      responsesWithThemes[responseTextId] = [newTheme];
    }
  };
  themes.forEach(function (theme) {
    var _theme$autogeneratedT;
    // add manually generated theme to each response
    theme.responseTextIds.forEach(function (responseTextId) {
      addThemeToResponse(responseTextId, theme.id, OECTagType.OECUSER);
    });

    // add autogenerated themes to each response
    (_theme$autogeneratedT = theme.autogeneratedTag) == null || _theme$autogeneratedT.responseTextIds.forEach(function (responseTextId) {
      var _theme$autogeneratedT2;
      var themeId = (_theme$autogeneratedT2 = theme.autogeneratedTag) == null ? void 0 : _theme$autogeneratedT2.id;
      if (themeId) {
        addThemeToResponse(responseTextId, themeId, OECTagType.OECMODEL);
      }
    });
  });
  return responsesWithThemes;
};
var calculateTrainingCounts = function calculateTrainingCounts(_ref14) {
  var responses = _ref14.responses,
    responsesTotal = _ref14.responsesTotal,
    themesTotal = _ref14.themesTotal;
  var responseTextIds = Object.keys(responses);
  var counts = {
    responseCount: responsesTotal,
    themesCount: themesTotal,
    autoTaggedCount: 0,
    manualTaggedCount: 0,
    untaggedCount: responsesTotal - responseTextIds.length
  };
  responseTextIds.forEach(function (responseTextId) {
    var themes = responses[responseTextId];

    // update manual count
    if (themes.some(function (t) {
      return t.tagType === OECTagType.OECUSER;
    })) {
      counts.manualTaggedCount += 1;
    }

    // update autotagged count
    if (themes.some(function (t) {
      return t.tagType === OECTagType.OECMODEL;
    })) {
      counts.autoTaggedCount += 1;
    }
  });
  return counts;
};
var isRetrainStepHidden = function isRetrainStepHidden(progress) {
  return progress === OECRetrainStepProgress.HIDE_STEP;
};
var isRetrainStepInProgress = function isRetrainStepInProgress(progress) {
  return progress === OECRetrainStepProgress.STEP_IN_PROGRESS;
};
var isRetrainStepComplete = function isRetrainStepComplete(progress) {
  return progress === OECRetrainStepProgress.STEP_COMPLETE;
};

// check if user has completed all required retrain steps
var retrainStepsHaveBeenCompleted = function retrainStepsHaveBeenCompleted(steps) {
  // if all steps are hidden they haven't worked through any steps
  if (steps.every(function (step) {
    return isRetrainStepHidden(step);
  })) {
    return false;
  }

  // ensure there are no remaining in progress steps
  return !steps.some(function (step) {
    return isRetrainStepInProgress(step);
  });
};
var retrainProgressHandler = function retrainProgressHandler(_ref15) {
  var value = _ref15.value,
    progressValue = _ref15.progressValue,
    themesChanged = _ref15.themesChanged,
    responsesChanged = _ref15.responsesChanged,
    setProgressValue = _ref15.setProgressValue;
  // themes are unchanged, so no step in progress
  if (!themesChanged && !responsesChanged) {
    if (!isRetrainStepHidden(progressValue)) {
      setProgressValue(OECRetrainStepProgress.HIDE_STEP);
    }
    return;
  }

  // user has to take some action to move ahead with retraining
  if (value && (isRetrainStepHidden(progressValue) || isRetrainStepComplete(progressValue))) {
    setProgressValue(OECRetrainStepProgress.STEP_IN_PROGRESS);
  }

  // user has completed the action to move ahead with retraining
  if (!value && isRetrainStepInProgress(progressValue)) {
    setProgressValue(OECRetrainStepProgress.STEP_COMPLETE);
  }
};
var updateTheme = function updateTheme(_ref16) {
  var themes = _ref16.themes,
    themeId = _ref16.themeId,
    name = _ref16.name;
  return themes.map(function (theme) {
    if (theme.id === themeId) {
      return Object.assign({}, theme, {
        theme: name
      });
    }
    return theme;
  });
};
var createKeywords = function createKeywords(_ref17) {
  var theme = _ref17.theme;
  return {
    themeId: theme.id,
    keywords: []
  };
};
var hasKeywordsPresent = function hasKeywordsPresent(keywords) {
  return keywords.length > 0 && keywords.some(function (k) {
    return k.keywords.length > 0;
  });
};
var deleteTheme = function deleteTheme(_ref18) {
  var themes = _ref18.themes,
    themeId = _ref18.themeId;
  return themes.filter(function (theme) {
    return theme.id !== themeId;
  });
};
var deleteKeywords = function deleteKeywords(_ref19) {
  var keywords = _ref19.keywords,
    themeId = _ref19.themeId;
  return keywords.filter(function (k) {
    return k.themeId !== themeId;
  });
};
var removeResponseFromTheme = function removeResponseFromTheme(_ref20) {
  var themes = _ref20.themes,
    themeIds = _ref20.themeIds,
    responseTextId = _ref20.responseTextId;
  return themes.map(function (theme) {
    var _theme$autogeneratedT;
    // manually added tag has been removed
    if (themeIds.includes(theme.id)) {
      return Object.assign({}, theme, {
        responseTextIds: theme.responseTextIds.filter(function (r) {
          return r !== responseTextId;
        })
      });
    }

    // autogenerated tag has been removed
    var autogeneratedTagId = (_theme$autogeneratedT = theme.autogeneratedTag) == null ? void 0 : _theme$autogeneratedT.id;
    if (theme.autogeneratedTag && autogeneratedTagId && themeIds.includes(autogeneratedTagId)) {
      var autogeneratedTag = {
        id: autogeneratedTagId,
        responseTextIds: theme.autogeneratedTag.responseTextIds.filter(function (r) {
          return r !== responseTextId;
        })
      };
      return Object.assign({}, theme, {
        autogeneratedTag: autogeneratedTag
      });
    }
    return theme;
  });
};
var addResponseToTheme = function addResponseToTheme(_ref21) {
  var themes = _ref21.themes,
    themeIds = _ref21.themeIds,
    responseTextId = _ref21.responseTextId;
  return themes.map(function (theme) {
    var _theme$autogeneratedT2;
    // manually added tag has been added
    if (themeIds.includes(theme.id)) {
      return Object.assign({}, theme, {
        responseTextIds: [].concat(_toConsumableArray(theme.responseTextIds), [responseTextId])
      });
    }

    // autogenerated tag has been added
    var autogeneratedTagId = (_theme$autogeneratedT2 = theme.autogeneratedTag) == null ? void 0 : _theme$autogeneratedT2.id;
    if (theme.autogeneratedTag && autogeneratedTagId && themeIds.includes(autogeneratedTagId)) {
      var autogeneratedTag = {
        id: autogeneratedTagId,
        responseTextIds: [].concat(_toConsumableArray(theme.autogeneratedTag.responseTextIds), [responseTextId])
      };
      return Object.assign({}, theme, {
        autogeneratedTag: autogeneratedTag
      });
    }
    return theme;
  });
};
var buildThemesForResponse = function buildThemesForResponse(_ref22) {
  var response = _ref22.response,
    themes = _ref22.themes;
  return response.tagIds.reduce(function (result, tagId) {
    var _autogenerated$autoge;
    // manually generated theme
    var theme = themes.find(function (t) {
      return t.id === tagId;
    });
    if (theme) {
      result.push(theme);
    }

    // autogenerated theme
    var autogenerated = themes.find(function (t) {
      var _t$autogeneratedTag;
      return ((_t$autogeneratedTag = t.autogeneratedTag) == null ? void 0 : _t$autogeneratedTag.id) === tagId;
    });
    var autogeneratedTagId = autogenerated == null || (_autogenerated$autoge = autogenerated.autogeneratedTag) == null ? void 0 : _autogenerated$autoge.id;
    if (autogenerated && autogeneratedTagId) {
      result.push(Object.assign({}, autogenerated, {
        tagType: OECTagType.OECMODEL,
        id: autogeneratedTagId
      }));
    }
    return result;
  }, []);
};
var removeThemesFromResponse = function removeThemesFromResponse(_ref23) {
  var responses = _ref23.responses,
    themeId = _ref23.themeId,
    responseTextId = _ref23.responseTextId;
  return responses.map(function (response) {
    // Different response
    if (responseTextId !== response.responseTextId) {
      return response;
    }

    // Filter out the tag that has been deleted
    var newTagIds = response.tagIds.filter(function (t) {
      return t !== themeId;
    });
    return Object.assign({}, response, {
      tagIds: newTagIds
    });
  });
};
var addThemesToResponse = function addThemesToResponse(_ref24) {
  var responses = _ref24.responses,
    themeIds = _ref24.themeIds,
    responseTextId = _ref24.responseTextId;
  return responses.map(function (response) {
    // Different response
    if (responseTextId !== response.responseTextId) {
      return response;
    }

    // Get the new Tag IDs
    var newTagIds = themeIds.filter(function (themeId) {
      return !response.tagIds.includes(themeId);
    });
    return Object.assign({}, response, {
      tagIds: [].concat(_toConsumableArray(response.tagIds), _toConsumableArray(newTagIds))
    });
  });
};
var filterCheckedThemesBySearch = function filterCheckedThemesBySearch(_ref25) {
  var searchPhrase = _ref25.searchPhrase,
    themes = _ref25.themes;
  return themes.map(function (theme) {
    var show = theme.theme.toLowerCase().includes(searchPhrase.toLowerCase());
    return Object.assign({}, theme, {
      show: show
    });
  });
};
var splitBySearchPhrase = function splitBySearchPhrase(_ref26) {
  var searchPhrase = _ref26.searchPhrase,
    text = _ref26.text;
  var re = new RegExp("(".concat(searchPhrase, ")"), 'i');
  var textLower = text.toLowerCase();
  var searchPhraseLower = searchPhrase.toLowerCase();

  // No point searching for empty string
  if (searchPhrase === '') {
    return [text];
  }

  // Return early if it's not a substring
  if (!textLower.includes(searchPhraseLower)) {
    return [text];
  }
  return text.split(re).filter(Boolean);
};
var transformKeywords = function transformKeywords(_ref27) {
  var keywords = _ref27.keywords;
  return keywords.map(function (k) {
    var newKeywords = k.keywords.join(', ');
    return Object.assign({}, k, {
      keywords: newKeywords,
      error: false,
      errorMessages: []
    });
  });
};
var transformBackKeywords = function transformBackKeywords(_ref28) {
  var keywords = _ref28.keywords;
  return keywords.map(function (k) {
    var newKeywords = k.keywords.split(',').map(function (keyword) {
      return keyword.trim();
    });
    return {
      themeId: k.themeId,
      keywords: newKeywords
    };
  });
};
var formatTheme = function formatTheme(theme) {
  return {
    id: theme.id,
    theme: theme.label,
    tagType: theme.tagType,
    responseTextIds: theme.responseTextIds,
    autogeneratedTag: theme.autogeneratedTag ? {
      id: theme.autogeneratedTag.id,
      responseTextIds: theme.autogeneratedTag.responseTextIds
    } : null
  };
};
var getResponseCountForTheme = function getResponseCountForTheme(theme) {
  var _theme$autogeneratedT3, _theme$autogeneratedT4;
  var manuallyTagged = theme.responseTextIds;
  var autotagged = (_theme$autogeneratedT3 = (_theme$autogeneratedT4 = theme.autogeneratedTag) == null ? void 0 : _theme$autogeneratedT4.responseTextIds) != null ? _theme$autogeneratedT3 : [];
  return manuallyTagged.length + autotagged.length;
};
var formatResponse = function formatResponse(_ref29) {
  var id = _ref29.id,
    stimulus = _ref29.stimulus,
    respondentId = _ref29.respondentId,
    questionId = _ref29.questionId,
    optionId = _ref29.optionId,
    content = _ref29.content,
    createdAt = _ref29.createdAt,
    tagIds = _ref29.tagIds,
    sentiment = _ref29.sentiment;
  return {
    responseTextId: id,
    stimulus: stimulus,
    respondentId: respondentId,
    questionId: questionId,
    optionId: optionId,
    content: content,
    date: createdAt,
    tagIds: tagIds,
    sentiment: sentiment,
    suggestedTags: []
  };
};
var formatKeywords = function formatKeywords(keywords) {
  return {
    themeId: keywords.id,
    keywords: keywords.keywords
  };
};
var formatKeywordsForPersistence = function formatKeywordsForPersistence(_ref30) {
  var themes = _ref30.themes,
    keywords = _ref30.keywords;
  return themes.map(function (t) {
    var _keywords$find;
    var k = (_keywords$find = keywords.find(function (kw) {
      return kw.themeId === t.id;
    })) == null ? void 0 : _keywords$find.keywords;
    return {
      id: t.id,
      label: t.theme,
      keywords: k != null ? k : []
    };
  });
};
var validateKeywordsForTheme = function validateKeywordsForTheme(_ref31) {
  var keywords = _ref31.keywords,
    newKeywords = _ref31.newKeywords,
    themeId = _ref31.themeId;
  // this is a new theme
  var keywordsIdx = keywords.findIndex(function (kw) {
    return kw.themeId === themeId;
  });
  if (keywordsIdx === -1) {
    return [].concat(_toConsumableArray(keywords), [{
      themeId: themeId,
      keywords: newKeywords,
      error: false,
      errorMessages: []
    }]);
  }

  // eslint-disable-next-line no-param-reassign
  keywords[keywordsIdx] = {
    themeId: themeId,
    keywords: newKeywords,
    error: false,
    errorMessages: []
  };
  return keywords;
};
var trackAmplitudeEvent = function trackAmplitudeEvent(_ref32) {
  var amplitudeEvent = _ref32.amplitudeEvent,
    _ref32$name = _ref32.name,
    _name = _ref32$name === void 0 ? USER_EVENTS.ELEMENT_INTERACTION : _ref32$name,
    _ref32$data = _ref32.data,
    _data = _ref32$data === void 0 ? {} : _ref32$data;
  var _window;
  if (window.SM && (_window = window) != null && _window.SM.MetricsTracker) {
    var hasSubscribers = !!window.SM.MetricsTracker.getSubscribers().length;
    if (hasSubscribers) {
      window.SM.MetricsTracker.track({
        name: _name,
        data: Object.assign({}, {
          amplitudeEvent: amplitudeEvent
        }, _data)
      });
    }
  }
};
var getResponseThemeIds = function getResponseThemeIds(_ref33) {
  var responses = _ref33.responses,
    responseTextId = _ref33.responseTextId;
  var _responses$find$tagId, _responses$find;
  return (_responses$find$tagId = (_responses$find = responses.find(function (r) {
    return r.responseTextId === responseTextId;
  })) == null ? void 0 : _responses$find.tagIds) != null ? _responses$find$tagId : [];
};
var getPredictedThemes = function getPredictedThemes(_ref34) {
  var themes = _ref34.themes,
    responseThemes = _ref34.responseThemes;
  return themes.filter(function (t) {
    return t.autogeneratedTag && responseThemes.includes(t.autogeneratedTag.id);
  }).map(function (t) {
    return t.theme;
  });
};
var getThemeNames = function getThemeNames(_ref35) {
  var themes = _ref35.themes,
    themeIds = _ref35.themeIds;
  return themes.filter(function (t) {
    return themeIds.includes(t.id) || t.autogeneratedTag && themeIds.includes(t.autogeneratedTag.id);
  }).map(function (t) {
    return t.theme;
  });
};
var getResponseText = function getResponseText(_ref36) {
  var responses = _ref36.responses,
    responseTextId = _ref36.responseTextId;
  var _responses$find$conte, _responses$find2;
  return (_responses$find$conte = (_responses$find2 = responses.find(function (r) {
    return r.responseTextId === responseTextId;
  })) == null ? void 0 : _responses$find2.content) != null ? _responses$find$conte : '';
};
var getCombinedItems = function getCombinedItems(prevItems, newItems) {
  var existingKeysSet = new Set(prevItems.map(function (item) {
    return item.id;
  }));
  return newItems.reduce(function (items, item) {
    if (!existingKeysSet.has(item.id)) {
      items.push(item);
    }
    return items;
  }, prevItems.slice() || []);
};
var getPaginatedResponses = function getPaginatedResponses(_ref37) {
  var responsesPage = _ref37.responsesPage,
    responses = _ref37.responses;
  var firstResponseIndex = responsesPage * RESPONSE_PAGE_SIZE;
  var lastResponseIndex = firstResponseIndex + RESPONSE_PAGE_SIZE;
  return responses.slice(firstResponseIndex, lastResponseIndex);
};
var getThemesPerResponse = function getThemesPerResponse(_ref38) {
  var responses = _ref38.responses;
  return responses.reduce(function (acc, r) {
    return Object.assign({}, acc, _defineProperty({}, r.responseTextId, r.tagIds));
  }, {});
};
var updateResponsesThemes = function updateResponsesThemes(_ref39) {
  var responses = _ref39.responses,
    themesPerResponse = _ref39.themesPerResponse;
  return responses.map(function (response) {
    var tagIds = themesPerResponse[response.id];
    if (tagIds) {
      return Object.assign({}, response, {
        tagIds: tagIds
      });
    }
    return response;
  });
};
var mergePaginatedResponses = function mergePaginatedResponses(_ref40) {
  var prevData = _ref40.prevData,
    newData = _ref40.newData,
    themesPerResponse = _ref40.themesPerResponse;
  // update the cached responses with any tags since modified by the user
  var updatedPrevResponses = updateResponsesThemes({
    responses: prevData == null ? void 0 : prevData.getOecResponses.items,
    themesPerResponse: themesPerResponse
  });

  // combine any new responses fetched with the previously cached responses
  var items = getCombinedItems(updatedPrevResponses, newData == null ? void 0 : newData.getOecResponses.items);

  // merge all new data except for the responses
  var merged = merge({}, prevData, newData);
  return {
    getOecResponses: Object.assign({}, merged.getOecResponses, {
      items: items
    })
  };
};
var isAutoTaggingComplete = function isAutoTaggingComplete(trainingStatus) {
  return [OECTrainingStatus.REQUIRES_RETRAINING, OECTrainingStatus.TRAINING_COMPLETE].includes(trainingStatus);
};
var haveKeywordsChanged = function haveKeywordsChanged(_ref41) {
  var generatedKeywords = _ref41.generatedKeywords,
    unsavedKeywords = _ref41.unsavedKeywords;
  var generated = generatedKeywords.map(function (_ref42) {
    var themeId = _ref42.themeId,
      keywords = _ref42.keywords;
    return {
      id: themeId,
      keywords: keywords
    };
  });
  var unsaved = unsavedKeywords.map(function (_ref43) {
    var themeId = _ref43.themeId,
      keywords = _ref43.keywords;
    return {
      id: themeId,
      keywords: keywords
    };
  });
  return !isEqual(generated, unsaved);
};
var areThemesEqual = function areThemesEqual(_ref44) {
  var prevThemes = _ref44.prevThemes,
    newThemes = _ref44.newThemes;
  return (
    // just using lodash for now; will probably need to add some custom checks in future
    isEqual(prevThemes.map(function (t) {
      return t.id;
    }), newThemes.map(function (t) {
      return t.id;
    }))
  );
};
var areThemesAdded = function areThemesAdded(_ref45) {
  var prevThemes = _ref45.prevThemes,
    newThemes = _ref45.newThemes;
  var prevThemeIds = prevThemes.map(function (t) {
    return t.id;
  });
  var newThemeIds = newThemes.map(function (t) {
    return t.id;
  });
  var difference = newThemeIds.filter(function (t) {
    return !prevThemeIds.includes(t);
  });
  return difference.length > 0;
};
var areThemesDeleted = function areThemesDeleted(_ref46) {
  var prevThemes = _ref46.prevThemes,
    newThemes = _ref46.newThemes;
  var prevThemeIds = prevThemes.map(function (t) {
    return t.id;
  });
  var newThemeIds = newThemes.map(function (t) {
    return t.id;
  });
  var difference = prevThemeIds.filter(function (t) {
    return !newThemeIds.includes(t);
  });
  return difference.length > 0;
};

// helper used for a few different methods
var responsesPerThemeReducer = function responsesPerThemeReducer(_ref47) {
  var themes = _ref47.themes;
  return themes.reduce(function (acc, t) {
    return Object.assign({}, acc, _defineProperty({}, t.id, t.responseTextIds), t.autogeneratedTag && _defineProperty({}, t.autogeneratedTag.id, t.autogeneratedTag.responseTextIds));
  }, {});
};
var areResponsesEqual = function areResponsesEqual(_ref49) {
  var prevThemes = _ref49.prevThemes,
    newThemes = _ref49.newThemes;
  return isEqual(responsesPerThemeReducer({
    themes: prevThemes
  }), responsesPerThemeReducer({
    themes: newThemes
  }));
};
var significantChangeCountResponses = function significantChangeCountResponses(_ref50) {
  var prevThemes = _ref50.prevThemes,
    newThemes = _ref50.newThemes;
  var prevResponsesPerTheme = responsesPerThemeReducer({
    themes: prevThemes
  });
  var newResponsesPerTheme = responsesPerThemeReducer({
    themes: newThemes
  });
  return Object.keys(prevResponsesPerTheme).reduce(function (acc, themeId) {
    var prevResponses = prevResponsesPerTheme[themeId];
    var newResponses = newResponsesPerTheme[themeId];
    if (!prevResponses || !newResponses) {
      return acc;
    }

    // get the symmetric difference in themes per response and add the count to the running total
    return acc + prevResponses.filter(function (x) {
      return !newResponses.includes(x);
    }).concat(newResponses.filter(function (x) {
      return !prevResponses.includes(x);
    })).length;
  }, 0);
};

// TODO: This function is getting quite complicated.
// At a later date we might try and rearchitect more of this
// logic and move to the backend.
var isRetrainAllowed = function isRetrainAllowed(_ref51) {
  var trainingStatus = _ref51.trainingStatus,
    themesAdded = _ref51.themesAdded,
    themesDeleted = _ref51.themesDeleted,
    significantChangesResponses = _ref51.significantChangesResponses,
    notEnoughThemesCreated = _ref51.notEnoughThemesCreated,
    notEnoughResponsesTagged = _ref51.notEnoughResponsesTagged,
    applyThemeToMoreResponses = _ref51.applyThemeToMoreResponses,
    notEnoughThemesCreatedStep = _ref51.notEnoughThemesCreatedStep,
    notEnoughResponsesTaggedStep = _ref51.notEnoughResponsesTaggedStep,
    applyThemeToMoreResponsesStep = _ref51.applyThemeToMoreResponsesStep;
  // checks required to be completed before a user can retrain
  if (notEnoughThemesCreated || notEnoughResponsesTagged || applyThemeToMoreResponses) {
    return false;
  }

  // user is in a retrain state (trust the backend)
  if (trainingStatus === OECTrainingStatus.REQUIRES_RETRAINING) {
    return true;
  }

  // the user has completed autotagging steps and can continue with retraining
  if (retrainStepsHaveBeenCompleted([notEnoughThemesCreatedStep, notEnoughResponsesTaggedStep, applyThemeToMoreResponsesStep])) {
    return true;
  }

  // themes added or deleted and checks pass
  if (themesAdded || themesDeleted) {
    return true;
  }

  // significant changes to responses and checks pass
  if (significantChangesResponses > SIGNIFICANT_CHANGES_FOR_RETRAIN) {
    return true;
  }
  return false;
};
var hasInsufficientResponses = function hasInsufficientResponses(themes, responsesTotal) {
  if (themes.length === 0) {
    return true;
  }

  // number of responses that need to be tagged
  var amountToTag = Math.ceil(responsesTotal * (PERCENT_TO_TAG / 100.0));

  // get number of responses that have a tag applied
  var responsesIdsTagged = Array.from(new Set(themes.flatMap(function (t) {
    var _t$autogeneratedTag$r, _t$autogeneratedTag2;
    return [].concat(_toConsumableArray(t.responseTextIds), _toConsumableArray((_t$autogeneratedTag$r = (_t$autogeneratedTag2 = t.autogeneratedTag) == null ? void 0 : _t$autogeneratedTag2.responseTextIds) != null ? _t$autogeneratedTag$r : []));
  })));
  return responsesIdsTagged.length < amountToTag;
};
var hasInsufficientThemes = function hasInsufficientThemes(themes) {
  if (themes.length === 0) {
    return true;
  }
  return themes.filter(function (t) {
    var _t$autogeneratedTag3;
    var manuallyAdded = t.responseTextIds.length;
    var autogenerated = (_t$autogeneratedTag3 = t.autogeneratedTag) == null ? void 0 : _t$autogeneratedTag3.responseTextIds.length;
    return manuallyAdded + (autogenerated != null ? autogenerated : 0) < NUMBER_OF_RESPONSES;
  }).length > 0;
};
var getStatus$1 = function getStatus$1(_ref52) {
  var responsesTotal = _ref52.responsesTotal,
    themes = _ref52.themes;
  var autoTaggingStatus = {
    // there must be at least 2 themes added
    notEnoughThemesCreated: themes.length < MIN_NUMBER_OF_THEMES,
    // a mininum number of responses need to have themes added
    notEnoughResponsesTagged: hasInsufficientResponses(themes, responsesTotal),
    // each theme must be applied to a mininum number of responses
    applyThemeToMoreResponses: hasInsufficientThemes(themes)
  };
  return autoTaggingStatus;
};
var getRetrainData = function getRetrainData(_ref53) {
  var prevThemes = _ref53.prevThemes,
    newThemes = _ref53.newThemes;
  return {
    themesChanged: !areThemesEqual({
      prevThemes: prevThemes,
      newThemes: newThemes
    }),
    responsesChanged: !areResponsesEqual({
      prevThemes: prevThemes,
      newThemes: newThemes
    }),
    themesAdded: areThemesAdded({
      prevThemes: prevThemes,
      newThemes: newThemes
    }),
    themesDeleted: areThemesDeleted({
      prevThemes: prevThemes,
      newThemes: newThemes
    }),
    significantChangesResponses: significantChangeCountResponses({
      prevThemes: prevThemes,
      newThemes: newThemes
    })
  };
};
var THEME_MIN_LENGTH = 3;
var THEME_MAX_LENGTH = 25;
var KW_MAX_LENGTH = 128;
var INVALID_KEYWORDS = ['', ',', ' '];
var COPY$A = {
  malformed: {
    id: 'OpenEndedCoding.errors.malformed',
    defaultMessage: 'You can only use letters and numbers in a theme name.',
    description: '[Type: Label][Vis: med] - OEC malformed input error message'
  },
  duplicates: {
    id: 'OpenEndedCoding.errors.duplicates',
    defaultMessage: '{ themeName } already exists.',
    description: '[Type: Label][Vis: med] - OEC duplicate themes error message'
  },
  length: {
    id: 'OpenEndedCoding.errors.length',
    defaultMessage: 'Please create a theme name that is between { minLength } and { maxLength } characters.',
    description: '[Type: Label][Vis: med] - OEC theme name length error message'
  },
  keywordsHasInvalid: {
    id: 'OpenEndedCoding.errors.keywordsHasInvalid',
    defaultMessage: 'You can only use letters and numbers in a keyword.',
    description: '[Type: Label][Vis: med] - OEC malformed input error message'
  },
  keywordsHasDuplicates: {
    id: 'OpenEndedCoding.errors.keywordsHasDuplicates',
    defaultMessage: 'There are some duplicate keywords.',
    description: '[Type: Label][Vis: med] - OEC duplicate keywords'
  },
  keywordsTooLong: {
    id: 'OpenEndedCoding.errors.keywordsTooLong',
    defaultMessage: 'Please create a keyword that is less than { maxLength } characters.',
    description: '[Type: Label][Vis: med] - OEC keyword length error message'
  },
  keywordsNotEnough: {
    id: 'OpenEndedCoding.errors.keywordsTooLong',
    defaultMessage: 'Please create at least one keyword per theme.',
    description: '[Type: Label][Vis: med] - OEC keyword minimum required error message'
  }
};
var NO_ERRORS = {
  error: false,
  messages: []
};

// we only allow letters, numbers and spaces for theme names
var onlyLettersAndNumbers = function onlyLettersAndNumbers(str) {
  return /^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\s]*$/.test(str);
};
var validateTheme = function validateTheme(_ref54) {
  var themes = _ref54.themes,
    themeName = _ref54.themeName,
    _ref54$originalTheme = _ref54.originalTheme,
    _originalTheme = _ref54$originalTheme === void 0 ? '' : _ref54$originalTheme;
  var errors = {
    error: false,
    messages: []
  };

  // check length
  if (themeName.length < THEME_MIN_LENGTH || themeName.length > THEME_MAX_LENGTH) {
    errors.error = true;
    errors.messages.push(t(COPY$A.length, {
      minLength: THEME_MIN_LENGTH,
      maxLength: THEME_MAX_LENGTH
    }));
  }

  // check for malformed input
  var malformed = !onlyLettersAndNumbers(themeName);
  if (malformed) {
    errors.error = true;
    errors.messages.push(t(COPY$A.malformed));
  }

  // check for duplicates
  var duplicates = themes.filter(function (_ref55) {
    var theme = _ref55.theme;
    return theme.toLowerCase() === themeName.toLowerCase() && theme !== _originalTheme;
  });
  if (duplicates.length > 0) {
    errors.error = true;
    errors.messages.push(t(COPY$A.duplicates, {
      themeName: themeName
    }));
  }
  return errors;
};
var hasDuplicates = function hasDuplicates(_ref56) {
  var items = _ref56.items;
  var lowerCaseItems = items.map(function (item) {
    return item.toLowerCase();
  });
  return lowerCaseItems.some(function (item, index) {
    return lowerCaseItems.indexOf(item) !== index;
  });
};
var buildKeywordsErrorMessages = function buildKeywordsErrorMessages(errors) {
  var messages = [];
  if (errors.keywordsHasInvalid) {
    messages.push(t(COPY$A.keywordsHasInvalid));
  }
  if (errors.keywordsTooLong) {
    messages.push(t(COPY$A.keywordsTooLong, {
      maxLength: KW_MAX_LENGTH
    }));
  }
  if (errors.keywordsHasDuplicates) {
    messages.push(t(COPY$A.keywordsHasDuplicates));
  }
  if (errors.keywordsNotEnough) {
    messages.push(t(COPY$A.keywordsNotEnough));
  }
  return messages;
};
var validateKeywords = function validateKeywords(_ref57) {
  var keywords = _ref57.keywords;
  return keywords.map(function (k) {
    // track different types of errors
    var errors = {
      keywordsHasInvalid: false,
      keywordsHasDuplicates: false,
      keywordsTooLong: false,
      keywordsNotEnough: false
    };

    // remove all spaces, split by comma and replace empties
    var keywordList = k.keywords.split(',').filter(function (kw) {
      return kw.trim() !== '';
    });
    if (keywordList.length === 0) {
      errors.keywordsNotEnough = true;
    }
    keywordList.forEach(function (keyword) {
      // can't have any invalid keywords
      // can only have letters, numbers and spaces
      if (INVALID_KEYWORDS.includes(keyword) || !onlyLettersAndNumbers(keyword)) {
        errors.keywordsHasInvalid = true;
      }

      // can't create long keywords
      if (keyword.length > KW_MAX_LENGTH) {
        errors.keywordsTooLong = true;
      }
    });

    // check for duplicates in keywords list
    if (hasDuplicates({
      items: keywordList
    })) {
      errors.keywordsHasDuplicates = true;
    }

    // build errors
    var error = Object.values(errors).some(function (e) {
      return e;
    });
    var errorMessages = buildKeywordsErrorMessages(errors);
    return {
      themeId: k.themeId,
      keywords: keywordList.join(','),
      error: error,
      errorMessages: errorMessages
    };
  });
};
var COPY$z = {
  do: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.do',
    defaultMessage: 'Do',
    description: '[Type: Header][Vis: med] - creating/updating theme name do'
  },
  firstDo: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.firstDo',
    defaultMessage: 'Create themes that represent recurring topics in your responses. For example, if many respondents mention the cost of a product, you could create a theme called "price" to capture this topic.',
    description: '[Type: Header][Vis: med] - selecting themes name first do'
  },
  secondDo: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.secondDo',
    defaultMessage: 'We recommend creating between 5 and 15 themes.',
    description: '[Type: Header][Vis: med] - selecting themes name second do'
  },
  dont: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.dont',
    defaultMessage: "Don't",
    description: "[Type: Header][Vis: med] - selecting keywords title don't"
  },
  firstDont: {
    id: 'OpenEndedCoding.ThemeGuidanceCard.firstDont',
    defaultMessage: 'Create themes that don’t relate to the content of your responses. Our AI analyzes the text of your responses to apply the appropriate tags, so themes related to internal workflows or administrative tasks, like "to do" or "follow up" will return ambiguous or inaccurate results.',
    description: '[Type: Header][Vis: med] - selecting keywords first dont'
  }
};
var ThemeGuidanceCard = function ThemeGuidanceCard() {
  return /*#__PURE__*/jsxs(Grid, {
    noBleeds: true,
    mt: 4,
    children: [/*#__PURE__*/jsxs(Grid.Item, {
      children: [/*#__PURE__*/jsx(Box, {
        mb: 4,
        children: /*#__PURE__*/jsxs(Box, {
          children: [/*#__PURE__*/jsx(IconCheckCircle, {
            title: "check",
            color: "primary"
          }), "\xA0", /*#__PURE__*/jsx(Typography, {
            component: "span",
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$z.do
            })
          })]
        })
      }), /*#__PURE__*/jsxs(Box, {
        children: [/*#__PURE__*/jsx(Typography, {
          component: "div",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$z.firstDo
          })
        }), /*#__PURE__*/jsx(Box, {
          mt: 4,
          children: /*#__PURE__*/jsx(Typography, {
            component: "div",
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$z.secondDo
            })
          })
        })]
      })]
    }), /*#__PURE__*/jsxs(Grid.Item, {
      children: [/*#__PURE__*/jsx(Box, {
        mb: 4,
        children: /*#__PURE__*/jsxs(Box, {
          children: [/*#__PURE__*/jsx(IconFlag, {
            title: "flag",
            color: "warning"
          }), "\xA0", /*#__PURE__*/jsx(Typography, {
            component: "span",
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$z.dont
            })
          })]
        })
      }), /*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(Typography, {
          component: "div",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$z.firstDont
          })
        })
      })]
    })]
  });
};
var COPY$y = {
  header: {
    id: 'OpenEndedCoding.AddThemeModal.header',
    defaultMessage: 'Create theme',
    description: '[Type: Header][Vis: med] - Header for Create Theme Modal'
  },
  cancel: {
    id: 'OpenEndedCoding.AddThemeModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Create Theme Modal cancel button'
  },
  create: {
    id: 'OpenEndedCoding.AddThemeModal.create',
    defaultMessage: 'Create',
    description: '[Type: Header][Vis: med] - Create Theme Modal create button'
  },
  theme: {
    id: 'OpenEndedCoding.AddThemeModal.theme',
    defaultMessage: 'Theme name',
    description: '[Type: Header][Vis: med] - Create Theme Modal theme title'
  },
  placeholder: {
    id: 'OpenEndedCoding.AddThemeModal.placeholder',
    defaultMessage: 'Enter theme name here',
    description: '[Type: Header][Vis: med] - Create Theme Modal placeholder'
  }
};
var AddThemeModal = function AddThemeModal(_ref58) {
  var show = _ref58.show,
    selectedThemeId = _ref58.selectedThemeId,
    createdSource = _ref58.createdSource,
    onClose = _ref58.onClose,
    onCreate = _ref58.onCreate;
  var _useGeneral = useGeneral(),
    surveyId = _useGeneral.surveyId,
    questionId = _useGeneral.questionId,
    isSolutions = _useGeneral.isSolutions;
  var _useThemes = useThemes(),
    themes = _useThemes.themes;
  var selectedTheme = themes.find(function (theme) {
    return theme.id === selectedThemeId;
  });
  var originalTheme = selectedTheme ? selectedTheme.theme : '';
  var _useState = useState(originalTheme),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  var _useState3 = useState(NO_ERRORS),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var touched = useRef(false);
  var handleThemeChange = function handleThemeChange(e) {
    var themeName = e.currentTarget.value;
    setTheme(themeName);
    if (touched.current) {
      setError(validateTheme({
        themes: themes,
        themeName: themeName,
        originalTheme: originalTheme
      }));
    }
  };
  useEffect(function () {
    setTheme(selectedTheme ? selectedTheme.theme : '');
  }, [selectedTheme]);
  var handleClose = function handleClose() {
    onClose();
    setError(NO_ERRORS);
    setTheme('');
  };
  var onFormSubmit = function onFormSubmit(e) {
    e.preventDefault();

    // catch any validation errors
    var validated = validateTheme({
      themes: themes,
      themeName: theme,
      originalTheme: originalTheme
    });
    if (validated.error) {
      setError(validated);
      touched.current = true;
      return;
    }
    onCreate(theme);
    onClose();
    setTheme('');

    // tracking
    trackAmplitudeEvent({
      amplitudeEvent: 'open-ended coding created theme',
      data: {
        surveyId: surveyId,
        questionId: questionId,
        pageName: isSolutions ? 'ctm' : 'analyze',
        createdSource: createdSource
      }
    });
  };
  return /*#__PURE__*/jsx("form", {
    onSubmit: onFormSubmit,
    children: /*#__PURE__*/jsxs(Modal, {
      "data-testid": "AddThemeModal__OEC",
      show: show,
      onClose: handleClose,
      size: "md",
      children: [/*#__PURE__*/jsx(Modal.Header, {
        header: t(COPY$y.header)
      }), /*#__PURE__*/jsx(Modal.Body, {
        children: /*#__PURE__*/jsxs(Box, {
          mb: 5,
          children: [/*#__PURE__*/jsx(Input, Object.assign({
            ariaLabel: "Create a theme",
            stretched: true,
            label: t(COPY$y.theme),
            value: theme,
            placeholder: t(COPY$y.placeholder),
            onChange: handleThemeChange
          }, error.error && {
            color: 'warning',
            errorMessage: /*#__PURE__*/jsx(Box, {
              children: error.messages.map(function (message) {
                return /*#__PURE__*/jsx(Typography, {
                  component: "p",
                  variant: "bodySm",
                  color: "warning",
                  children: message
                }, message);
              })
            })
          })), /*#__PURE__*/jsx(ThemeGuidanceCard, {})]
        })
      }), /*#__PURE__*/jsxs(Modal.Footer, {
        align: "right",
        children: [/*#__PURE__*/jsx(Button, {
          variant: "ghost",
          color: "secondary",
          onClick: handleClose,
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$y.cancel
          })
        }), /*#__PURE__*/jsx(Button, {
          type: "submit",
          disabled: error.error || theme === originalTheme,
          onClick: onFormSubmit,
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$y.create
          })
        })]
      })]
    })
  });
};
createUseStyles(function (theme) {
  return {
    tips: {
      backgroundColor: '#EEF9FE',
      padding: theme.spacing[6]
    }
  };
});
var _$j = function _$j(t) {
    return t;
  },
  _t$j;
gql(_t$j || (_t$j = _$j(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getOecPreviouslyUsedTags($surveyId: ID!, $questionId: ID!) {\n    getOecPreviouslyUsedTags(surveyId: $surveyId, questionId: $questionId) {\n      id\n      name\n    }\n  }\n"])))));
createUseStyles(function () {
  return {
    badges: {
      display: 'inline-flex',
      flexWrap: 'wrap'
    }
  };
});
createUseStyles(function (theme) {
  return {
    badges: {
      display: 'inline-flex',
      flexWrap: 'wrap'
    }
  };
});
var _$i = function _$i(t) {
    return t;
  },
  _t$i;
gql(_t$i || (_t$i = _$i(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  mutation createThemesForQuestion($input: CreateTagsDataInput!) {\n    createOecQuestionTags(input: $input) {\n      success\n      trainingStatus\n      tags {\n        id\n        label\n        tagType\n        responseTextIds\n      }\n    }\n  }\n"])))));
createUseStyles(function (theme) {
  return {
    leftPane: {
      maxHeight: '450px',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    badges: {
      display: 'inline-flex',
      flexWrap: 'wrap'
    }
  };
});
var COPY$x = {
  header: {
    id: 'OpenEndedCoding.DeleteThemeModal.header',
    defaultMessage: 'Delete theme?',
    description: '[Type: Header][Vis: med] - Header for Delete Theme Modal'
  },
  description: {
    id: 'OpenEndedCoding.DeleteThemeModal.description',
    defaultMessage: 'You are going to delete the theme and remove it from any response you might have tagged it.',
    description: '[Type: Header][Vis: med] - Delete Theme Modal description'
  },
  cancel: {
    id: 'OpenEndedCoding.DeleteThemeModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Delete Theme Modal cancel button'
  },
  delete: {
    id: 'OpenEndedCoding.DeleteThemeModal.delete',
    defaultMessage: 'Delete',
    description: '[Type: Header][Vis: med] - Delete Theme Modal delete button'
  }
};
var DeleteThemeModal = function DeleteThemeModal(_ref59) {
  var show = _ref59.show,
    onClose = _ref59.onClose,
    onDelete = _ref59.onDelete;
  var _useGeneral2 = useGeneral(),
    surveyId = _useGeneral2.surveyId,
    questionId = _useGeneral2.questionId,
    isSolutions = _useGeneral2.isSolutions;
  return /*#__PURE__*/jsxs(Modal, {
    "data-testid": "DeleteThemeModal__OEC",
    show: show,
    onClose: onClose,
    children: [/*#__PURE__*/jsx(Modal.Header, {
      header: t(COPY$x.header)
    }), /*#__PURE__*/jsx(Modal.Body, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$x.description
      })
    }), /*#__PURE__*/jsxs(Modal.Footer, {
      align: "right",
      children: [/*#__PURE__*/jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: onClose,
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$x.cancel
        })
      }), /*#__PURE__*/jsx(Button, {
        color: "warning",
        onClick: function onClick() {
          onDelete();
          onClose();

          // tracking
          trackAmplitudeEvent({
            amplitudeEvent: 'open-ended coding deleted theme',
            data: {
              surveyId: surveyId,
              questionId: questionId,
              pageName: isSolutions ? 'ctm' : 'analyze'
            }
          });
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$x.delete
        })
      })]
    })]
  });
};
var InputSkeleton$1 = function InputSkeleton$1() {
  return /*#__PURE__*/jsx(Box, {
    display: "flex",
    flexJustify: "center",
    children: /*#__PURE__*/jsx(Box, {
      m: 4,
      children: /*#__PURE__*/jsxs(SkeletonLoader, {
        "data-testid": "InputSkeleton",
        height: 50,
        width: 615,
        children: [/*#__PURE__*/jsx("rect", {
          x: "0",
          y: "0",
          rx: "0",
          ry: "0",
          width: "150",
          height: "15"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "20",
          rx: "0",
          ry: "0",
          width: "615",
          height: "30"
        })]
      })
    })
  });
};
var COPY$w = {
  header: {
    id: 'OpenEndedCoding.EditThemeModal.header',
    defaultMessage: 'Edit Theme',
    description: '[Type: Header][Vis: med] - Header for Edit Theme Modal'
  },
  cancel: {
    id: 'OpenEndedCoding.EditThemeModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Edit Theme Modal cancel button'
  },
  save: {
    id: 'OpenEndedCoding.EditThemeModal.save',
    defaultMessage: 'Save',
    description: '[Type: Header][Vis: med] - Edit Theme Modal delete button'
  },
  theme: {
    id: 'OpenEndedCoding.EditThemeModal.theme',
    defaultMessage: 'Name',
    description: '[Type: Header][Vis: med] - Edit Theme Modal theme title'
  },
  keywords: {
    id: 'OpenEndedCoding.EditThemeModal.keywords',
    defaultMessage: 'Keywords',
    description: '[Type: Header][Vis: med] - Edit Theme Modal keywords title'
  },
  updateThemeLabel: {
    id: 'OpenEndedCoding.EditThemeModal.updateThemeLabel',
    defaultMessage: 'Update a theme',
    description: '[Type: Header][Vis: med] - Edit Theme Modal update theme label'
  },
  getKeywordsError: {
    id: 'OpenEndedCoding.EditThemeModal.getKeywordsError',
    defaultMessage: 'An error occured getting the keywords',
    description: '[Type: Header][Vis: med] - Edit Theme Modal get keywords error'
  }
};
var EditThemeModal = function EditThemeModal(_ref60) {
  var show = _ref60.show,
    selectedThemeId = _ref60.selectedThemeId,
    onClose = _ref60.onClose,
    onSave = _ref60.onSave;
  var _selectedKeywords$key;
  var _useThemes2 = useThemes(),
    themes = _useThemes2.themes,
    keywords = _useThemes2.keywords,
    keywordsLoading = _useThemes2.keywordsLoading,
    keywordsError = _useThemes2.keywordsError;
  var _useGeneral3 = useGeneral(),
    surveyId = _useGeneral3.surveyId,
    questionId = _useGeneral3.questionId,
    isSolutions = _useGeneral3.isSolutions;
  var selectedTheme = themes.find(function (theme) {
    return theme.id === selectedThemeId;
  });
  var selectedKeywords = keywords.find(function (themeWithKeyword) {
    return themeWithKeyword.themeId === selectedThemeId;
  });
  var originalTheme = selectedTheme ? selectedTheme.theme : '';
  var _useState5 = useState(originalTheme),
    _useState6 = _slicedToArray(_useState5, 2),
    theme = _useState6[0],
    setTheme = _useState6[1];
  var _useState7 = useState(NO_ERRORS),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var touched = useRef(false);
  var handleThemeChange = function handleThemeChange(e) {
    var themeName = e.currentTarget.value;
    setTheme(themeName);
    if (touched.current) {
      setError(validateTheme({
        themes: themes,
        themeName: themeName,
        originalTheme: originalTheme
      }));
    }
  };
  useEffect(function () {
    setTheme(selectedTheme ? selectedTheme.theme : '');
  }, [selectedTheme]);
  var handleClose = function handleClose() {
    onClose();
    setError(NO_ERRORS);
    setTheme('');
  };
  return /*#__PURE__*/jsxs(Modal, {
    "data-testid": "EditThemeModal__OEC",
    show: show,
    onClose: handleClose,
    size: "md",
    children: [/*#__PURE__*/jsx(Modal.Header, {
      header: t(COPY$w.header)
    }), /*#__PURE__*/jsxs(Modal.Body, {
      children: [/*#__PURE__*/jsx(Box, {
        mb: 5,
        children: /*#__PURE__*/jsx(Input, Object.assign({
          ariaLabel: t(COPY$w.updateThemeLabel),
          stretched: true,
          label: t(COPY$w.theme),
          value: theme,
          onChange: handleThemeChange
        }, error.error && {
          color: 'warning',
          errorMessage: /*#__PURE__*/jsx(Box, {
            children: error.messages.map(function (message) {
              return /*#__PURE__*/jsx(Typography, {
                component: "p",
                variant: "bodySm",
                color: "warning",
                children: message
              }, message);
            })
          })
        }))
      }), /*#__PURE__*/jsx(Box, {
        mb: 5,
        children: keywordsLoading ? /*#__PURE__*/jsx(InputSkeleton$1, {}) : /*#__PURE__*/jsx(Input, Object.assign({
          stretched: true,
          disabled: true,
          label: t(COPY$w.keywords),
          value: (_selectedKeywords$key = selectedKeywords == null ? void 0 : selectedKeywords.keywords.join(', ')) != null ? _selectedKeywords$key : ''
        }, keywordsError && {
          color: 'warning',
          errorMessage: /*#__PURE__*/jsx(Box, {
            children: /*#__PURE__*/jsx(Typography, {
              component: "p",
              variant: "bodySm",
              color: "warning",
              children: t(COPY$w.getKeywordsError)
            })
          })
        }))
      }), /*#__PURE__*/jsx(ThemeGuidanceCard, {})]
    }), /*#__PURE__*/jsxs(Modal.Footer, {
      align: "right",
      children: [/*#__PURE__*/jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: handleClose,
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$w.cancel
        })
      }), /*#__PURE__*/jsx(Button, {
        disabled: error.error || theme === originalTheme,
        onClick: function onClick() {
          var validated = validateTheme({
            themes: themes,
            themeName: theme,
            originalTheme: originalTheme
          });
          if (validated.error) {
            setError(validated);
            touched.current = true;
          } else {
            onSave(theme);
            onClose();
          }

          // tracking
          trackAmplitudeEvent({
            amplitudeEvent: 'open-ended coding edited theme',
            data: {
              surveyId: surveyId,
              questionId: questionId,
              pageName: isSolutions ? 'ctm' : 'analyze'
            }
          });
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$w.save
        })
      })]
    })]
  });
};
var _$h = function _$h(t) {
    return t;
  },
  _t$h;
var generateOecSuggestedThemes = gql(_t$h || (_t$h = _$h(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  mutation generateOecSuggestedThemes($input: GenerateSuggestedTagsInput!) {\n    generateOecSuggestedTags(input: $input) {\n      success\n      modelId\n      modelVersion\n      predictionId\n    }\n  }\n"])))));
var COPY$v = {
  header: {
    id: 'OpenEndedCoding.ChangeUseCaseModal.header',
    defaultMessage: 'Confirm Use Case',
    description: '[Type: Header][Vis: med] - Header for Change Use Case Modal'
  },
  headerNone: {
    id: 'OpenEndedCoding.ChangeUseCaseModal.headerNone',
    defaultMessage: 'Hide suggested themes',
    description: '[Type: Header][Vis: med] - Header for Change Use Case Modal when user selects none'
  },
  description: {
    id: 'OpenEndedCoding.ChangeUseCaseModal.description',
    defaultMessage: 'You are going to generate new suggested themes based on this new use case, {displayedUseCase}.',
    description: '[Type: Header][Vis: med] - Change Use Case Modal description'
  },
  descriptionNone: {
    id: 'OpenEndedCoding.ChangeUseCaseModal.descriptionNone',
    defaultMessage: 'This action will hide all suggested themes for your responses. Are you sure?',
    description: '[Type: Header][Vis: med] - Change Use Case Modal description when user selects none'
  },
  cancel: {
    id: 'OpenEndedCoding.ChangeUseCaseModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Change Use Case Modal cancel button'
  },
  change: {
    id: 'OpenEndedCoding.ChangeUseCaseModal.change',
    defaultMessage: 'Update',
    description: '[Type: Header][Vis: med] - Change Use Case Modal update button'
  }
};
var ChangeUseCaseModal = function ChangeUseCaseModal(_ref61) {
  var show = _ref61.show,
    previousUseCase = _ref61.previousUseCase,
    _onClose = _ref61.onClose;
  var _useGeneral4 = useGeneral(),
    surveyId = _useGeneral4.surveyId,
    questionId = _useGeneral4.questionId,
    isSolutions = _useGeneral4.isSolutions;
  var _useGeneralActions = useGeneralActions(),
    setError = _useGeneralActions.setError;
  var _useThemesReuseAction = useThemesReuseActions(),
    setSelectedUseCase = _useThemesReuseAction.setSelectedUseCase;
  var _useThemesReuse = useThemesReuse(),
    selectedUseCase = _useThemesReuse.selectedUseCase;
  var displayedUseCase = selectedUseCase && startCase(selectedUseCase);

  // just default to none if no confirmed use case
  // we won't fire the mutation if set to none
  var domain = selectedUseCase && selectedUseCase in USE_CASES ? USE_CASES[selectedUseCase] : USE_CASES.none;
  var _useMutation = useMutation(generateOecSuggestedThemes, {
      onCompleted: function onCompleted(_ref62) {
        var success = _ref62.generateOecSuggestedTags.success;
        // error occurred
        if (!success) {
          setError(true);
        }
      },
      onError: function onError() {
        setError(true);
      }
    }),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    generateOECSuggestedThemes = _useMutation2[0];
  return /*#__PURE__*/jsxs(Modal, {
    "data-testid": "ChangeUseCaseModal__OEC",
    show: show,
    onClose: function onClose() {
      _onClose();
      setSelectedUseCase(previousUseCase);
    },
    children: [/*#__PURE__*/jsx(Modal.Header, {
      header: previousUseCase === USE_CASE_NONE ? t(COPY$v.headerNone) : t(COPY$v.header)
    }), /*#__PURE__*/jsx(Modal.Body, {
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: selectedUseCase === USE_CASE_NONE ? /*#__PURE__*/jsx(T, {
          desc: COPY$v.descriptionNone
        }) : /*#__PURE__*/jsx(T, {
          html: true,
          desc: COPY$v.description,
          values: {
            displayedUseCase: displayedUseCase
          }
        })
      })
    }), /*#__PURE__*/jsxs(Modal.Footer, {
      align: "right",
      children: [/*#__PURE__*/jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: function onClick() {
          _onClose();
          setSelectedUseCase(previousUseCase);
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$v.cancel
        })
      }), /*#__PURE__*/jsx(Button, {
        color: "link",
        onClick: function onClick() {
          if (selectedUseCase !== USE_CASE_NONE) {
            // generate suggested themes for the use case
            void generateOECSuggestedThemes({
              variables: {
                input: {
                  surveyId: surveyId,
                  questionId: questionId,
                  domain: domain
                }
              }
            });
          }
          _onClose();

          // tracking
          trackAmplitudeEvent({
            amplitudeEvent: 'open-ended coding change use case',
            data: {
              surveyId: surveyId,
              questionId: questionId,
              pageName: isSolutions ? 'ctm' : 'analyze'
            }
          });
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$v.change
        })
      })]
    })]
  });
};
var COPY$u = {
  edit: {
    id: 'OpenEndedCoding.ThemeRow.edit',
    defaultMessage: 'Edit',
    description: '[Type: Header][Vis: med] - Edit button for themes'
  },
  delete: {
    id: 'OpenEndedCoding.ThemeRow.delete',
    defaultMessage: 'Delete',
    description: '[Type: Header][Vis: med] - Delete button for themes'
  }
};
var ThemeRow$1 = function ThemeRow$1(_ref63) {
  var theme = _ref63.theme,
    count = _ref63.count,
    onClickDelete = _ref63.onClickDelete,
    onClickEdit = _ref63.onClickEdit;
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showMenu = _useState10[0],
    setShowMenu = _useState10[1];
  var trigger = /*#__PURE__*/jsx(LinkStyleButton, {
    children: /*#__PURE__*/jsx(IconMoreAndroid, {
      title: "theme options",
      size: "sm",
      color: "darkMuted"
    })
  });
  return /*#__PURE__*/jsxs(Box, {
    display: "flex",
    flexJustify: "space-between",
    children: [/*#__PURE__*/jsx(Typography, {
      component: "div",
      variant: "bodySm",
      color: "dark",
      children: theme
    }), /*#__PURE__*/jsxs(Box, {
      display: "inline-flex",
      flexAlign: "center",
      children: [/*#__PURE__*/jsx(Typography, {
        component: "div",
        variant: "bodySm",
        color: "dark",
        children: count
      }), /*#__PURE__*/jsx(Box, {
        ml: 2,
        mb: 1,
        children: /*#__PURE__*/jsxs(Menu, {
          placement: "bottom-right",
          show: showMenu,
          menuTrigger: trigger,
          children: [/*#__PURE__*/jsx(Menu.Item, {
            onClick: function onClick() {
              setShowMenu(false);
              onClickEdit();
            },
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$u.edit
            })
          }), /*#__PURE__*/jsx(Menu.Item, {
            onClick: function onClick() {
              setShowMenu(false);
              onClickDelete();
            },
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$u.delete
            })
          })]
        })
      })]
    })]
  });
};
var COPY$t = {
  emptyStateRepeatedly: {
    id: 'OpenEndedCoding.ThemeSelector.emptyStateRepeatedly',
    defaultMessage: 'As you read your responses, you’ll probably notice some topics, or <strong>themes</strong>, come up repeatedly.',
    description: '[Type: Header][Vis: med] - empty state theme selection'
  },
  emptyStateThematic: {
    id: 'OpenEndedCoding.ThemeSelector.emptyStateThematic',
    defaultMessage: 'These themes can reveal important concepts and patterns in your data. <strong>Thematic analysis</strong> is the process of identifying what these themes are and where they appear.',
    description: '[Type: Header][Vis: med] - empty state theme selection'
  }
};
var useStyles$m = createUseStyles(function (theme) {
  return {
    list: {
      // remove the default list item padding to maximize width
      // as the theme selector section has a reduced grid portion.
      '& div[id^="theme-row"] > span[class^="wrenchListLabel"]': {
        padding: 0
      }
    }
  };
});
var ThemeSection = function ThemeSection(_ref64) {
  var _onClickDelete = _ref64.onClickDelete,
    _onClickEdit = _ref64.onClickEdit;
  var classes = useStyles$m();
  var _useThemes3 = useThemes(),
    themes = _useThemes3.themes;

  // Empty state
  if (themes.length === 0) {
    return /*#__PURE__*/jsxs(Box, {
      mb: 4,
      "data-testid": "ThemeSection__EmptyState",
      children: [/*#__PURE__*/jsx(Box, {
        mb: 2,
        children: /*#__PURE__*/jsx(Typography, {
          component: "p",
          variant: "bodySm",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$t.emptyStateRepeatedly,
            html: true
          })
        })
      }), /*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(Typography, {
          component: "p",
          variant: "bodySm",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$t.emptyStateThematic,
            html: true
          })
        })
      })]
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: classes.list,
    children: /*#__PURE__*/jsx(List, {
      dense: true,
      noRules: true,
      children: themes.map(function (theme) {
        return /*#__PURE__*/jsx(List.Item, {
          id: "theme-row-".concat(theme.id),
          children: /*#__PURE__*/jsx(ThemeRow$1, {
            theme: theme.theme,
            count: getResponseCountForTheme(theme),
            onClickDelete: function onClickDelete() {
              return _onClickDelete(theme.id);
            },
            onClickEdit: function onClickEdit() {
              return _onClickEdit(theme.id);
            }
          })
        }, theme.id);
      })
    })
  });
};
var ThemesSkeleton = function ThemesSkeleton() {
  return /*#__PURE__*/jsx(Box, {
    display: "flex",
    flexJustify: "center",
    children: /*#__PURE__*/jsx(Box, {
      m: 4,
      children: /*#__PURE__*/jsxs(SkeletonLoader, {
        "data-testid": "ThemesSkeleton",
        height: 200,
        width: 180,
        children: [/*#__PURE__*/jsx("rect", {
          x: "0",
          y: "0",
          rx: "0",
          ry: "0",
          width: "170",
          height: "30"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "50",
          rx: "0",
          ry: "0",
          width: "170",
          height: "30"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "100",
          rx: "0",
          ry: "0",
          width: "170",
          height: "30"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "150",
          rx: "0",
          ry: "0",
          width: "170",
          height: "30"
        })]
      })
    })
  });
};
createUseStyles(function (theme) {
  return {
    selectMenu: {
      // style the check blue
      '& div[class^="wrenchListAddon"] svg': {
        fill: BLUE_CHECK
      },
      // need a narrower select menu trigger
      '& span[class^="wrenchMenuContainer"] > div[class^="wrenchSelectMenu"]': {
        padding: '0px 42px 0px 12px'
      }
    }
  };
});
var useStyles$l = createUseStyles(function (theme) {
  return {
    label: {
      fontSize: theme.type.fontSize.bodySm
    }
  };
});
var ThemeRow = function ThemeRow(_ref65) {
  var theme = _ref65.theme,
    responseTextId = _ref65.responseTextId,
    search = _ref65.search;
  var classes = useStyles$l();
  var items = splitBySearchPhrase({
    text: theme.theme,
    searchPhrase: search
  });
  var label = items.reduce(function (htmlString, item) {
    var makeBold = item.toLowerCase() === search.toLowerCase();
    return "".concat(htmlString).concat(makeBold ? "<b>".concat(item, "</b>") : "<span>".concat(item, "</span>"));
  }, '');
  return /*#__PURE__*/jsx(Checkbox, {
    id: "".concat(theme.id, "-").concat(responseTextId),
    checked: theme.checked,
    label: /*#__PURE__*/jsx("span", {
      id: "ThemeRow__Theme-".concat(theme.id),
      "data-testid": "ThemeRow__Theme-".concat(theme.id),
      className: classes.label,
      dangerouslySetInnerHTML: {
        __html: sanitizeString(label)
      }
    })
  });
};
var COPY$s = {
  addThemesButton: {
    id: 'OpenEndedCoding.ThemeMenu.addThemesButton',
    defaultMessage: 'Add {themes, plural, =1 {theme} =0 {theme} other {themes}}',
    description: '[Type: Header][Vis: med] - button text theme selection'
  },
  addAndTagButton: {
    id: 'OpenEndedCoding.ThemeMenu.addAndTagButton',
    defaultMessage: 'Add theme and tag',
    description: '[Type: Header][Vis: med] - button text theme creation'
  }
};
var AddButton = function AddButton(_ref66) {
  var allThemes = _ref66.allThemes,
    themesSelected = _ref66.themesSelected,
    search = _ref66.search,
    disabled = _ref66.disabled,
    handleSaveThemes = _ref66.handleSaveThemes,
    handleThemeCreationForResponse = _ref66.handleThemeCreationForResponse;
  var showAddThemesButton = themesSelected.length > 0 || search === '' || !!allThemes.find(function (_ref67) {
    var theme = _ref67.theme;
    return theme === search;
  });
  var _useGeneral5 = useGeneral(),
    surveyId = _useGeneral5.surveyId,
    questionId = _useGeneral5.questionId,
    isSolutions = _useGeneral5.isSolutions;
  if (showAddThemesButton) {
    return /*#__PURE__*/jsx(Menu.Item, {
      disabled: themesSelected.length === 0 || disabled,
      onClick: function onClick() {
        handleSaveThemes();

        // tracking
        trackAmplitudeEvent({
          amplitudeEvent: 'open-ended coding applied theme',
          data: {
            surveyId: surveyId,
            questionId: questionId,
            pageName: isSolutions ? 'ctm' : 'analyze',
            themeType: 'existing theme'
          }
        });
      },
      children: /*#__PURE__*/jsx(Box, {
        px: 3,
        children: /*#__PURE__*/jsx(Button, {
          disabled: themesSelected.length === 0 || disabled,
          color: "link",
          stretched: true,
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$s.addThemesButton,
            values: {
              themes: themesSelected.length
            }
          })
        })
      })
    });
  }
  return /*#__PURE__*/jsx(Menu.Item, {
    onClick: function onClick() {
      handleThemeCreationForResponse();

      // tracking
      trackAmplitudeEvent({
        amplitudeEvent: 'open-ended coding applied theme',
        data: {
          surveyId: surveyId,
          questionId: questionId,
          pageName: isSolutions ? 'ctm' : 'analyze',
          themeType: 'new theme'
        }
      });
    },
    children: /*#__PURE__*/jsx(Box, {
      px: 3,
      children: /*#__PURE__*/jsx(Button, {
        stretched: true,
        color: "secondary",
        variant: "ghost",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$s.addAndTagButton
        })
      })
    })
  });
};
var COPY$r = {
  addThemeButton: {
    id: 'OpenEndedCoding.ThemeMenu.addThemeButton',
    defaultMessage: 'Add theme',
    description: '[Type: Header][Vis: med] - button text theme selection'
  },
  title: {
    id: 'OpenEndedCoding.ThemeMenu.title',
    defaultMessage: 'Add theme',
    description: '[Type: Header][Vis: med] - Add theme title'
  },
  label: {
    id: 'OpenEndedCoding.ThemeMenu.label',
    defaultMessage: 'Add theme',
    description: '[Type: Header][Vis: med] - Search theme label'
  },
  placeholder: {
    id: 'OpenEndedCoding.ThemeMenu.placeholder',
    defaultMessage: 'Type to search or add new',
    description: '[Type: Header][Vis: med] - Search theme placeholder'
  },
  placeholderNoThemes: {
    id: 'OpenEndedCoding.ThemeMenu.placeholderNoThemes',
    defaultMessage: 'Add a theme',
    description: '[Type: Header][Vis: med] - Search theme placeholder'
  }
};
var useStyles$k = createUseStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      // How we apply custom styles to the menu.
      '& div[role=menu] > div': {
        minWidth: '280px',
        maxHeight: 'none',
        // Ensure whole menu doesn't scroll vertically.
        overflowY: 'visible',
        // Make theme section scroll vertically.
        '& > ul:nth-of-type(2) > section': {
          height: '200px',
          overflowY: 'auto'
        },
        // Need extra padding for the menu items.
        '& div[role=menuitem]': {
          paddingLeft: theme.spacing[3],
          paddingRight: theme.spacing[3]
        }
      }
    },
    // Style checkboxes blue.
    checkbox: {
      '& input[class^="wrenchCheckboxNative"]:checked + span[class^="wrenchCheckboxFaux"]': {
        background: BLUE_CHECK,
        borderColor: BLUE_CHECK
      },
      '& input[class^="wrenchCheckboxNative"]:focus:checked + span[class^="wrenchCheckboxFaux"]': {
        borderColor: "".concat(BLUE_CHECK, " !important"),
        boxShadow: 'none !important'
      }
    },
    error: {
      overflowWrap: 'break-word',
      whiteSpace: 'normal'
    }
  };
});
var isEmptyState = function isEmptyState(_ref68) {
  var allThemes = _ref68.allThemes,
    themesAvailableForSelection = _ref68.themesAvailableForSelection;
  var hasThemes = allThemes.length > 0;
  var hasThemesAvailableForSelection = themesAvailableForSelection.length > 0;

  // When there are themes check if no remaining themes to select
  if (hasThemes) {
    return !hasThemesAvailableForSelection;
  }

  // There are no themes created
  return true;
};
var ThemeMenu = function ThemeMenu(_ref69) {
  var responseTextId = _ref69.responseTextId,
    allThemes = _ref69.allThemes,
    themesAvailableForSelection = _ref69.themesAvailableForSelection,
    addThemesToResponse = _ref69.addThemesToResponse,
    createThemeForResponse = _ref69.createThemeForResponse;
  var classes = useStyles$k();
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showThemeMenu = _useState12[0],
    setShowThemeMenu = _useState12[1];
  var _useState13 = useState(NO_ERRORS),
    _useState14 = _slicedToArray(_useState13, 2),
    error = _useState14[0],
    setError = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    search = _useState16[0],
    setSearch = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    searchDisabled = _useState18[0],
    setSearchDisabled = _useState18[1];
  var _useState19 = useState(themesAvailableForSelection.map(function (theme) {
      return Object.assign({}, theme, {
        checked: false,
        show: true
      });
    })),
    _useState20 = _slicedToArray(_useState19, 2),
    themesWithChecked = _useState20[0],
    setThemesWithChecked = _useState20[1];

  // When the themes get updated, we need to refresh the theme menu.
  useEffect(function () {
    setThemesWithChecked(themesAvailableForSelection.map(function (theme) {
      return Object.assign({}, theme, {
        checked: false,
        show: true
      });
    }));
  }, [themesAvailableForSelection]);
  var themesSelected = themesWithChecked.filter(function (theme) {
    return theme.checked;
  });
  var themesToShow = themesWithChecked.filter(function (theme) {
    return theme.show;
  });
  var isEmpty = isEmptyState({
    allThemes: allThemes,
    themesAvailableForSelection: themesAvailableForSelection
  });

  // Need to update when theme checked
  var handleThemeChange = function handleThemeChange(_ref70) {
    var themeId = _ref70.themeId,
      checked = _ref70.checked;
    setThemesWithChecked(function (prevThemes) {
      return prevThemes.map(function (theme) {
        return themeId === theme.id ? Object.assign({}, theme, {
          checked: checked
        }) : theme;
      });
    });
  };

  // Trigger addition of themes to a response
  var handleSaveThemes = function handleSaveThemes() {
    addThemesToResponse(themesSelected.map(function (theme) {
      return theme.id;
    }));
    setShowThemeMenu(false);
    setSearch('');
    setSearchDisabled(false);
  };

  // Trigger theme creation and add to response
  var handleThemeCreationForResponse = function handleThemeCreationForResponse() {
    var validation = validateTheme({
      themes: allThemes,
      themeName: search
    });
    setError(validation);
    if (!validation.error) {
      createThemeForResponse(search);
      setShowThemeMenu(false);
      setSearch('');
      setSearchDisabled(false);
    }
  };

  // Search for themes
  var handleSearch = function handleSearch(e) {
    var searchPhrase = e.currentTarget.value;
    setSearch(searchPhrase);
    setError(NO_ERRORS);
    setThemesWithChecked(filterCheckedThemesBySearch({
      searchPhrase: searchPhrase,
      themes: themesWithChecked
    }));
  };
  var handleSearchDisable = function handleSearchDisable(themes, themeId, currentElementChecked) {
    setSearchDisabled(currentElementChecked || themes.filter(function (theme) {
      return theme.id !== themeId;
    }).some(function (theme) {
      return theme.checked;
    }));
  };
  return /*#__PURE__*/jsx(Box, {
    className: classes.container,
    px: 3,
    children: /*#__PURE__*/jsxs(Menu, {
      placement: "bottom-left",
      show: showThemeMenu,
      onChange: function onChange(show) {
        return setShowThemeMenu(show);
      },
      menuTrigger: /*#__PURE__*/jsx(LinkStyleButton, {
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$r.addThemeButton
        })
      }),
      children: [/*#__PURE__*/jsx(Menu.Group, {
        children: /*#__PURE__*/jsx(Box, {
          py: 4,
          px: 3,
          children: /*#__PURE__*/jsx(Input, Object.assign({
            ariaLabel: t(COPY$r.label),
            label: t(COPY$r.label),
            value: search,
            disabled: searchDisabled,
            placeholder: isEmpty ? t(COPY$r.placeholderNoThemes) : t(COPY$r.placeholder),
            onChange: handleSearch
          }, error.error && {
            color: 'warning',
            errorMessage: /*#__PURE__*/jsx(Box, {
              className: classes.error,
              children: error.messages.map(function (message) {
                return /*#__PURE__*/jsx(Typography, {
                  component: "p",
                  variant: "body",
                  color: "warning",
                  children: message
                }, message);
              })
            })
          }))
        })
      }), /*#__PURE__*/jsx(Menu.Group, {
        children: /*#__PURE__*/jsx(Fragment, {
          children: themesToShow.map(function (theme) {
            return /*#__PURE__*/jsx(Menu.Item, {
              onClick: function onClick(e) {
                var _e$target$parentEleme, _e$target;
                // when clicking on the checkbox label, a double event was firing
                var parentId = (_e$target$parentEleme = (_e$target = e.target) == null || (_e$target = _e$target.parentElement) == null ? void 0 : _e$target.id) != null ? _e$target$parentEleme : '';
                if (parentId.startsWith('ThemeRow__Theme')) {
                  return;
                }
                handleThemeChange({
                  themeId: theme.id,
                  checked: !theme.checked
                });
                handleSearchDisable(themesToShow, theme.id, !theme.checked);
              },
              children: /*#__PURE__*/jsx(Box, {
                className: classes.checkbox,
                px: 3,
                children: /*#__PURE__*/jsx(ThemeRow, {
                  theme: theme,
                  search: search,
                  responseTextId: responseTextId
                })
              })
            }, "".concat(theme.id, "-").concat(responseTextId));
          })
        })
      }), /*#__PURE__*/jsx(Menu.Group, {
        children: /*#__PURE__*/jsx(AddButton, {
          allThemes: allThemes,
          themesSelected: themesSelected,
          search: search,
          disabled: error.error,
          handleSaveThemes: handleSaveThemes,
          handleThemeCreationForResponse: handleThemeCreationForResponse
        })
      })]
    })
  });
};
var useStyles$j = createUseStyles(function (theme) {
  return {
    chip: {
      '& div[class^="wrenchChip"]': {
        backgroundColor: 'white',
        color: theme.palette.text.darkMuted,
        border: "1px solid ".concat(theme.palette.border.muted),
        padding: "".concat(theme.spacing[1], "px ").concat(theme.spacing[3], "px")
      }
    }
  };
});
var ThemeBadge = function ThemeBadge(_ref71) {
  var _ref71$isGenerated = _ref71.isGenerated,
    _isGenerated = _ref71$isGenerated === void 0 ? false : _ref71$isGenerated,
    theme = _ref71.theme,
    onClose = _ref71.onClose;
  var _useStyles$j = useStyles$j(),
    chip = _useStyles$j.chip;
  return /*#__PURE__*/jsx(Box, {
    className: chip,
    children: /*#__PURE__*/jsx(Chip, {
      variant: "dismissible",
      onClick: onClose,
      children: /*#__PURE__*/jsxs(Fragment, {
        children: [_isGenerated && /*#__PURE__*/jsx(IconInsights, {
          title: "ml generated",
          size: "md",
          color: "info"
        }), /*#__PURE__*/jsx(Box, {
          display: "inline",
          ml: 1,
          children: theme
        })]
      })
    })
  });
};
var COPY$q = {
  button: {
    id: 'OpenEndedCoding.ThemeSelector.button',
    defaultMessage: 'Add theme',
    description: '[Type: Header][Vis: med] - button text theme selection'
  },
  responseText: {
    id: 'OpenEndedCoding.ThemeSelector.responseText',
    defaultMessage: 'Response ID {respondentId}',
    description: '[Type: Header][Vis: med] - response text ID CTM'
  }
};
var useStyles$i = createUseStyles(function (theme) {
  return {
    bullet: {
      color: theme.palette.text.darkMuted
    },
    badges: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      maxWidth: '500px'
    }
  };
});
var BulletItem = function BulletItem(_ref72) {
  var children = _ref72.children,
    _ref72$showBullet = _ref72.showBullet,
    _showBullet = _ref72$showBullet === void 0 ? false : _ref72$showBullet;
  var classes = useStyles$i();
  return /*#__PURE__*/jsxs(Box, {
    display: "inline",
    children: [/*#__PURE__*/jsx(Typography, {
      component: "span",
      variant: "bodySm",
      color: "darkMuted",
      children: children
    }), _showBullet && /*#__PURE__*/jsx(Box, {
      px: 1,
      display: "inline",
      className: classes.bullet,
      children: "\u2022"
    })]
  });
};
var getSentimentIcon = function getSentimentIcon(sentiment) {
  var _sentimentIcon;
  var sentimentIcon = (_sentimentIcon = {}, _defineProperty(_sentimentIcon, OECSentiment.SM_POSITIVE, /*#__PURE__*/jsx(IconFaceHappy, {
    title: "positive",
    color: "success",
    size: "md"
  })), _defineProperty(_sentimentIcon, OECSentiment.SM_NEGATIVE, /*#__PURE__*/jsx(IconFaceSad, {
    title: "negative",
    color: "error",
    size: "md"
  })), _defineProperty(_sentimentIcon, OECSentiment.SM_NEUTRAL, /*#__PURE__*/jsx(IconFaceNeutral, {
    title: "neutral",
    size: "md",
    color: "upgrade"
  })), _defineProperty(_sentimentIcon, OECSentiment.SM_UNDETECTED, /*#__PURE__*/jsx(IconHelpFilled, {
    title: "undetected",
    size: "md",
    color: "error"
  })), _sentimentIcon);
  return sentimentIcon[sentiment];
};
var ResponseCard = function ResponseCard(_ref73) {
  var response = _ref73.response;
  var classes = useStyles$i();
  var _useContext = useContext(OpenEndedCodingContext),
    handleCreateThemeForResponse = _useContext.handleCreateThemeForResponse,
    handleAddThemesToResponse = _useContext.handleAddThemesToResponse,
    handleRemoveThemesFromResponse = _useContext.handleRemoveThemesFromResponse;
  var _useGeneral6 = useGeneral(),
    isSolutions = _useGeneral6.isSolutions;
  var _useThemes4 = useThemes(),
    themes = _useThemes4.themes;
  var _useResponses = useResponses(),
    showSA = _useResponses.showSA;
  var themesForResponse = buildThemesForResponse({
    response: response,
    themes: themes
  });
  var hasThemes = themesForResponse.length > 0;
  var themesAvailableForSelection = themes.filter(function (theme) {
    return themesForResponse.filter(function (responseTheme) {
      var _theme$autogeneratedT;
      return theme.id === responseTheme.id || (theme == null || (_theme$autogeneratedT = theme.autogeneratedTag) == null ? void 0 : _theme$autogeneratedT.id) === responseTheme.id;
    }).length === 0;
  });
  var theDate = new Date(response.date);
  return /*#__PURE__*/jsxs(Box, {
    py: 4,
    children: [/*#__PURE__*/jsxs(Box, {
      display: "flex",
      mb: 3,
      alignItems: "center",
      children: [showSA && response.sentiment !== OECSentiment.SM_NOT_ENABLED && /*#__PURE__*/jsx(Box, {
        mr: 1,
        children: getSentimentIcon(response.sentiment)
      }), /*#__PURE__*/jsx(Typography, {
        component: "p",
        variant: "body",
        children: response.content
      })]
    }), /*#__PURE__*/jsxs(Box, {
      className: classes.badges,
      children: [hasThemes && themesForResponse.map(function (_ref74) {
        var id = _ref74.id,
          theme = _ref74.theme,
          tagType = _ref74.tagType;
        return /*#__PURE__*/jsx(Box, {
          mr: 2,
          mb: 3,
          children: /*#__PURE__*/jsx(ThemeBadge, {
            isGenerated: tagType === OECTagType.OECMODEL,
            theme: theme,
            onClose: function onClose() {
              return handleRemoveThemesFromResponse(id, response.responseTextId);
            }
          })
        }, id);
      }), /*#__PURE__*/jsx(ThemeMenu, {
        responseTextId: response.responseTextId,
        allThemes: themes,
        themesAvailableForSelection: themesAvailableForSelection,
        addThemesToResponse: function addThemesToResponse(themeIds) {
          return handleAddThemesToResponse(themeIds, response.responseTextId);
        },
        createThemeForResponse: function createThemeForResponse(name) {
          return handleCreateThemeForResponse(name, response.responseTextId);
        }
      })]
    }), /*#__PURE__*/jsxs(Box, {
      children: [isSolutions && /*#__PURE__*/jsx(BulletItem, {
        showBullet: true,
        children: /*#__PURE__*/jsx("span", {
          dangerouslySetInnerHTML: {
            __html: sanitizeString(response.stimulus)
          }
        })
      }), /*#__PURE__*/jsx(BulletItem, {
        showBullet: true,
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$q.responseText,
          values: {
            respondentId: response.respondentId
          }
        })
      }), /*#__PURE__*/jsx(BulletItem, {
        children: /*#__PURE__*/jsx("time", {
          dateTime: theDate.toISOString(),
          children: /*#__PURE__*/jsx(FormattedDateTime, {
            value: theDate,
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric",
            timeZone: "utc"
          })
        })
      })]
    })]
  });
};
var COPY$p = {
  positive: {
    id: 'OpenEndedCoding.SentimentStats.positive',
    defaultMessage: 'Positive',
    description: '[Type: Header][Vis: med] - Positive sentiment stats'
  },
  neutral: {
    id: 'OpenEndedCoding.SentimentStats.neutral',
    defaultMessage: 'Neutral',
    description: '[Type: Header][Vis: med] - Neutral sentiment stats'
  },
  negative: {
    id: 'OpenEndedCoding.SentimentStats.negative',
    defaultMessage: 'Negative',
    description: '[Type: Header][Vis: med] - Negative sentiment stats'
  },
  undetected: {
    id: 'OpenEndedCoding.SentimentStats.undetected',
    defaultMessage: 'Unknown',
    description: '[Type: Header][Vis: med] - Undetected sentiment stats'
  }
};
var getSentimentPercentage = function getSentimentPercentage(_ref75) {
  var saCount = _ref75.saCount,
    totalSaCounts = _ref75.totalSaCounts;
  if (totalSaCounts === 0) {
    return 0;
  }
  return saCount / totalSaCounts;
};
var SentimentRow = function SentimentRow(_ref76) {
  var _sentimentCopy;
  var sentiment = _ref76.sentiment,
    saCount = _ref76.saCount,
    totalSaCounts = _ref76.totalSaCounts;
  var _useContext2 = useContext(OpenEndedCodingContext),
    filterResponses = _useContext2.filterResponses;
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    checked = _useState22[0],
    setChecked = _useState22[1];
  var sentimentCopy = (_sentimentCopy = {}, _defineProperty(_sentimentCopy, OECSentiment.SM_POSITIVE, t(COPY$p.positive)), _defineProperty(_sentimentCopy, OECSentiment.SM_NEGATIVE, t(COPY$p.negative)), _defineProperty(_sentimentCopy, OECSentiment.SM_NEUTRAL, t(COPY$p.neutral)), _defineProperty(_sentimentCopy, OECSentiment.SM_UNDETECTED, t(COPY$p.undetected)), _sentimentCopy);
  var _useFiltersActions = useFiltersActions(),
    setSelectedSentiment = _useFiltersActions.setSelectedSentiment;
  var _useFilters = useFilters(),
    selectedSentiment = _useFilters.selectedSentiment;
  var _createUseStyles = createUseStyles({
      noOverflow: function noOverflow() {
        return {
          overflow: 'hidden'
        };
      }
    })(),
    noOverflow = _createUseStyles.noOverflow;
  return /*#__PURE__*/jsxs(Grid, {
    noGutters: true,
    noBleeds: true,
    fluid: true,
    mb: 3,
    children: [/*#__PURE__*/jsx(Grid.Item, {
      xs: 2,
      children: /*#__PURE__*/jsx(Box, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        children: /*#__PURE__*/jsx(Checkbox, {
          id: "".concat(sentiment, "-sentimentCheckbox"),
          "data-testid": "".concat(sentiment, "-sentimentCheckbox"),
          value: sentiment,
          checked: selectedSentiment.includes(sentiment) || checked,
          onChange: function onChange(e) {
            var newSentiments = e.target.checked ? [].concat(_toConsumableArray(selectedSentiment), [sentiment]) : selectedSentiment.filter(function (s) {
              return s !== sentiment;
            });
            setChecked(newSentiments.includes(sentiment));
            filterResponses({
              sentiments: newSentiments
            });
            setSelectedSentiment(newSentiments);
          }
        })
      })
    }), /*#__PURE__*/jsx(Grid.Item, {
      xs: 2,
      children: /*#__PURE__*/jsx(Box, {
        className: noOverflow,
        justifyContent: "center",
        alignItems: "center",
        px: 1,
        children: getSentimentIcon(sentiment)
      })
    }), /*#__PURE__*/jsx(Grid.Item, {
      xs: 4,
      children: /*#__PURE__*/jsx(Box, {
        className: noOverflow,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        children: /*#__PURE__*/jsx(Typography, {
          component: "span",
          variant: "bodySm",
          children: sentimentCopy[sentiment]
        })
      })
    }), /*#__PURE__*/jsx(Grid.Item, {
      xs: 2,
      children: /*#__PURE__*/jsx(Box, {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        children: /*#__PURE__*/jsx(Typography, {
          component: "span",
          variant: "bodySm",
          weight: "medium",
          children: /*#__PURE__*/jsx(FormattedNumber, {
            formatStyle: "percent",
            value: getSentimentPercentage({
              saCount: saCount,
              totalSaCounts: totalSaCounts
            })
          })
        })
      })
    }), /*#__PURE__*/jsx(Grid.Item, {
      xs: 2,
      children: /*#__PURE__*/jsx(Box, {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        children: /*#__PURE__*/jsx(Typography, {
          component: "span",
          variant: "bodySm",
          children: saCount
        })
      })
    })]
  });
};
var COPY$o = {
  title: {
    id: 'OpenEndedCoding.SentimentStats.title',
    defaultMessage: 'Sentiment',
    description: '[Type: Header][Vis: med] - Header for sentiment stats'
  }
};
var SentimentStats = function SentimentStats() {
  var _useResponses2 = useResponses(),
    saStats = _useResponses2.saStats;
  var positiveCount = saStats.positive,
    negativeCount = saStats.negative,
    neutralCount = saStats.neutral,
    undetectedCount = saStats.undetected;
  var totalCount = positiveCount + negativeCount + neutralCount + undetectedCount;
  return /*#__PURE__*/jsxs(Box, {
    children: [/*#__PURE__*/jsx(Box, {
      mb: 5,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h5",
        variant: "cardTitle",
        weight: "medium",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$o.title
        })
      })
    }), /*#__PURE__*/jsxs(Box, {
      mr: 1,
      flexDirection: "column",
      children: [/*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(SentimentRow, {
          sentiment: OECSentiment.SM_POSITIVE,
          saCount: positiveCount,
          totalSaCounts: totalCount
        })
      }), /*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(SentimentRow, {
          sentiment: OECSentiment.SM_NEUTRAL,
          saCount: neutralCount,
          totalSaCounts: totalCount
        })
      }), /*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(SentimentRow, {
          sentiment: OECSentiment.SM_NEGATIVE,
          saCount: negativeCount,
          totalSaCounts: totalCount
        })
      }), /*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(SentimentRow, {
          sentiment: OECSentiment.SM_UNDETECTED,
          saCount: undetectedCount,
          totalSaCounts: totalCount
        })
      })]
    })]
  });
};
var COPY$n = {
  title: {
    id: 'OpenEndedCoding.ThemeSelector.title',
    defaultMessage: 'Themes',
    description: '[Type: Header][Vis: med] - Header for theme selection'
  },
  emptyStateRepeatedly: {
    id: 'OpenEndedCoding.ThemeSelector.emptyStateRepeatedly',
    defaultMessage: 'As you read your responses, you’ll probably notice some topics, or <strong>themes</strong>, come up repeatedly.',
    description: '[Type: Header][Vis: med] - empty state theme selection'
  },
  emptyStateThematic: {
    id: 'OpenEndedCoding.ThemeSelector.emptyStateThematic',
    defaultMessage: 'These themes can reveal important concepts and patterns in your data. <strong>Thematic analysis</strong> is the process of identifying what these themes are and where they appear.',
    description: '[Type: Header][Vis: med] - empty state theme selection'
  },
  button: {
    id: 'OpenEndedCoding.ThemeSelector.button',
    defaultMessage: 'Create theme',
    description: '[Type: Header][Vis: med] - button text theme selection'
  },
  error: {
    id: 'OpenEndedCoding.ThemeSelector.error',
    defaultMessage: "We couldn't load your themes",
    description: '[Type: Header][Vis: med] - OEC load themes error'
  }
};
var ThemeSelector = function ThemeSelector(_ref77) {
  var createdSource = _ref77.createdSource,
    showDeleteThemeModal = _ref77.showDeleteThemeModal,
    showEditThemeModal = _ref77.showEditThemeModal,
    showCreateThemeModal = _ref77.showCreateThemeModal,
    showChangeUseCaseModal = _ref77.showChangeUseCaseModal,
    setShowDeleteThemeModal = _ref77.setShowDeleteThemeModal,
    setShowEditThemeModal = _ref77.setShowEditThemeModal,
    setShowCreateThemeModal = _ref77.setShowCreateThemeModal,
    setShowChangeUseCaseModal = _ref77.setShowChangeUseCaseModal,
    setCreatedSource = _ref77.setCreatedSource;
  var _useContext3 = useContext(OpenEndedCodingContext),
    deleteThemeHandler = _useContext3.deleteThemeHandler,
    updateThemeHandler = _useContext3.updateThemeHandler,
    createThemeHandler = _useContext3.createThemeHandler,
    getKeywords = _useContext3.getKeywords;
  var _useThemes5 = useThemes(),
    themesLoading = _useThemes5.themesLoading,
    themesError = _useThemes5.themesError;
  useRetraining();
  var _useResponses3 = useResponses(),
    showSA = _useResponses3.showSA;
  var _useState23 = useState(),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedTheme = _useState24[0],
    setSelectedTheme = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    previousUseCase = _useState26[0],
    setPreviousUseCase = _useState26[1];
  var onDelete = function onDelete() {
    if (selectedTheme) {
      deleteThemeHandler(selectedTheme);
    }
    setSelectedTheme(undefined);
  };
  var onSave = function onSave(name) {
    // Update the name of the theme
    if (selectedTheme) {
      updateThemeHandler(selectedTheme, name);
    }
    setSelectedTheme(undefined);
  };
  var onCreateTheme = function onCreateTheme(name) {
    createThemeHandler(name);
    setSelectedTheme(undefined);
  };

  // need to fetch keywords when user opens modal
  var onClickEdit = function onClickEdit(themeId) {
    getKeywords();
    setSelectedTheme(themeId);
    setShowEditThemeModal(true);
  };
  var ThemesComponent = function ThemesComponent() {
    if (themesLoading) {
      return /*#__PURE__*/jsx(ThemesSkeleton, {});
    }
    if (themesError) {
      return /*#__PURE__*/jsx(FiveHundredError, {
        title: t(COPY$n.error)
      });
    }
    return /*#__PURE__*/jsx(ThemeSection, {
      onClickDelete: function onClickDelete(themeId) {
        setSelectedTheme(themeId);
        setShowDeleteThemeModal(true);
      },
      onClickEdit: onClickEdit
    });
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Box, {
      py: 5,
      pl: 6,
      pr: 4,
      children: [/*#__PURE__*/jsx(Box, {
        mb: 5,
        children: /*#__PURE__*/jsx(Typography, {
          component: "h5",
          variant: "cardTitle",
          children: /*#__PURE__*/jsx("strong", {
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$n.title
            })
          })
        })
      }), /*#__PURE__*/jsx(Box, {
        mb: 3,
        children: ThemesComponent()
      }), /*#__PURE__*/jsx(Box, {
        mb: 5,
        children: /*#__PURE__*/jsx(LinkStyleButton, {
          onClick: function onClick() {
            setShowCreateThemeModal(true);
            setCreatedSource(OECCreatedSource.THEMES);
          },
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$n.button
          })
        })
      }), COLD_START_ENABLED, showSA && /*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(SentimentStats, {})
      })]
    }), /*#__PURE__*/jsx(DeleteThemeModal, {
      show: showDeleteThemeModal,
      onClose: function onClose() {
        setShowDeleteThemeModal(false);
        setSelectedTheme(undefined);
      },
      onDelete: onDelete
    }), /*#__PURE__*/jsx(ChangeUseCaseModal, {
      show: showChangeUseCaseModal,
      previousUseCase: previousUseCase,
      onClose: function onClose() {
        setShowChangeUseCaseModal(false);
      }
    }), /*#__PURE__*/jsx(EditThemeModal, {
      show: showEditThemeModal,
      selectedThemeId: selectedTheme,
      onClose: function onClose() {
        setShowEditThemeModal(false);
        setSelectedTheme(undefined);
      },
      onSave: onSave
    }), /*#__PURE__*/jsx(AddThemeModal, {
      show: showCreateThemeModal,
      createdSource: createdSource,
      selectedThemeId: selectedTheme,
      onClose: function onClose() {
        setShowCreateThemeModal(false);
        setSelectedTheme(undefined);
      },
      onCreate: onCreateTheme
    })]
  });
};

// simplify using intervals with react hooks
function useInterval(callback, delay) {
  var savedCallback = useRef(function () {
    return undefined;
  });

  // Remember the latest callback.
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  /* eslint-disable-next-line consistent-return */
  useEffect(function () {
    if (delay === 0) {
      return;
    }
    var id = setInterval(function () {
      savedCallback.current();
    }, delay);
    return function () {
      return clearInterval(id);
    };
  }, [delay]);
}
var COPY$m = {
  pendingTitle: {
    id: 'oec.ExportToastPending.PendingTitle',
    defaultMessage: 'Preparing your export.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the title of export pending prompt'
  },
  pendingBody: {
    id: 'oec.ExportToastPending.PendingBody',
    defaultMessage: 'Your download will begin automatically.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the body of export pending prompt'
  }
};
var ToastPending = function ToastPending() {
  return /*#__PURE__*/jsxs(Toast, {
    autoClose: false,
    children: [/*#__PURE__*/jsx(Toast.Title, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$m.pendingTitle
      })
    }), /*#__PURE__*/jsx(Toast.Body, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$m.pendingBody
      })
    })]
  });
};
var COPY$l = {
  errorTitle: {
    id: 'oec.ExportToastError.ErrorTitle',
    defaultMessage: 'Error fetching export.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the title of export error prompt'
  },
  errorBody: {
    id: 'oec.ExportToastError.ErrorBody',
    defaultMessage: 'Please try refreshing the page or contact customer support.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the body of export error prompt'
  }
};
var ToastError = function ToastError() {
  return /*#__PURE__*/jsxs(Toast, {
    dismissible: true,
    autoClose: false,
    children: [/*#__PURE__*/jsxs(Toast.Title, {
      children: [/*#__PURE__*/jsxs("span", {
        children: [/*#__PURE__*/jsx(IconWarningFilled, {
          color: "error",
          size: "md",
          title: ""
        }), "\xA0"]
      }), /*#__PURE__*/jsx(T, {
        desc: COPY$l.errorTitle
      })]
    }), /*#__PURE__*/jsx(Toast.Body, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$l.errorBody
      })
    })]
  });
};
var _$g = function _$g(t) {
    return t;
  },
  _t$g;
var createOECQuestionResponseExport = gql(_t$g || (_t$g = _$g(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  mutation createOECQuestionResponseExport($surveyId: ID!, $questionId: ID!, $respondentCount: Int!) {\n    createOECQuestionResponseExport(surveyId: $surveyId, questionId: $questionId, respondentCount: $respondentCount) {\n      id\n      status\n    }\n  }\n"])))));
var _$f = function _$f(t) {
    return t;
  },
  _t$f;
var oecExportJobQuery = gql(_t$f || (_t$f = _$f(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  query oecExportJobQuery($surveyId: ID!, $id: ID!) {\n    analysisExportJob(surveyId: $surveyId, id: $id) {\n      id\n      status\n      file {\n        downloadLink\n        name\n      }\n    }\n  }\n"])))));
var COPY$k = {
  button: {
    id: 'OpenEndedCoding.Export.button',
    defaultMessage: 'Export',
    description: '[Type: Header][Vis: med] - Button to export data'
  }
};
var EXPORT_JOB_STATUS = /*#__PURE__*/function (EXPORT_JOB_STATUS) {
  EXPORT_JOB_STATUS["SERVER_ERROR"] = "SERVER_ERROR";
  EXPORT_JOB_STATUS["ENQUEUED"] = "ENQUEUED";
  EXPORT_JOB_STATUS["STARTED"] = "STARTED";
  EXPORT_JOB_STATUS["SUCCESS"] = "SUCCESS";
  return EXPORT_JOB_STATUS;
}(EXPORT_JOB_STATUS || {});
var FETCH_JOBS_INTERVAL$1 = 10000;
var ExportButton = function ExportButton(_ref78) {
  var surveyId = _ref78.surveyId,
    questionId = _ref78.questionId,
    respondentCount = _ref78.respondentCount;
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    disabled = _useState28[0],
    setDisabled = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    preparingExport = _useState30[0],
    setPreparingExport = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    exportError = _useState32[0],
    setExportError = _useState32[1];
  var _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    exportJobId = _useState34[0],
    setExportJobId = _useState34[1];

  // Queries

  var _useLazyQuery = useLazyQuery(oecExportJobQuery, {
      variables: {
        surveyId: surveyId,
        id: exportJobId
      },
      fetchPolicy: 'no-cache',
      onCompleted: function onCompleted(_ref79) {
        var _ref79$analysisExport = _ref79.analysisExportJob,
          id = _ref79$analysisExport.id,
          status = _ref79$analysisExport.status,
          file = _ref79$analysisExport.file;
        if (status === EXPORT_JOB_STATUS.SUCCESS && file != null && file.downloadLink) {
          window.location.href = file == null ? void 0 : file.downloadLink;
          setDisabled(false);
          setPreparingExport(false);
        } else if (status === EXPORT_JOB_STATUS.SERVER_ERROR) {
          setPreparingExport(false);
          setExportError(true);
          setDisabled(false);
        }
      },
      onError: function onError() {}
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 1),
    queryExportJobStatus = _useLazyQuery2[0];

  // Mutations

  var _useMutation3 = useMutation(createOECQuestionResponseExport, {
      onCompleted: function onCompleted(_ref80) {
        var _ref80$createOECQuest = _ref80.createOECQuestionResponseExport,
          id = _ref80$createOECQuest.id,
          status = _ref80$createOECQuest.status;
        if (status === EXPORT_JOB_STATUS.ENQUEUED) {
          setExportJobId(id);
          setPreparingExport(true);
        } else if (status === EXPORT_JOB_STATUS.SERVER_ERROR) {
          setDisabled(false);
          setPreparingExport(false);
          setExportError(true);
        }
      },
      onError: function onError() {
        setDisabled(false);
        setPreparingExport(false);
        setExportError(true);
      }
    }),
    _useMutation4 = _slicedToArray(_useMutation3, 1),
    createOECExport = _useMutation4[0];
  useInterval(function () {
    if (!preparingExport) {
      return;
    }
    queryExportJobStatus({
      variables: {
        surveyId: surveyId,
        id: exportJobId
      }
    });
  }, preparingExport ? FETCH_JOBS_INTERVAL$1 : 0);
  var startExport = function startExport() {
    setDisabled(true);
    setPreparingExport(true);
    void createOECExport({
      variables: {
        surveyId: surveyId,
        questionId: questionId,
        respondentCount: respondentCount
      }
    });
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Button, {
      variant: "ghost",
      color: "alt",
      disabled: disabled,
      onClick: function onClick() {
        return startExport();
      },
      marginWidth: 1,
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$k.button
      })
    }), preparingExport && /*#__PURE__*/jsx(ToastPending, {}), exportError && /*#__PURE__*/jsx(ToastError, {})]
  });
};
var COPY$j = {
  title: {
    id: 'OpenEndedCoding.AutoTaggingEmptyState.title',
    defaultMessage: 'Auto-tagging',
    description: '[Type: Header][Vis: med] - Header for auto tagging'
  },
  helperTitle: {
    id: 'OpenEndedCoding.AutoTaggingEmptyState.helperTitle',
    defaultMessage: 'Let AI tag these responses for you',
    description: '[Type: Header][Vis: med] - Helper header for auto tagging'
  },
  helperTextReview: {
    id: 'OpenEndedCoding.AutoTaggingEmptyState.helperTextReview',
    defaultMessage: 'Our text analysis model can automatically review and tag your responses with the relevant themes.',
    description: '[Type: Header][Vis: med] - Helper text for auto tagging'
  },
  helperTextAdd: {
    id: 'OpenEndedCoding.AutoTaggingEmptyState.helperTextAdd',
    defaultMessage: 'Create your themes and tag a few responses to get started!',
    description: '[Type: Header][Vis: med] - Helper text for auto tagging'
  },
  createTheme: {
    id: 'OpenEndedCoding.AutoTaggingEmptyState.createTheme',
    defaultMessage: 'Create theme',
    description: '[Type: Header][Vis: med] - Create theme'
  }
};
var useStyles$h = createUseStyles(function (theme) {
  return {
    helper: {
      backgroundColor: '#EEF9FE',
      padding: theme.spacing[4]
    }
  };
});
var EmptyState = function EmptyState(_ref81) {
  var setShowCreateThemeModal = _ref81.setShowCreateThemeModal,
    setCreatedSource = _ref81.setCreatedSource;
  var classes = useStyles$h();
  return /*#__PURE__*/jsxs(Box, {
    py: 5,
    px: 6,
    "data-testid": "EmptyState__OecAutotagging",
    children: [/*#__PURE__*/jsx(Box, {
      mb: 5,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h5",
        variant: "cardTitle",
        children: /*#__PURE__*/jsx("strong", {
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$j.title
          })
        })
      })
    }), /*#__PURE__*/jsxs(Box, {
      className: classes.helper,
      children: [/*#__PURE__*/jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/jsx(Typography, {
          component: "h6",
          variant: "cardTitle",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$j.helperTitle
          })
        })
      }), /*#__PURE__*/jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/jsx(Typography, {
          component: "p",
          variant: "bodySm",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$j.helperTextReview
          })
        })
      }), /*#__PURE__*/jsx(Box, {
        mb: 4,
        children: /*#__PURE__*/jsx(Typography, {
          component: "p",
          variant: "bodySm",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$j.helperTextAdd
          })
        })
      }), /*#__PURE__*/jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/jsx(Button, {
          color: "link",
          onClick: function onClick() {
            setShowCreateThemeModal(true);
            setCreatedSource(OECCreatedSource.AUTO_TAGGING);
          },
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$j.createTheme
          })
        })
      })]
    })]
  });
};
var COPY$i = {
  firstStep: {
    id: 'OpenEndedCoding.ProgressState.firstStep',
    defaultMessage: 'Create at least { amount } themes',
    description: '[Type: Header][Vis: med] - First step'
  },
  secondStep: {
    id: 'OpenEndedCoding.ProgressState.secondStep',
    defaultMessage: 'Tag at least { amount } ({ percentage }%) responses',
    description: '[Type: Header][Vis: med] - Second step'
  },
  thirdStep: {
    id: 'OpenEndedCoding.ProgressState.thirdStep',
    defaultMessage: 'Apply each theme to at least { amount } responses',
    description: '[Type: Header][Vis: med] - Third step'
  },
  progressCircle: {
    id: 'OpenEndedCoding.ProgressState.progressCircle',
    defaultMessage: 'tagging step',
    description: '[Type: Header][Vis: med] - progress circle'
  }
};
var useStyles$g = createUseStyles(function (theme) {
  return {
    icons: {
      marginLeft: 0,
      marginRight: theme.spacing[2]
    },
    check: {
      color: theme.palette.text.light,
      // TODO: MLEXP-784 Move stray hex codes into a constants file
      backgroundColor: '#2CB2F1',
      borderRadius: '50%',
      padding: theme.spacing[2],
      // need to center the checkmark
      '& > svg': {
        marginLeft: '2px'
      }
    }
  };
});
var ProgressStep = function ProgressStep(_ref82) {
  var text = _ref82.text,
    _ref82$inProgress = _ref82.inProgress,
    _inProgress = _ref82$inProgress === void 0 ? false : _ref82$inProgress;
  var classes = useStyles$g();
  return /*#__PURE__*/jsxs(Box, {
    display: "flex",
    alignItems: "center",
    children: [/*#__PURE__*/jsx(Box, {
      className: classes.icons,
      children: _inProgress ? /*#__PURE__*/jsx(ProgressCircle, {
        continuous: true,
        size: "sm",
        color: "info",
        valueText: t(COPY$i.progressCircle)
      }) : /*#__PURE__*/jsx(Box, {
        className: classes.check,
        children: /*#__PURE__*/jsx(IconCheck, {
          title: "icon check",
          size: "md"
        })
      })
    }), /*#__PURE__*/jsx(Typography, {
      component: "p",
      variant: "bodySm",
      children: text
    })]
  });
};
var COPY$h = {
  title: {
    id: 'OpenEndedCoding.ProgressState.title',
    defaultMessage: 'Auto-tagging',
    description: '[Type: Header][Vis: med] - Header for auto tagging'
  },
  helperTitle: {
    id: 'OpenEndedCoding.ProgressState.helperTitle',
    defaultMessage: 'Let AI tag these responses for you',
    description: '[Type: Header][Vis: med] - Helper header for auto tagging'
  },
  helperText: {
    id: 'OpenEndedCoding.ProgressState.helperText',
    defaultMessage: 'Our model learns from you. To start auto-tagging:',
    description: '[Type: Header][Vis: med] - Helper text for auto tagging'
  },
  start: {
    id: 'OpenEndedCoding.ProgressState.start',
    defaultMessage: 'Start auto-tagging',
    description: '[Type: Header][Vis: med] - Start auto tagging'
  }
};
var useStyles$f = createUseStyles(function (theme) {
  return {
    helper: {
      backgroundColor: '#EEF9FE',
      padding: theme.spacing[4]
    }
  };
});
var ProgressState = function ProgressState(_ref83) {
  var notEnoughThemesCreated = _ref83.notEnoughThemesCreated,
    notEnoughResponsesTagged = _ref83.notEnoughResponsesTagged,
    applyThemeToMoreResponses = _ref83.applyThemeToMoreResponses;
  var classes = useStyles$f();
  var _useGeneral7 = useGeneral(),
    surveyId = _useGeneral7.surveyId,
    questionId = _useGeneral7.questionId,
    isSolutions = _useGeneral7.isSolutions;
  var _useResponses4 = useResponses(),
    responsesTotal = _useResponses4.responsesTotal;
  var _useTrainingActions = useTrainingActions(),
    setShowTrainingScreen = _useTrainingActions.setShowTrainingScreen;
  var amount = Math.ceil(responsesTotal * (PERCENT_TO_TAG / 100.0));
  var ProgressSection = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressStep, {
        inProgress: notEnoughThemesCreated,
        text: t(COPY$i.firstStep, {
          amount: MIN_NUMBER_OF_THEMES
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressStep, {
        inProgress: notEnoughResponsesTagged,
        text: t(COPY$i.secondStep, {
          amount: amount,
          percentage: PERCENT_TO_TAG
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressStep, {
        inProgress: applyThemeToMoreResponses,
        text: t(COPY$i.thirdStep, {
          amount: NUMBER_OF_RESPONSES
        })
      })
    })]
  });
  return /*#__PURE__*/jsxs(Box, {
    py: 5,
    px: 6,
    "data-testid": "ProgressState__OecAutotagging",
    children: [/*#__PURE__*/jsx(Box, {
      mb: 5,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h5",
        variant: "cardTitle",
        children: /*#__PURE__*/jsx("strong", {
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$h.title
          })
        })
      })
    }), /*#__PURE__*/jsxs(Box, {
      className: classes.helper,
      children: [/*#__PURE__*/jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/jsx(Typography, {
          component: "h6",
          variant: "cardTitle",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$h.helperTitle
          })
        })
      }), /*#__PURE__*/jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/jsx(Typography, {
          component: "p",
          variant: "body",
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$h.helperText
          })
        })
      }), ProgressSection, /*#__PURE__*/jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/jsx(Button, {
          disabled: notEnoughThemesCreated || notEnoughResponsesTagged || applyThemeToMoreResponses,
          color: "link",
          onClick: function onClick() {
            setShowTrainingScreen(true);

            // tracking
            trackAmplitudeEvent({
              amplitudeEvent: 'open-ended coding started auto-tagging',
              data: {
                surveyId: surveyId,
                questionId: questionId,
                pageName: isSolutions ? 'ctm' : 'analyze'
              }
            });
          },
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$h.start
          })
        })
      })]
    })]
  });
};
var COPY$g = {
  title: {
    id: 'OpenEndedCoding.AutoTaggingRetrainingState.title',
    defaultMessage: "Once you make changes, we'll do the rest!",
    description: '[Type: Header][Vis: med] - header for retraining'
  },
  textReview: {
    id: 'OpenEndedCoding.AutoTaggingRetrainingState.textReview',
    defaultMessage: 'When you make significant changes - like adding or deleting a theme or a theme tag on a response - rerunning the model gives you more accurate tags.',
    description: '[Type: Header][Vis: med] - Helper text for retraining'
  },
  update: {
    id: 'OpenEndedCoding.AutoTaggingRetrainingState.update',
    defaultMessage: 'To update auto-tagging:',
    description: '[Type: Header][Vis: med] - Update auto tagging instructions'
  },
  instructions: {
    id: 'OpenEndedCoding.AutoTaggingRetrainingState.instructions',
    defaultMessage: 'Review themes and auto-tags',
    description: '[Type: Header][Vis: med] - Update auto tagging approve tags'
  },
  instructionsLabel: {
    id: 'OpenEndedCoding.AutoTaggingRetrainingState.instructionsLabel',
    defaultMessage: 'info update auto tags',
    description: '[Type: Header][Vis: med] - Update auto tagging approve tags label'
  },
  updateButton: {
    id: 'OpenEndedCoding.AutoTaggingRetrainingState.updateButton',
    defaultMessage: 'Update auto-tagging',
    description: '[Type: Header][Vis: med] - update auto-tagging button'
  },
  keywordsButton: {
    id: 'OpenEndedCoding.AutoTaggingRetrainingState.keywordsButton',
    defaultMessage: 'View & edit keywords',
    description: '[Type: Header][Vis: med] - update keywords button'
  }
};
var useStyles$e = createUseStyles(function (theme) {
  return {
    container: {
      backgroundColor: '#EEF9FE',
      padding: "".concat(theme.spacing[4], "px ").concat(theme.spacing[5], "px"),
      margin: "".concat(theme.spacing[5], "px ").concat(theme.spacing[6], "px")
    },
    icon: {
      marginLeft: 0,
      marginRight: theme.spacing[2],
      color: theme.palette.text.light,
      // TODO: MLEXP-784 Move stray hex codes into a constants file
      backgroundColor: '#2CB2F1',
      borderRadius: '50%',
      padding: theme.spacing[2]
    }
  };
});
var InfoStep = function InfoStep(_ref84) {
  var text = _ref84.text;
  var classes = useStyles$e();
  return /*#__PURE__*/jsxs(Box, {
    display: "flex",
    alignItems: "center",
    children: [/*#__PURE__*/jsx(Box, {
      className: classes.icon,
      children: /*#__PURE__*/jsx(IconLightbulb, {
        title: t(COPY$g.instructionsLabel),
        size: "md"
      })
    }), /*#__PURE__*/jsx(Typography, {
      component: "p",
      variant: "bodySm",
      children: text
    })]
  });
};
var RetrainingState = function RetrainingState() {
  var classes = useStyles$e();
  var _useRetraining = useRetraining(),
    trainingStatus = _useRetraining.trainingStatus,
    notEnoughThemesCreated = _useRetraining.notEnoughThemesCreated,
    notEnoughResponsesTagged = _useRetraining.notEnoughResponsesTagged,
    applyThemeToMoreResponses = _useRetraining.applyThemeToMoreResponses,
    notEnoughThemesCreatedStep = _useRetraining.notEnoughThemesCreatedStep,
    notEnoughResponsesTaggedStep = _useRetraining.notEnoughResponsesTaggedStep,
    applyThemeToMoreResponsesStep = _useRetraining.applyThemeToMoreResponsesStep;
  var _useThemes6 = useThemes(),
    themesChanged = _useThemes6.themesChanged,
    themesAdded = _useThemes6.themesAdded,
    themesDeleted = _useThemes6.themesDeleted,
    keywords = _useThemes6.keywords;
  var _useResponses5 = useResponses(),
    responsesChanged = _useResponses5.responsesChanged,
    significantChangesResponses = _useResponses5.significantChangesResponses,
    responsesTotal = _useResponses5.responsesTotal;
  var _useTrainingActions2 = useTrainingActions(),
    setTrainingStep = _useTrainingActions2.setTrainingStep,
    setShowTrainingScreen = _useTrainingActions2.setShowTrainingScreen,
    setMultipleTrainingFields = _useTrainingActions2.setMultiple;
  var _useRetrainingActions = useRetrainingActions(),
    setNotEnoughThemesCreatedStep = _useRetrainingActions.setNotEnoughThemesCreatedStep,
    setNotEnoughResponsesTaggedStep = _useRetrainingActions.setNotEnoughResponsesTaggedStep,
    setApplyThemeToMoreResponsesStep = _useRetrainingActions.setApplyThemeToMoreResponsesStep;
  var amount = Math.ceil(responsesTotal * (PERCENT_TO_TAG / 100.0));
  var retrainAllowed = isRetrainAllowed({
    trainingStatus: trainingStatus,
    themesAdded: themesAdded,
    themesDeleted: themesDeleted,
    significantChangesResponses: significantChangesResponses,
    applyThemeToMoreResponses: applyThemeToMoreResponses,
    notEnoughResponsesTagged: notEnoughResponsesTagged,
    notEnoughThemesCreated: notEnoughThemesCreated,
    notEnoughThemesCreatedStep: notEnoughThemesCreatedStep,
    notEnoughResponsesTaggedStep: notEnoughResponsesTaggedStep,
    applyThemeToMoreResponsesStep: applyThemeToMoreResponsesStep
  });
  var canEditKeywords = !notEnoughThemesCreated && !applyThemeToMoreResponses && !notEnoughResponsesTagged && !retrainAllowed;

  // a minimum number of themes must be created
  useEffect(function () {
    retrainProgressHandler({
      themesChanged: themesChanged,
      responsesChanged: responsesChanged,
      value: notEnoughThemesCreated,
      progressValue: notEnoughThemesCreatedStep,
      setProgressValue: function setProgressValue(step) {
        return setNotEnoughThemesCreatedStep(step);
      }
    });
  }, [notEnoughThemesCreated, notEnoughThemesCreatedStep, themesChanged, responsesChanged, setNotEnoughThemesCreatedStep]);

  // a minimum number of responses must be tagged
  useEffect(function () {
    retrainProgressHandler({
      themesChanged: themesChanged,
      responsesChanged: responsesChanged,
      value: notEnoughResponsesTagged,
      progressValue: notEnoughResponsesTaggedStep,
      setProgressValue: function setProgressValue(step) {
        return setNotEnoughResponsesTaggedStep(step);
      }
    });
  }, [notEnoughResponsesTagged, notEnoughResponsesTaggedStep, themesChanged, responsesChanged, setNotEnoughResponsesTaggedStep]);

  // each theme must be applied to a certain number of responses
  useEffect(function () {
    retrainProgressHandler({
      themesChanged: themesChanged,
      responsesChanged: responsesChanged,
      value: applyThemeToMoreResponses,
      progressValue: applyThemeToMoreResponsesStep,
      setProgressValue: function setProgressValue(step) {
        return setApplyThemeToMoreResponsesStep(step);
      }
    });
  }, [applyThemeToMoreResponses, applyThemeToMoreResponsesStep, themesChanged, responsesChanged, setApplyThemeToMoreResponsesStep]);
  var ProgressSection = /*#__PURE__*/jsxs(Fragment, {
    children: [!isRetrainStepHidden(notEnoughThemesCreatedStep) && /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressStep, {
        inProgress: isRetrainStepInProgress(notEnoughThemesCreatedStep),
        text: t(COPY$i.firstStep, {
          amount: MIN_NUMBER_OF_THEMES
        })
      })
    }), !isRetrainStepHidden(notEnoughResponsesTaggedStep) && /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressStep, {
        inProgress: isRetrainStepInProgress(notEnoughResponsesTaggedStep),
        text: t(COPY$i.secondStep, {
          amount: amount,
          percentage: PERCENT_TO_TAG
        })
      })
    }), !isRetrainStepHidden(applyThemeToMoreResponsesStep) && /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressStep, {
        inProgress: isRetrainStepInProgress(applyThemeToMoreResponsesStep),
        text: t(COPY$i.thirdStep, {
          amount: NUMBER_OF_RESPONSES
        })
      })
    })]
  });
  return /*#__PURE__*/jsxs(Box, {
    className: classes.container,
    "data-testid": "RetrainingState__OecAutotagging",
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h6",
        variant: "cardTitle",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$g.title
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "p",
        variant: "bodySm",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$g.textReview
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "p",
        variant: "bodySm",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$g.update
        })
      })
    }), themesChanged || responsesChanged ? ProgressSection : /*#__PURE__*/jsx(Box, {
      mb: 4,
      children: /*#__PURE__*/jsx(InfoStep, {
        text: t(COPY$g.instructions)
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Button, {
        disabled: !retrainAllowed,
        color: "link",
        size: "sm",
        onClick: function onClick() {
          setShowTrainingScreen(true);
          setTrainingStep(TRAINING_STEP.KEYWORD_GENERATION);
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$g.updateButton
        })
      })
    }), canEditKeywords && /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(LinkStyleButton, {
        onClick: function onClick() {
          setShowTrainingScreen(true);
          setMultipleTrainingFields({
            trainingStep: TRAINING_STEP.KEYWORDS_VIEWING,
            unsavedKeywords: transformKeywords({
              keywords: keywords
            })
          });
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$g.keywordsButton
        })
      })
    })]
  });
};
var AutoTaggingSkeleton = function AutoTaggingSkeleton() {
  return /*#__PURE__*/jsx(Box, {
    display: "flex",
    flexJustify: "center",
    children: /*#__PURE__*/jsx(Box, {
      m: 4,
      children: /*#__PURE__*/jsxs(SkeletonLoader, {
        "data-testid": "AutoTaggingSkeleton",
        height: 500,
        width: 250,
        children: [/*#__PURE__*/jsx("rect", {
          x: "0",
          y: "30",
          rx: "0",
          ry: "0",
          width: "300",
          height: "50"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "130",
          rx: "0",
          ry: "0",
          width: "300",
          height: "30"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "180",
          rx: "0",
          ry: "0",
          width: "300",
          height: "30"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "230",
          rx: "0",
          ry: "0",
          width: "300",
          height: "30"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "280",
          rx: "0",
          ry: "0",
          width: "300",
          height: "30"
        })]
      })
    })
  });
};
var COPY$f = {
  title: {
    id: 'OpenEndedCoding.AutoTaggingDonut.title',
    defaultMessage: 'Auto-tagging',
    description: '[Type: Header][Vis: med] - Title for auto-tagging results'
  },
  legendTitle: {
    id: 'OpenEndedCoding.AutoTaggingDonut.legendTitle',
    defaultMessage: 'Responses',
    description: '[Type: Header][Vis: med] - Title for auto-tagging results legend'
  },
  manuallyTagged: {
    id: 'OpenEndedCoding.AutoTaggingDonut.manuallyTagged',
    defaultMessage: 'Tagged manually',
    description: '[Type: Header][Vis: med] - Donut chart manual tagging'
  },
  autoTagged: {
    id: 'OpenEndedCoding.AutoTaggingDonut.autoTagged',
    defaultMessage: 'Auto-tagged',
    description: '[Type: Header][Vis: med] - Donut chart manual tagging'
  },
  untagged: {
    id: 'OpenEndedCoding.AutoTaggingDonut.untagged',
    defaultMessage: 'Not tagged',
    description: '[Type: Header][Vis: med] - Donut chart manual tagging'
  }
};

// smquestions donut chart options
var numberOfResponses = 0;
var manuallyTaggedColor = '#D5F0FC';
var autotaggedColor = '#2CB2F1';
var untaggedColor = '#D0D2D3';

// highchart options
var options = {
  chart: {
    height: 110
  },
  plotOptions: {
    pie: {
      innerSize: '50%',
      dataLabels: {
        enabled: false
      },
      size: 100
    }
  }
};
var useStyles$d = createUseStyles(function (theme) {
  return {
    legend: _defineProperty({
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      paddingRight: "".concat(theme.spacing[5], "px"),
      paddingLeft: "".concat(theme.spacing[5], "px")
    }, "@media (min-width: ".concat(theme.breakpoints.sm, "px)"), {
      paddingRight: "".concat(theme.spacing[1], "px"),
      paddingLeft: "".concat(theme.spacing[1], "px")
    }),
    legendRow: _defineProperty({
      display: 'flex',
      alignContent: 'center',
      marginBottom: "".concat(theme.spacing[1], "px")
    }, "@media (min-width: ".concat(theme.breakpoints.sm, "px)"), {
      justifyContent: 'space-between'
    }),
    bullet: {
      fontSize: "".concat(theme.spacing[2], "px"),
      margin: "auto ".concat(theme.spacing[2], "px auto 0")
    },
    manuallyTagged: {
      color: manuallyTaggedColor
    },
    autotagged: {
      color: autotaggedColor
    },
    untagged: {
      color: untaggedColor
    }
  };
});
var buildDonutData = function buildDonutData(_ref85) {
  var counts = _ref85.counts;
  return [{
    name: t(COPY$f.manuallyTagged),
    color: manuallyTaggedColor,
    value: counts.manualTaggedCount,
    numberOfResponses: numberOfResponses
  }, {
    name: t(COPY$f.autoTagged),
    color: autotaggedColor,
    value: counts.autoTaggedCount,
    numberOfResponses: numberOfResponses
  }, {
    name: t(COPY$f.untagged),
    color: untaggedColor,
    value: counts.untaggedCount,
    numberOfResponses: numberOfResponses
  }];
};
var LegendRow = function LegendRow(_ref86) {
  var text = _ref86.text,
    value = _ref86.value,
    className = _ref86.className;
  var classes = useStyles$d();
  return /*#__PURE__*/jsxs(Box, {
    className: classes.legendRow,
    children: [/*#__PURE__*/jsxs(Box, {
      display: "flex",
      mr: 2,
      children: [/*#__PURE__*/jsx(Box, {
        className: classNames(classes.bullet, className),
        children: "\u2B24"
      }), /*#__PURE__*/jsx(Typography, {
        component: "p",
        variant: "bodySm",
        children: /*#__PURE__*/jsx(T, {
          desc: text
        })
      })]
    }), /*#__PURE__*/jsx(Typography, {
      component: "p",
      variant: "bodySm",
      color: "secondary",
      children: value
    })]
  });
};
var AutoTaggingLegend = function AutoTaggingLegend(_ref87) {
  var counts = _ref87.counts;
  var classes = useStyles$d();
  return /*#__PURE__*/jsxs(Box, {
    className: classes.legend,
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h6",
        children: /*#__PURE__*/jsx("strong", {
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$f.legendTitle
          })
        })
      })
    }), /*#__PURE__*/jsx(LegendRow, {
      value: counts.manualTaggedCount,
      text: COPY$f.manuallyTagged,
      className: classes.manuallyTagged
    }), /*#__PURE__*/jsx(LegendRow, {
      value: counts.autoTaggedCount,
      text: COPY$f.autoTagged,
      className: classes.autotagged
    }), /*#__PURE__*/jsx(LegendRow, {
      value: counts.untaggedCount,
      text: COPY$f.untagged,
      className: classes.untagged
    })]
  });
};
var DonutChart = function DonutChart(_ref88) {
  var themes = _ref88.themes,
    responsesTotal = _ref88.responsesTotal;
  var themesPerResponse = getThemesPerResponse$1(themes);
  var counts = calculateTrainingCounts({
    responses: themesPerResponse,
    responsesTotal: responsesTotal,
    themesTotal: themes.length
  });
  return /*#__PURE__*/jsxs(Box, {
    py: 5,
    "data-testid": "DonutChart__OecAutotagging",
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      px: 6,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h5",
        variant: "cardTitle",
        children: /*#__PURE__*/jsx("strong", {
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$f.title
          })
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mt: 5,
      pl: 3,
      pr: 5,
      children: /*#__PURE__*/jsxs(Grid, {
        noBleeds: true,
        noGutters: true,
        fluid: true,
        children: [/*#__PURE__*/jsx(Grid.Item, {
          xs: 12,
          sm: 5,
          md: 5,
          lg: 12,
          xl: 5,
          children: /*#__PURE__*/jsx(Box, {
            mt: 2,
            children: /*#__PURE__*/jsx(DonutChart$1, {
              data: buildDonutData({
                counts: counts
              }),
              options: options
            })
          })
        }), /*#__PURE__*/jsx(Grid.Item, {
          xs: 12,
          sm: 7,
          md: 7,
          lg: 12,
          xl: 7,
          children: /*#__PURE__*/jsx(AutoTaggingLegend, {
            counts: counts
          })
        })]
      })
    })]
  });
};
var COPY$e = {
  header: {
    id: 'OpenEndedCoding.UpdateAutotaggingModal.header',
    defaultMessage: 'Update auto-tagging to see more accurate results',
    description: '[Type: Header][Vis: med] - Header for Update autotagging Modal'
  },
  description: {
    id: 'OpenEndedCoding.UpdateAutotaggingModal.description',
    defaultMessage: 'You’ve made significant changes to your theme analysis since the last time you ran auto-tagging. For more accurate results, update auto-tagging to reflect these changes.',
    description: '[Type: Header][Vis: med] - Update autotagging Modal description'
  },
  skip: {
    id: 'OpenEndedCoding.UpdateAutotaggingModal.skip',
    defaultMessage: 'Skip',
    description: '[Type: Header][Vis: med] - Update autotagging Modal skip button'
  },
  update: {
    id: 'OpenEndedCoding.UpdateAutotaggingModal.update',
    defaultMessage: 'Update auto-tagging',
    description: '[Type: Header][Vis: med] - Update autotagging Modal update button'
  }
};
var UpdateAutotaggingModal = function UpdateAutotaggingModal(_ref89) {
  var show = _ref89.show,
    onSkip = _ref89.onSkip,
    onUpdate = _ref89.onUpdate;
  return /*#__PURE__*/jsxs(Modal, {
    "data-testid": "UpdateAutotaggingModal__OEC",
    show: show,
    onClose: onSkip,
    children: [/*#__PURE__*/jsx(Modal.Header, {
      header: t(COPY$e.header)
    }), /*#__PURE__*/jsx(Modal.Body, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$e.description
      })
    }), /*#__PURE__*/jsxs(Modal.Footer, {
      align: "right",
      children: [/*#__PURE__*/jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: onSkip,
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$e.skip
        })
      }), /*#__PURE__*/jsx(Button, {
        onClick: onUpdate,
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$e.update
        })
      })]
    })]
  });
};
var useStyles$c = createUseStyles(function () {
  return {
    results: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }
  };
});
var AutoTagging = function AutoTagging(_ref90) {
  var setShowCreateThemeModal = _ref90.setShowCreateThemeModal,
    setCreatedSource = _ref90.setCreatedSource;
  var classes = useStyles$c();
  var _useContext4 = useContext(OpenEndedCodingContext),
    setShowOecModal = _useContext4.setShowOecModal;
  var _useGeneral8 = useGeneral(),
    showUpdateAutotaggingModal = _useGeneral8.showUpdateAutotaggingModal;
  var _useThemes7 = useThemes(),
    themesLoading = _useThemes7.themesLoading,
    themes = _useThemes7.themes,
    themesChanged = _useThemes7.themesChanged;
  var _useResponses6 = useResponses(),
    responsesTotal = _useResponses6.responsesTotal,
    responsesChanged = _useResponses6.responsesChanged;
  var _useRetraining2 = useRetraining(),
    trainingStatus = _useRetraining2.trainingStatus,
    notEnoughThemesCreated = _useRetraining2.notEnoughThemesCreated,
    notEnoughResponsesTagged = _useRetraining2.notEnoughResponsesTagged,
    applyThemeToMoreResponses = _useRetraining2.applyThemeToMoreResponses;
  var _useGeneralActions2 = useGeneralActions(),
    setShowUpdateAutotaggingModal = _useGeneralActions2.setShowUpdateAutotaggingModal;
  var _useTrainingActions3 = useTrainingActions(),
    setShowTrainingScreen = _useTrainingActions3.setShowTrainingScreen;
  var showDonut = isAutoTaggingComplete(trainingStatus) && !(themesChanged || responsesChanged);
  var AutoTaggingComponent = function AutoTaggingComponent() {
    if (themesLoading) {
      return /*#__PURE__*/jsx(AutoTaggingSkeleton, {});
    }
    if (isAutoTaggingComplete(trainingStatus)) {
      return /*#__PURE__*/jsxs(Box, {
        className: classes.results,
        children: [showDonut && /*#__PURE__*/jsx(DonutChart, {
          themes: themes,
          responsesTotal: responsesTotal
        }), /*#__PURE__*/jsx(RetrainingState, {})]
      });
    }
    if (themes.length > 0 && !isAutoTaggingComplete(trainingStatus)) {
      return /*#__PURE__*/jsx(ProgressState, {
        notEnoughThemesCreated: notEnoughThemesCreated,
        notEnoughResponsesTagged: notEnoughResponsesTagged,
        applyThemeToMoreResponses: applyThemeToMoreResponses
      });
    }
    return /*#__PURE__*/jsx(EmptyState, {
      setShowCreateThemeModal: setShowCreateThemeModal,
      setCreatedSource: setCreatedSource
    });
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [AutoTaggingComponent(), /*#__PURE__*/jsx(UpdateAutotaggingModal, {
      show: showUpdateAutotaggingModal,
      onSkip: function onSkip() {
        setShowUpdateAutotaggingModal(false);

        // need to close the modal
        setShowOecModal(false);
      },
      onUpdate: function onUpdate() {
        // show training screen
        setShowUpdateAutotaggingModal(false);
        setShowTrainingScreen(true);
      }
    })]
  });
};
var useStyles$b = createUseStyles(function (theme) {
  return {
    trigger: {
      '& > button': {
        borderColor: BORDER_COLOR,
        padding: "0 ".concat(theme.spacing[3], "px"),
        '&:hover, &:focus': {
          backgroundColor: BACKGROUND_COLOR_HOVER,
          borderColor: BORDER_COLOR_HOVER,
          outline: 0,
          boxShadow: '0px 2px 4px 0px rgb(0 0 0 / 14%)',
          transition: 'border-color 100ms ease 0s'
        }
      }
    },
    menu: {
      // style the checkbox blue
      '& input[class^="wrenchCheckboxNative"]:checked + span[class^="wrenchCheckboxFaux"]': {
        background: BLUE_CHECK,
        borderColor: BLUE_CHECK
      },
      '& input[class^="wrenchCheckboxNative"]:focus:checked + span[class^="wrenchCheckboxFaux"]': {
        borderColor: "".concat(BLUE_CHECK, " !important"),
        boxShadow: 'none !important'
      }
    }
  };
});
var MultiSelect = function MultiSelect(_ref91) {
  var title = _ref91.title,
    values = _ref91.values,
    label = _ref91.label,
    _ref91$disabled = _ref91.disabled,
    _disabled = _ref91$disabled === void 0 ? false : _ref91$disabled,
    handleSelect = _ref91.handleSelect;
  var classes = useStyles$b();
  var wrapperRef = useRef(null);
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    showMenu = _useState36[0],
    setShowMenu = _useState36[1];

  // handle clicks outside menu
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  var allOption = values.find(function (v) {
    return v.id === ALL_FILTER_ID;
  });
  var shouldDisableAllOption = function shouldDisableAllOption(id) {
    if (!allOption || allOption.id === id) {
      return false;
    }
    return allOption.selected;
  };
  var trigger = /*#__PURE__*/jsx(Box, {
    className: classes.trigger,
    children: /*#__PURE__*/jsxs(Button, {
      color: "secondary",
      variant: "ghost",
      size: "md",
      disabled: _disabled,
      children: [/*#__PURE__*/jsx(Typography, {
        color: "dark",
        children: title
      }), /*#__PURE__*/jsx(IconCaretDown, {
        title: "arrow down",
        color: "dark"
      })]
    })
  });
  return /*#__PURE__*/jsxs("div", {
    ref: wrapperRef,
    className: classes.menu,
    children: [label && /*#__PURE__*/jsx(Box, {
      mb: 2,
      children: /*#__PURE__*/jsx(Typography, {
        component: "strong",
        variant: "bodySm",
        color: "dark",
        children: label
      })
    }), /*#__PURE__*/jsx(Menu, {
      "data-testid": "Menu__".concat(title),
      dense: true,
      noRules: true,
      menuTrigger: trigger,
      autoClose: false,
      show: showMenu,
      onChange: function onChange(show) {
        return setShowMenu(show);
      },
      children: values.map(function (_ref92) {
        var id = _ref92.id,
          menuLabel = _ref92.label,
          selected = _ref92.selected;
        return /*#__PURE__*/jsx(Menu.Item, {
          addOn: /*#__PURE__*/jsx(Checkbox, {
            "data-testid": "Checkbox-".concat(id),
            id: "checkbox-".concat(id),
            checked: selected || shouldDisableAllOption(id),
            value: id,
            disabled: shouldDisableAllOption(id),
            onChange: function onChange() {
              return handleSelect({
                id: id
              });
            }
          }),
          addOnPlacement: "left",
          onClick: function onClick() {
            if (!shouldDisableAllOption(id)) {
              handleSelect({
                id: id
              });
            }
          },
          children: menuLabel
        }, "".concat(title, "-").concat(id));
      })
    })]
  });
};
var COPY$d = {
  filters: {
    id: 'OpenEndedCoding.Filters.filters',
    defaultMessage: 'Filter by',
    description: '[Type: Header][Vis: med] - Filter by label OEC'
  },
  searchPlaceholder: {
    id: 'OpenEndedCoding.Filters.searchPlaceholder',
    defaultMessage: 'Enter text',
    description: '[Type: Header][Vis: med] - Filters search placeholder OEC'
  },
  sortBy: {
    id: 'OpenEndedCoding.Filters.sortBy',
    defaultMessage: 'Sort by',
    description: '[Type: Header][Vis: med] - Sort by label OEC'
  },
  mostRecent: {
    id: 'OpenEndedCoding.Filters.mostRecent',
    defaultMessage: 'Most recent',
    description: '[Type: Header][Vis: med] - Sort by most recent OEC'
  },
  alphabetically: {
    id: 'OpenEndedCoding.Filters.alphabetically',
    defaultMessage: 'A to Z',
    description: '[Type: Header][Vis: med] - Sort by A - Z OEC'
  },
  apply: {
    id: 'OpenEndedCoding.Filters.apply',
    defaultMessage: 'Apply',
    description: '[Type: Header][Vis: med] - filters apply button OEC'
  },
  themes: {
    id: 'OpenEndedCoding.Filters.themes',
    defaultMessage: 'Themes',
    description: '[Type: Header][Vis: med] - themes filter OEC'
  },
  stimuli: {
    id: 'OpenEndedCoding.Filters.stimuli',
    defaultMessage: 'Stimuli',
    description: '[Type: Header][Vis: med] - stimuli filter OEC'
  }
};
var useStyles$a = createUseStyles(function (theme) {
  return {
    form: {
      marginY: theme.spacing[4],
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end'
    },
    selectMenu: {
      // style the check blue
      '& div[class^="wrenchListAddon"] svg': {
        fill: BLUE_CHECK
      },
      // need a narrower select menu trigger
      '& span[class^="wrenchMenuContainer"] > div[class^="wrenchSelectMenu"]': {
        padding: '0px 42px 0px 12px'
      }
    }
  };
});
var Filters = function Filters() {
  var classes = useStyles$a();

  // the search value used when fetching responses
  var _useContext5 = useContext(OpenEndedCodingContext),
    filterResponses = _useContext5.filterResponses;
  var _useStimuli = useStimuli(),
    stimuli = _useStimuli.stimuli;
  var _useThemes8 = useThemes(),
    themes = _useThemes8.themes;
  var _useGeneral9 = useGeneral(),
    isSolutions = _useGeneral9.isSolutions;
  var _useFilters2 = useFilters(),
    searchInput = _useFilters2.searchInput,
    sortValue = _useFilters2.sortValue,
    filterDisabled = _useFilters2.filterDisabled,
    selectedThemes = _useFilters2.selectedThemes,
    selectedStimuli = _useFilters2.selectedStimuli;
  var _useFiltersActions2 = useFiltersActions(),
    setFilterDisabled = _useFiltersActions2.setFilterDisabled,
    setMultipleFilterFields = _useFiltersActions2.setMultiple;

  // filter the responses using sort by, themes, stimuli and search phrase
  var executeFilter = function executeFilter() {
    // there are manually generated themes and autogenerated themes.
    // these are essentially duplicates but we only use the manually
    // generated themes for the filter. we also need to include the
    // autogenerated IDs when making the request to the backend.
    var autoGeneratedIds = themes.reduce(function (result, theme) {
      var _theme$autogeneratedT;
      var selected = selectedThemes.includes(theme.id);
      var autogeneratedId = (_theme$autogeneratedT = theme.autogeneratedTag) == null ? void 0 : _theme$autogeneratedT.id;
      if (selected && autogeneratedId) {
        return [].concat(_toConsumableArray(result), [autogeneratedId]);
      }
      return result;
    }, []);
    filterResponses(Object.assign({}, {
      search: searchInput,
      sortBy: sortValue,
      themeIds: [].concat(_toConsumableArray(selectedThemes), _toConsumableArray(autoGeneratedIds))
    }, isSolutions && {
      stimulusIds: selectedStimuli
    }));
    setFilterDisabled(true);
  };

  // handle sorting
  var handleSortByChange = function handleSortByChange(e) {
    var value = e.currentTarget.getAttribute('data-value');
    if (value) {
      setMultipleFilterFields({
        sortValue: value,
        filterDisabled: false
      });
    }
  };

  // set the search input value
  var handleSearchChange = function handleSearchChange(e) {
    setMultipleFilterFields({
      searchInput: e.currentTarget.value,
      filterDisabled: false
    });
  };

  // handle enter search input
  var handleSearchOnKeyDown = function handleSearchOnKeyDown(e) {
    if (e.key === 'Enter' && !filterDisabled) {
      executeFilter();
    }
  };

  // theme filter
  var handleThemeSelect = function handleThemeSelect(_ref93) {
    var id = _ref93.id;
    // this acts as a togggle
    // remove the theme if it already exists, include it if it doesn't exist
    setMultipleFilterFields({
      filterDisabled: false,
      selectedThemes: selectedThemes.includes(id) ? selectedThemes.filter(function (tid) {
        return tid !== id;
      }) : [].concat(_toConsumableArray(selectedThemes), [id])
    });
  };

  // stimulus filter
  var handleStimulusSelect = function handleStimulusSelect(_ref94) {
    var id = _ref94.id;
    // this acts as a togggle
    // remove the stimulus if it already exists, include it if it doesn't exist
    setMultipleFilterFields({
      filterDisabled: false,
      selectedStimuli: selectedStimuli.includes(id) ? selectedStimuli.filter(function (sid) {
        return sid !== id;
      }) : [].concat(_toConsumableArray(selectedStimuli), [id])
    });
  };
  return /*#__PURE__*/jsxs("form", {
    className: classes.form,
    "aria-controls": "responsesList",
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    },
    children: [/*#__PURE__*/jsx(Box, {
      mr: 2,
      className: classes.selectMenu,
      children: /*#__PURE__*/jsxs(SelectMenu, {
        "data-testid": "Filters__SortBy",
        label: t(COPY$d.sortBy),
        ariaLabel: t(COPY$d.sortBy),
        value: sortValue,
        name: t(COPY$d.sortBy),
        onChange: handleSortByChange,
        children: [/*#__PURE__*/jsx(SelectMenu.Option, {
          value: SORT_BY.DATE,
          children: t(COPY$d.mostRecent)
        }), /*#__PURE__*/jsx(SelectMenu.Option, {
          value: SORT_BY.ALPHABETICALLY,
          children: t(COPY$d.alphabetically)
        })]
      })
    }), isSolutions && /*#__PURE__*/jsx(Box, {
      mr: 2,
      children: /*#__PURE__*/jsx(MultiSelect, {
        title: t(COPY$d.stimuli),
        values: stimuli.map(function (_ref95) {
          var id = _ref95.id,
            name = _ref95.name;
          return {
            id: id,
            label: name,
            selected: selectedStimuli.includes(id)
          };
        }),
        label: t(COPY$d.filters),
        handleSelect: handleStimulusSelect
      })
    }), /*#__PURE__*/jsx(Box, {
      mr: 2,
      children: /*#__PURE__*/jsx(MultiSelect, {
        title: t(COPY$d.themes),
        values: [{
          id: ALL_FILTER_ID,
          label: ALL_RESPONSES,
          selected: selectedThemes.includes(ALL_FILTER_ID)
        }].concat(_toConsumableArray(themes.map(function (_ref96) {
          var id = _ref96.id,
            theme = _ref96.theme;
          return {
            id: id,
            label: theme,
            selected: selectedThemes.includes(id)
          };
        }))),
        handleSelect: handleThemeSelect,
        disabled: themes.length === 0
      })
    }), /*#__PURE__*/jsx(Box, {
      flexItemGrow: true,
      mr: 2,
      children: /*#__PURE__*/jsx(Input, {
        placeholder: t(COPY$d.searchPlaceholder),
        ariaLabel: t(COPY$d.filters),
        stretched: true,
        value: searchInput,
        onChange: handleSearchChange,
        onKeyDown: handleSearchOnKeyDown
      })
    }), /*#__PURE__*/jsx(Button, {
      disabled: filterDisabled,
      color: "link",
      onClick: function onClick() {
        return executeFilter();
      },
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$d.apply
      })
    })]
  });
};
createUseStyles(function (theme) {
  return {
    chip: {
      '& div[class^="wrenchChip"]': {
        backgroundColor: 'white',
        color: theme.palette.text.darkMuted,
        border: "1px solid ".concat(theme.palette.border.muted),
        padding: "".concat(theme.spacing[1], "px ").concat(theme.spacing[3], "px")
      }
    }
  };
});
createUseStyles(function (theme) {
  var border = "1px solid ".concat(theme.palette.border.main);
  return {
    separator: {
      borderRight: border,
      height: "".concat(theme.spacing[6], "px"),
      marginLeft: "".concat(theme.spacing[3], "px"),
      marginRight: "".concat(theme.spacing[3], "px"),
      marginTop: 'auto',
      marginBottom: 'auto'
    }
  };
});
createUseStyles(function (theme) {
  return {
    bullet: {
      color: theme.palette.text.darkMuted
    }
  };
});
createUseStyles(function (theme) {
  var border = "1px solid ".concat(theme.border.main);
  return {
    badges: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: "".concat(theme.spacing[3], "px")
    },
    separator: {
      borderRight: border,
      height: "".concat(theme.spacing[6], "px"),
      marginLeft: "".concat(theme.spacing[3], "px"),
      marginRight: "".concat(theme.spacing[3], "px"),
      marginTop: 'auto',
      marginBottom: 'auto'
    }
  };
});
var COPY$c = {
  header: {
    id: 'OpenEndedCoding.CreateSuggestedThemeModal.header',
    defaultMessage: 'Add theme and apply to response?',
    description: '[Type: Header][Vis: med] - Header for Create Suggested Theme Modal'
  },
  description: {
    id: 'OpenEndedCoding.CreateSuggestedThemeModal.description',
    defaultMessage: 'This will create a new theme that can then be applied to other responses.',
    description: '[Type: Header][Vis: med] - Create Suggested Theme Modal description'
  },
  cancel: {
    id: 'OpenEndedCoding.CreateSuggestedThemeModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Create Suggested Theme Modal cancel button'
  },
  create: {
    id: 'OpenEndedCoding.CreateSuggestedThemeModal.delete',
    defaultMessage: 'Add theme',
    description: '[Type: Header][Vis: med] - Create Suggested Theme Modal delete button'
  }
};
var CreateSuggestedThemeModal = function CreateSuggestedThemeModal(_ref97) {
  var show = _ref97.show,
    onClose = _ref97.onClose,
    onCreate = _ref97.onCreate;
  var _useGeneral10 = useGeneral(),
    surveyId = _useGeneral10.surveyId,
    questionId = _useGeneral10.questionId,
    isSolutions = _useGeneral10.isSolutions;
  return /*#__PURE__*/jsxs(Modal, {
    "data-testid": "CreateSuggestedThemeModal__OEC",
    show: show,
    onClose: onClose,
    children: [/*#__PURE__*/jsx(Modal.Header, {
      header: t(COPY$c.header)
    }), /*#__PURE__*/jsx(Modal.Body, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$c.description
      })
    }), /*#__PURE__*/jsxs(Modal.Footer, {
      align: "right",
      children: [/*#__PURE__*/jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: onClose,
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$c.cancel
        })
      }), /*#__PURE__*/jsx(Button, {
        color: "info",
        onClick: function onClick() {
          onCreate();
          onClose();

          // tracking
          trackAmplitudeEvent({
            amplitudeEvent: 'open-ended coding created theme',
            data: {
              surveyId: surveyId,
              questionId: questionId,
              pageName: isSolutions ? 'ctm' : 'analyze'
            }
          });
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$c.create
        })
      })]
    })]
  });
};
var ResponsesSkeleton = function ResponsesSkeleton() {
  return /*#__PURE__*/jsx(Box, {
    display: "flex",
    children: /*#__PURE__*/jsx(Box, {
      m: 4,
      children: /*#__PURE__*/jsxs(SkeletonLoader, {
        "data-testid": "ResponsesSkeleton",
        height: 600,
        width: 700,
        children: [/*#__PURE__*/jsx("rect", {
          x: "0",
          y: "40",
          rx: "0",
          ry: "0",
          width: "600",
          height: "80"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "160",
          rx: "0",
          ry: "0",
          width: "600",
          height: "80"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "280",
          rx: "0",
          ry: "0",
          width: "600",
          height: "80"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "400",
          rx: "0",
          ry: "0",
          width: "600",
          height: "80"
        }), /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "520",
          rx: "0",
          ry: "0",
          width: "600",
          height: "80"
        })]
      })
    })
  });
};
var COPY$b = {
  title: {
    id: 'OpenEndedCoding.Responses.title',
    defaultMessage: 'Responses ({responsesCount})',
    description: '[Type: Header][Vis: med] - Header for auto tagging'
  },
  titleStillLoading: {
    id: 'OpenEndedCoding.Responses.titleStillLoading',
    defaultMessage: 'Responses',
    description: '[Type: Header][Vis: med] - Header for auto tagging'
  },
  error: {
    id: 'OpenEndedCoding.Responses.error',
    defaultMessage: "We couldn't load your responses",
    description: '[Type: Header][Vis: med] - OEC load responses error'
  }
};
var useStyles$9 = createUseStyles({
  list: {
    // remove the default list item padding to maximize width
    // as the theme selector section has a reduced grid portion.
    '& [class^="wrenchListLabel"]': {
      padding: 0
    }
  }
});
var Responses = function Responses(_ref98) {
  var showCreateSuggestedThemeModal = _ref98.showCreateSuggestedThemeModal,
    setShowCreateSuggestedThemeModal = _ref98.setShowCreateSuggestedThemeModal;
  var classes = useStyles$9();
  var _useContext6 = useContext(OpenEndedCodingContext),
    setResponsesPage = _useContext6.setResponsesPage,
    handleCreateThemeForResponse = _useContext6.handleCreateThemeForResponse;
  var _useResponses7 = useResponses(),
    responses = _useResponses7.responses,
    responsesCount = _useResponses7.responsesCount,
    responsesLoading = _useResponses7.responsesLoading,
    responsesError = _useResponses7.responsesError,
    responsesPage = _useResponses7.responsesPage,
    responsesPageSize = _useResponses7.responsesPageSize;
  var _useThemesReuseAction2 = useThemesReuseActions(),
    setSuggestedThemesForResponse = _useThemesReuseAction2.setSuggestedThemesForResponse;
  useThemesReuse();
  var _useThemesReuse2 = useThemesReuse(),
    suggestedThemes = _useThemesReuse2.suggestedThemes;
  var paginatedResponses = getPaginatedResponses({
    responses: responses,
    responsesPage: responsesPage
  });
  var _useState37 = useState(null),
    _useState38 = _slicedToArray(_useState37, 2),
    suggestedTheme = _useState38[0],
    setSuggestedTheme = _useState38[1];
  var _useState39 = useState(null),
    _useState40 = _slicedToArray(_useState39, 2),
    suggestedThemeResponseTextId = _useState40[0],
    setSuggestedThemeResponseTextId = _useState40[1];
  var ResponsesComponent = function ResponsesComponent() {
    if (responsesLoading) {
      return /*#__PURE__*/jsx(ResponsesSkeleton, {});
    }
    if (responsesError) {
      return /*#__PURE__*/jsx(FiveHundredError, {
        title: t(COPY$b.error)
      });
    }
    return /*#__PURE__*/jsxs(List, {
      dense: true,
      id: "responsesList",
      children: [paginatedResponses.map(function (response) {
        return /*#__PURE__*/jsx(List.Item, {
          children: /*#__PURE__*/jsx(ResponseCard, {
            response: response
          }, response.responseTextId)
        }, response.responseTextId);
      }), /*#__PURE__*/jsx(List.Item, {
        children: /*#__PURE__*/jsx(Box, {
          pt: 4,
          children: /*#__PURE__*/jsx(Pagination, {
            page: responsesPage,
            count: responsesCount,
            rowsPerPage: responsesPageSize,
            onChangePage: function onChangePage(_, page) {
              return setResponsesPage(page);
            },
            onChangeRowsPerPage: function onChangeRowsPerPage() {
              return '';
            }
          })
        })
      })]
    });
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Box, {
      py: 5,
      px: 6,
      className: classes.list,
      children: [/*#__PURE__*/jsx(Box, {
        mb: 3,
        children: /*#__PURE__*/jsx(Typography, {
          component: "h5",
          variant: "cardTitle",
          children: /*#__PURE__*/jsx("strong", {
            children: (responsesLoading || responsesError) && responsesCount === 0 ? /*#__PURE__*/jsx(T, {
              desc: COPY$b.titleStillLoading
            }) : /*#__PURE__*/jsx(T, {
              desc: COPY$b.title,
              values: {
                responsesCount: responsesCount
              }
            })
          })
        })
      }), /*#__PURE__*/jsx(Filters, {}), ResponsesComponent()]
    }), /*#__PURE__*/jsx(CreateSuggestedThemeModal, {
      show: showCreateSuggestedThemeModal,
      onClose: function onClose() {
        setShowCreateSuggestedThemeModal(false);

        // clear values
        setSuggestedTheme(null);
        setSuggestedThemeResponseTextId(null);
      },
      onCreate: function onCreate() {
        if (suggestedTheme && suggestedThemeResponseTextId) {
          handleCreateThemeForResponse(suggestedTheme, suggestedThemeResponseTextId);

          // remove the suggested theme
          var suggested = suggestedThemes[suggestedThemeResponseTextId];
          if (suggested) {
            setSuggestedThemesForResponse(suggested.filter(function (s) {
              return s !== suggestedTheme;
            }), suggestedThemeResponseTextId);
          }
        }

        // clear values
        setSuggestedTheme(null);
        setSuggestedThemeResponseTextId(null);
      }
    })]
  });
};
var COPY$a = {
  title: {
    id: 'OpenEndedCoding.ManualTagging.title',
    defaultMessage: 'Thematic analysis for question "{questionText}"',
    description: '[Type: Header][Vis: med] - Header for open ended coding view'
  },
  button: {
    id: 'OpenEndedCoding.ManualTagging.button',
    defaultMessage: 'View visualization',
    description: '[Type: Header][Vis: med] - Button to view visualization'
  }
};
var useStyles$8 = createUseStyles(function (theme) {
  var _center;
  // We want to ensure the modal has a fixed height.
  // and doesn't increase in size once responses are loaded.
  var bodyHeight = '90vh';
  var border = "2px solid ".concat(theme.palette.border.main);
  return {
    header: _defineProperty({
      borderBottom: border,
      padding: "".concat(theme.spacing[6], "px ").concat(theme.spacing[7], "px"),
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column'
    }, "@media (min-width: ".concat(theme.breakpoints.md, "px)"), {
      flexDirection: 'row'
    }),
    left: _defineProperty({}, "@media (min-width: ".concat(theme.breakpoints.lg, "px)"), {
      height: bodyHeight,
      overflowY: 'scroll',
      overflowX: 'hidden'
    }),
    center: (_center = {}, _defineProperty(_center, "@media (min-width: ".concat(theme.breakpoints.lg, "px)"), {
      height: bodyHeight,
      overflowY: 'scroll',
      overflowX: 'hidden'
    }), _defineProperty(_center, "@media (min-width: ".concat(theme.breakpoints.md, "px)"), {
      borderLeft: border,
      borderRight: border
    }), _center),
    viewVisualization: {
      whiteSpace: 'nowrap'
    },
    buttons: _defineProperty({
      marginTop: "".concat(theme.spacing[4], "px")
    }, "@media (min-width: ".concat(theme.breakpoints.md, "px)"), {
      marginLeft: "".concat(theme.spacing[4], "px"),
      marginTop: 0
    })
  };
});
var Header$1 = function Header$1(_ref99) {
  var surveyId = _ref99.surveyId,
    questionId = _ref99.questionId,
    responsesCount = _ref99.responsesCount,
    questionText = _ref99.questionText,
    autoTaggingComplete = _ref99.autoTaggingComplete,
    isSolutions = _ref99.isSolutions,
    handleClose = _ref99.handleClose;
  var classes = useStyles$8();
  return /*#__PURE__*/jsxs(Box, {
    className: classes.header,
    children: [/*#__PURE__*/jsx(Typography, {
      component: "h4",
      variant: "sectionTitle",
      children: /*#__PURE__*/jsx("strong", {
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$a.title,
          values: {
            questionText: questionText
          }
        })
      })
    }), autoTaggingComplete && /*#__PURE__*/jsxs(Box, {
      display: "flex",
      align: "center",
      className: classes.buttons,
      children: [/*#__PURE__*/jsx(Box, {
        children: /*#__PURE__*/jsx(ExportButton, {
          surveyId: surveyId,
          questionId: questionId,
          respondentCount: responsesCount
        })
      }), /*#__PURE__*/jsx(Box, {
        ml: 2,
        children: /*#__PURE__*/jsx(Button, {
          variant: "ghost",
          color: "alt",
          onClick: function onClick() {
            handleClose();

            // tracking
            trackAmplitudeEvent({
              amplitudeEvent: 'open-ended coding viewed visualization',
              data: {
                surveyId: surveyId,
                questionId: questionId,
                pageName: isSolutions ? 'ctm' : 'analyze'
              }
            });
          },
          children: /*#__PURE__*/jsx("span", {
            className: classes.viewVisualization,
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$a.button
            })
          })
        })
      })]
    })]
  });
};
var ManualTagging = function ManualTagging(_ref100) {
  var questionText = _ref100.questionText,
    handleClose = _ref100.handleClose;
  var classes = useStyles$8();
  var _useGeneral11 = useGeneral(),
    surveyId = _useGeneral11.surveyId,
    questionId = _useGeneral11.questionId,
    isSolutions = _useGeneral11.isSolutions;
  var _useRetraining3 = useRetraining(),
    trainingStatus = _useRetraining3.trainingStatus;
  var _useResponses8 = useResponses(),
    responsesCount = _useResponses8.responsesCount;
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    showDeleteThemeModal = _useState42[0],
    setShowDeleteThemeModal = _useState42[1];
  var _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    showEditThemeModal = _useState44[0],
    setShowEditThemeModal = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    showCreateThemeModal = _useState46[0],
    setShowCreateThemeModal = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    showCreateSuggestedThemeModal = _useState48[0],
    setShowCreateSuggestedThemeModal = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    showChangeUseCaseModal = _useState50[0],
    setShowChangeUseCaseModal = _useState50[1];
  var _useState51 = useState(OECCreatedSource.THEMES),
    _useState52 = _slicedToArray(_useState51, 2),
    createdSource = _useState52[0],
    setCreatedSource = _useState52[1];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Header$1, {
      surveyId: surveyId,
      questionId: questionId,
      responsesCount: responsesCount,
      questionText: questionText,
      autoTaggingComplete: isAutoTaggingComplete(trainingStatus),
      isSolutions: isSolutions,
      handleClose: handleClose
    }), /*#__PURE__*/jsx(Modal.Body, {
      padding: false,
      children: /*#__PURE__*/jsxs(Grid, {
        noBleeds: true,
        noGutters: true,
        fluid: true,
        children: [/*#__PURE__*/jsx(Grid.Item, {
          xs: 12,
          sm: 12,
          md: 12,
          lg: 2,
          children: /*#__PURE__*/jsx(Box, {
            className: classes.left,
            children: /*#__PURE__*/jsx(ThemeSelector, {
              createdSource: createdSource,
              showDeleteThemeModal: showDeleteThemeModal,
              showEditThemeModal: showEditThemeModal,
              showCreateThemeModal: showCreateThemeModal,
              showChangeUseCaseModal: showChangeUseCaseModal,
              setCreatedSource: setCreatedSource,
              setShowDeleteThemeModal: setShowDeleteThemeModal,
              setShowEditThemeModal: setShowEditThemeModal,
              setShowCreateThemeModal: setShowCreateThemeModal,
              setShowChangeUseCaseModal: setShowChangeUseCaseModal
            })
          })
        }), /*#__PURE__*/jsx(Grid.Item, {
          xs: 12,
          sm: 12,
          md: 12,
          lg: 7,
          children: /*#__PURE__*/jsx(Box, {
            className: classes.center,
            children: /*#__PURE__*/jsx(Responses, {
              showCreateSuggestedThemeModal: showCreateSuggestedThemeModal,
              setShowCreateSuggestedThemeModal: setShowCreateSuggestedThemeModal
            })
          })
        }), /*#__PURE__*/jsx(Grid.Item, {
          xs: 12,
          sm: 12,
          md: 12,
          lg: 3,
          children: /*#__PURE__*/jsx(AutoTagging, {
            setShowCreateThemeModal: setShowCreateThemeModal,
            setCreatedSource: setCreatedSource
          })
        })]
      })
    })]
  });
};
var COPY$9 = {
  title: {
    id: 'OpenEndedCoding.KeywordGeneration.title',
    defaultMessage: 'Extracting keywords',
    description: '[Type: Header][Vis: med] - extracting keywords title'
  },
  time: {
    id: 'OpenEndedCoding.KeywordGeneration.time',
    defaultMessage: 'About 5 seconds',
    description: '[Type: Header][Vis: med] - time to extract keywords'
  },
  descriptionTheme: {
    id: 'OpenEndedCoding.KeywordGeneration.descriptionTheme',
    defaultMessage: 'Keywords are unique words associated with a theme.',
    description: '[Type: Header][Vis: med] - extracting keywords description'
  },
  descriptionReview: {
    id: 'OpenEndedCoding.KeywordGeneration.descriptionReview',
    defaultMessage: 'You’ll be able to review them in the next step.',
    description: '[Type: Header][Vis: med] - extracting keywords description'
  }
};
var KeywordGeneration = function KeywordGeneration() {
  return /*#__PURE__*/jsxs(Box, {
    display: "flex",
    flexDirection: "column",
    flexJustify: "center",
    flexAlign: "center",
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressCircle, {
        continuous: true,
        size: "lg",
        valueText: "keywords"
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h4",
        variant: "sectionTitle",
        "data-testid": "KeywordGeneration__OECTitle",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$9.title
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 6,
      children: /*#__PURE__*/jsx(Typography, {
        component: "div",
        variant: "body",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$9.time
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$9.descriptionTheme
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$9.descriptionReview
        })
      })
    })]
  });
};
var InputSkeleton = function InputSkeleton() {
  return /*#__PURE__*/jsx(Box, {
    children: /*#__PURE__*/jsx(Box, {
      children: /*#__PURE__*/jsx(SkeletonLoader, {
        "data-testid": "InputSkeleton__Keywords",
        height: 45,
        width: 560,
        children: /*#__PURE__*/jsx("rect", {
          x: "0",
          y: "5",
          rx: "0",
          ry: "0",
          height: "40",
          width: "560"
        })
      })
    })
  });
};
var KeywordsEdit = function KeywordsEdit(_ref101) {
  var themes = _ref101.themes,
    keywords = _ref101.keywords,
    keywordsLoading = _ref101.keywordsLoading,
    setKeywords = _ref101.setKeywords;
  var handleKeywordsChange = function handleKeywordsChange(e, themeId) {
    var newKeywords = e.currentTarget.value;
    setKeywords({
      newKeywords: newKeywords,
      themeId: themeId
    });
  };
  var themesWithKeywords = themes.map(function (t) {
    var found = keywords.find(function (k) {
      return k.themeId === t.id;
    });
    return Object.assign({}, t, {
      keywords: found == null ? void 0 : found.keywords,
      error: found == null ? void 0 : found.error,
      errorMessages: found == null ? void 0 : found.errorMessages
    });
  });
  return /*#__PURE__*/jsx(List, {
    dense: true,
    children: themesWithKeywords.map(function (theme) {
      return /*#__PURE__*/jsx(List.Item, {
        children: /*#__PURE__*/jsxs(Grid, {
          noBleeds: true,
          fluid: true,
          children: [/*#__PURE__*/jsx(Grid.Item, {
            xs: 12,
            sm: 12,
            md: 3,
            children: /*#__PURE__*/jsx(Box, {
              mt: 2,
              children: /*#__PURE__*/jsx(Typography, {
                component: "div",
                variant: "body",
                children: theme.theme
              })
            })
          }), /*#__PURE__*/jsx(Grid.Item, {
            xs: 12,
            sm: 12,
            md: 9,
            children: keywordsLoading ? /*#__PURE__*/jsx(InputSkeleton, {}) : /*#__PURE__*/jsx(Input, Object.assign({
              id: "theme-".concat(theme.id),
              "data-testid": "theme-".concat(theme.id),
              stretched: true,
              value: theme.keywords ? theme.keywords : '',
              onChange: function onChange(e) {
                return handleKeywordsChange(e, theme.id);
              }
            }, theme.error && {
              color: 'warning',
              errorMessage: /*#__PURE__*/jsx(Box, {
                children: (theme == null ? void 0 : theme.errorMessages) && theme.errorMessages.map(function (message) {
                  return /*#__PURE__*/jsx(Typography, {
                    component: "p",
                    variant: "bodySm",
                    color: "warning",
                    children: message
                  }, message);
                })
              })
            }))
          })]
        })
      }, theme.id);
    })
  });
};
var COPY$8 = {
  title: {
    id: 'OpenEndedCoding.KeywordsInfo.title',
    defaultMessage: 'What are the keywords?',
    description: '[Type: Header][Vis: med] - selecting keywords title'
  },
  description: {
    id: 'OpenEndedCoding.KeywordsInfo.description',
    defaultMessage: 'Keywords are the unique words associated with a theme. Our model uses keywords to identify appropriate themes based on the language in a response, which makes tagging more accurate.',
    description: '[Type: Header][Vis: med] - selecting keywords description'
  },
  descriptionTaggedManually: {
    id: 'OpenEndedCoding.KeywordsInfo.descriptionTaggedManually',
    defaultMessage: 'The keywords shown here are based on the responses you tagged manually.',
    description: '[Type: Header][Vis: med] - selecting keywords description tagged manually'
  },
  do: {
    id: 'OpenEndedCoding.KeywordsInfo.do',
    defaultMessage: 'Do',
    description: '[Type: Header][Vis: med] - selecting keywords title do'
  },
  firstDo: {
    id: 'OpenEndedCoding.KeywordsInfo.firstDo',
    defaultMessage: 'Keep at least one keyword per theme.',
    description: '[Type: Header][Vis: med] - selecting keywords first do'
  },
  secondDo: {
    id: 'OpenEndedCoding.KeywordsInfo.secondDo',
    defaultMessage: 'Make sure each keyword is unique to a single theme.',
    description: '[Type: Header][Vis: med] - selecting keywords second do'
  },
  dont: {
    id: 'OpenEndedCoding.KeywordsInfo.dont',
    defaultMessage: "Don't",
    description: "[Type: Header][Vis: med] - selecting keywords title don't"
  },
  firstDont: {
    id: 'OpenEndedCoding.KeywordsInfo.firstDont',
    defaultMessage: 'Use the same keyword for multiple themes. Overlapping keywords might mean some themes are too similar. Consider merging these into a single theme.',
    description: '[Type: Header][Vis: med] - selecting keywords first dont'
  },
  secondDont: {
    id: 'OpenEndedCoding.KeywordsInfo.secondDont',
    defaultMessage: 'Add generic keywords. Keywords should be words that actually appear in the responses.',
    description: '[Type: Header][Vis: med] - selecting keywords second dont'
  }
};
var useStyles$7 = createUseStyles(function (theme) {
  return {
    list: {
      listStyleType: 'none',
      padding: 0,
      margin: "0 0 ".concat(theme.spacing[3], "px 0")
    },
    item: {
      display: 'flex',
      marginBottom: theme.spacing[2]
    }
  };
});
var InfoItem = function InfoItem(_ref102) {
  var text = _ref102.text,
    _ref102$positive = _ref102.positive,
    _positive = _ref102$positive === void 0 ? false : _ref102$positive;
  var classes = useStyles$7();
  return /*#__PURE__*/jsxs("li", {
    className: classes.item,
    children: [/*#__PURE__*/jsx(Box, {
      pr: 2,
      children: _positive ? /*#__PURE__*/jsx(IconCheck, {
        title: "check",
        color: "primary"
      }) : /*#__PURE__*/jsx(IconFlag, {
        title: "check",
        color: "warning"
      })
    }), /*#__PURE__*/jsx(Typography, {
      component: "span",
      variant: "bodySm",
      children: /*#__PURE__*/jsx(T, {
        desc: text
      })
    })]
  });
};
var KeywordsInfo = function KeywordsInfo() {
  var classes = useStyles$7();
  return /*#__PURE__*/jsxs(Box, {
    ml: 6,
    display: "flex",
    flexDirection: "column",
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h4",
        children: /*#__PURE__*/jsx("strong", {
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$8.title
          })
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 4,
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$8.description
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$8.descriptionTaggedManually
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h4",
        children: /*#__PURE__*/jsx("strong", {
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$8.do
          })
        })
      })
    }), /*#__PURE__*/jsxs("ul", {
      className: classes.list,
      children: [/*#__PURE__*/jsx(InfoItem, {
        text: COPY$8.firstDo,
        positive: true
      }), /*#__PURE__*/jsx(InfoItem, {
        text: COPY$8.secondDo,
        positive: true
      })]
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h4",
        children: /*#__PURE__*/jsx("strong", {
          children: /*#__PURE__*/jsx(T, {
            desc: COPY$8.dont
          })
        })
      })
    }), /*#__PURE__*/jsxs("ul", {
      className: classes.list,
      children: [/*#__PURE__*/jsx(InfoItem, {
        text: COPY$8.firstDont
      }), /*#__PURE__*/jsx(InfoItem, {
        text: COPY$8.secondDont
      })]
    })]
  });
};
var COPY$7 = {
  title: {
    id: 'OpenEndedCoding.KeywordSelection.title',
    defaultMessage: 'Are these keywords relevant?',
    description: '[Type: Header][Vis: med] - keyword review title'
  },
  description: {
    id: 'OpenEndedCoding.KeywordSelection.description',
    defaultMessage: 'Review the keywords associated with each theme.',
    description: '[Type: Header][Vis: med] - keyword review description'
  },
  question: {
    id: 'OpenEndedCoding.KeywordSelection.question',
    defaultMessage: 'Question: "{questionText}"',
    description: '[Type: Header][Vis: med] - keyword review description'
  }
};
var useStyles$6 = createUseStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      padding: "".concat(theme.spacing[5], "px ").concat(theme.spacing[9], "px")
    }
  };
});
var KeywordSelection = function KeywordSelection(_ref103) {
  var questionText = _ref103.questionText,
    themes = _ref103.themes,
    keywords = _ref103.keywords,
    keywordsLoading = _ref103.keywordsLoading,
    setKeywords = _ref103.setKeywords;
  var classes = useStyles$6();
  return /*#__PURE__*/jsxs(Box, {
    className: classes.container,
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h4",
        variant: "sectionTitle",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$7.title
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 1,
      children: /*#__PURE__*/jsx(Typography, {
        component: "div",
        variant: "body",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$7.description
        })
      })
    }), questionText && /*#__PURE__*/jsx(Box, {
      mb: 6,
      children: /*#__PURE__*/jsx(Typography, {
        component: "div",
        variant: "body",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$7.question,
          values: {
            questionText: questionText
          }
        })
      })
    }), /*#__PURE__*/jsxs(Grid, {
      noBleeds: true,
      noGutters: true,
      fluid: true,
      children: [/*#__PURE__*/jsx(Grid.Item, {
        xs: 12,
        sm: 12,
        md: 9,
        children: /*#__PURE__*/jsx(KeywordsEdit, {
          themes: themes,
          keywords: keywords,
          keywordsLoading: keywordsLoading,
          setKeywords: setKeywords
        })
      }), /*#__PURE__*/jsx(Grid.Item, {
        xs: 12,
        sm: 12,
        md: 3,
        children: /*#__PURE__*/jsx(KeywordsInfo, {})
      })]
    })]
  });
};
var COPY$6 = {
  title: {
    id: 'OpenEndedCoding.TrainingInProgress.title',
    defaultMessage: 'Auto-tagging your responses',
    description: '[Type: Header][Vis: med] - training title'
  },
  time: {
    id: 'OpenEndedCoding.TrainingInProgress.time',
    defaultMessage: 'About 3 minutes remaining',
    description: '[Type: Header][Vis: med] - time to train time left'
  },
  wait: {
    id: 'OpenEndedCoding.TrainingInProgress.wait',
    defaultMessage: "Please don't close or refresh this page. Leaving this page will cancel the auto-tagging process.",
    description: "[Type: Header][Vis: med] - time to train instruction don't leave"
  },
  description: {
    id: 'OpenEndedCoding.TrainingInProgress.description',
    defaultMessage: "We're running your themes and keywords through an extensive set of algorithms to make sure the auto-tags are accurate.",
    description: '[Type: Header][Vis: med] - training description'
  }
};
var useStyles$5 = createUseStyles(function (theme) {
  return {
    container: {
      maxWidth: '500px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center'
    }
  };
});
var TrainingInProgress = function TrainingInProgress() {
  var classes = useStyles$5();
  return /*#__PURE__*/jsxs(Box, {
    className: classes.container,
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(ProgressCircle, {
        continuous: true,
        size: "lg",
        valueText: "keywords"
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      children: /*#__PURE__*/jsx(Typography, {
        component: "h4",
        variant: "sectionTitle",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$6.title
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 2,
      children: /*#__PURE__*/jsx(Typography, {
        component: "div",
        variant: "body",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$6.time
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 5,
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "body",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$6.wait
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 1,
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "body",
        children: /*#__PURE__*/jsx(T, {
          desc: COPY$6.description
        })
      })
    })]
  });
};
var img = "data:image/svg+xml,%3csvg fill='none' height='128' viewBox='0 0 128 128' width='128' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cclipPath id='a'%3e%3cpath d='m32 35h64v64h-64z'/%3e%3c/clipPath%3e%3cmask id='b' height='128' maskUnits='userSpaceOnUse' width='128' x='0' y='0'%3e%3ccircle cx='64' cy='64' fill='%23008323' r='64'/%3e%3c/mask%3e%3cg mask='url(%23b)'%3e%3cpath d='m0 0h140v140h-140z' fill='white' transform='translate(-6 -6)'/%3e%3cg clip-rule='evenodd' fill='%23008323' fill-opacity='.6' fill-rule='evenodd' opacity='.7'%3e%3cpath d='m4.17065 2.6752c0 .82564-.67008 1.49573-1.49572 1.49573-.82565 0-1.49573-.67009-1.49573-1.49573s.67008-1.49573 1.49573-1.49573c.82564 0 1.49572.67009 1.49572 1.49573z'/%3e%3cpath d='m11.3501 2.6752c0 .82564-.6701 1.49573-1.49573 1.49573-.82564 0-1.49573-.67009-1.49573-1.49573s.67009-1.49573 1.49573-1.49573c.82563 0 1.49573.67009 1.49573 1.49573z'/%3e%3cpath d='m18.5295 2.6752c0 .82564-.67 1.49573-1.4957 1.49573-.8256 0-1.4957-.67009-1.4957-1.49573s.6701-1.49573 1.4957-1.49573c.8257 0 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m25.709 2.6752c0 .82564-.6701 1.49573-1.4957 1.49573-.8257 0-1.4958-.67009-1.4958-1.49573s.6701-1.49573 1.4958-1.49573c.8256 0 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m32.8884 2.6752c0 .82564-.6701 1.49573-1.4957 1.49573s-1.4957-.67009-1.4957-1.49573.6701-1.49573 1.4957-1.49573 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m40.0681 2.6752c0 .82564-.6701 1.49573-1.4957 1.49573-.8257 0-1.4957-.67009-1.4957-1.49573s.67-1.49573 1.4957-1.49573c.8256 0 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m54.427 2.6752c0 .82564-.6701 1.49573-1.4957 1.49573-.8257 0-1.4958-.67009-1.4958-1.49573s.6701-1.49573 1.4958-1.49573c.8256 0 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m61.6064 2.6752c0 .82564-.67 1.49573-1.4957 1.49573-.8256 0-1.4957-.67009-1.4957-1.49573s.6701-1.49573 1.4957-1.49573c.8257 0 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m68.7859 2.6752c0 .82564-.6701 1.49573-1.4957 1.49573-.8257 0-1.4958-.67009-1.4958-1.49573s.6701-1.49573 1.4958-1.49573c.8256 0 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m75.9656 2.6752c0 .82564-.6701 1.49573-1.4958 1.49573-.8256 0-1.4957-.67009-1.4957-1.49573s.6701-1.49573 1.4957-1.49573c.8257 0 1.4958.67009 1.4958 1.49573z'/%3e%3cpath d='m90.3245 2.6752c0 .82564-.6701 1.49573-1.4958 1.49573-.8256 0-1.4957-.67009-1.4957-1.49573s.6701-1.49573 1.4957-1.49573c.8257 0 1.4958.67009 1.4958 1.49573z'/%3e%3cpath d='m97.5039 2.6752c0 .82564-.6701 1.49573-1.4957 1.49573-.8257 0-1.4957-.67009-1.4957-1.49573s.67-1.49573 1.4957-1.49573c.8256 0 1.4957.67009 1.4957 1.49573z'/%3e%3cpath d='m104.683 2.6752c0 .82564-.67 1.49573-1.495 1.49573-.826 0-1.496-.67009-1.496-1.49573s.67-1.49573 1.496-1.49573c.825 0 1.495.67009 1.495 1.49573z'/%3e%3cpath d='m111.863 2.6752c0 .82564-.67 1.49573-1.496 1.49573s-1.496-.67009-1.496-1.49573.67-1.49573 1.496-1.49573 1.496.67009 1.496 1.49573z'/%3e%3cpath d='m119.042 2.6752c0 .82564-.67 1.49573-1.495 1.49573-.826 0-1.496-.67009-1.496-1.49573s.67-1.49573 1.496-1.49573c.825 0 1.495.67009 1.495 1.49573z'/%3e%3cpath d='m126.222 2.6752c0 .82564-.67 1.49573-1.496 1.49573-.825 0-1.496-.67009-1.496-1.49573s.671-1.49573 1.496-1.49573c.826 0 1.496.67009 1.496 1.49573z'/%3e%3cpath d='m4.17065 9.8547c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957 0-.82564.67008-1.49572 1.49573-1.49572.82564 0 1.49572.67008 1.49572 1.49572z'/%3e%3cpath d='m11.3501 9.8547c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957 0-.82564.67009-1.49572 1.49573-1.49572.82563 0 1.49573.67008 1.49573 1.49572z'/%3e%3cpath d='m18.5295 9.8547c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.82564.6701-1.49572 1.4957-1.49572.8257 0 1.4957.67008 1.4957 1.49572z'/%3e%3cpath d='m25.709 9.8547c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.82564.6701-1.49572 1.4958-1.49572.8256 0 1.4957.67008 1.4957 1.49572z'/%3e%3cpath d='m40.0681 9.8547c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.82564.67-1.49572 1.4957-1.49572.8256 0 1.4957.67008 1.4957 1.49572z'/%3e%3cpath d='m47.2476 9.8547c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.82564.6701-1.49572 1.4957-1.49572.8257 0 1.4958.67008 1.4958 1.49572z'/%3e%3cpath d='m54.427 9.8547c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.82564.6701-1.49572 1.4958-1.49572.8256 0 1.4957.67008 1.4957 1.49572z'/%3e%3cpath d='m61.6064 9.8547c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.82564.6701-1.49572 1.4957-1.49572.8257 0 1.4957.67008 1.4957 1.49572z'/%3e%3cpath d='m68.7859 9.8547c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.82564.6701-1.49572 1.4958-1.49572.8256 0 1.4957.67008 1.4957 1.49572z'/%3e%3cpath d='m75.9656 9.8547c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.82564.6701-1.49572 1.4957-1.49572.8257 0 1.4958.67008 1.4958 1.49572z'/%3e%3cpath d='m83.145 9.8547c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.82564.6701-1.49572 1.4957-1.49572s1.4957.67008 1.4957 1.49572z'/%3e%3cpath d='m90.3245 9.8547c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.82564.6701-1.49572 1.4957-1.49572.8257 0 1.4958.67008 1.4958 1.49572z'/%3e%3cpath d='m104.683 9.8547c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.82564.67-1.49572 1.496-1.49572.825 0 1.495.67008 1.495 1.49572z'/%3e%3cpath d='m111.863 9.8547c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.82564.67-1.49572 1.496-1.49572s1.496.67008 1.496 1.49572z'/%3e%3cpath d='m119.042 9.8547c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.82564.67-1.49572 1.496-1.49572.825 0 1.495.67008 1.495 1.49572z'/%3e%3cpath d='m126.222 9.8547c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957 0-.82564.671-1.49572 1.496-1.49572.826 0 1.496.67008 1.496 1.49572z'/%3e%3cpath d='m4.17065 17.0342c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957 0-.8257.67008-1.4957 1.49573-1.4957.82564 0 1.49572.67 1.49572 1.4957z'/%3e%3cpath d='m11.3501 17.0342c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957 0-.8257.67009-1.4957 1.49573-1.4957.82563 0 1.49573.67 1.49573 1.4957z'/%3e%3cpath d='m18.5295 17.0342c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m25.709 17.0342c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m32.8884 17.0342c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4957 1.4957-1.4957s1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m40.0681 17.0342c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4957 1.4957-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m47.2476 17.0342c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m54.427 17.0342c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m61.6064 17.0342c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m68.7859 17.0342c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m75.9656 17.0342c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m83.145 17.0342c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4957 1.4957-1.4957s1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m90.3245 17.0342c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m97.5039 17.0342c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4957 1.4957-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m104.683 17.0342c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4957 1.496-1.4957.825 0 1.495.67 1.495 1.4957z'/%3e%3cpath d='m111.863 17.0342c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.8257.67-1.4957 1.496-1.4957s1.496.67 1.496 1.4957z'/%3e%3cpath d='m119.042 17.0342c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4957 1.496-1.4957.825 0 1.495.67 1.495 1.4957z'/%3e%3cpath d='m126.222 17.0342c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957 0-.8257.671-1.4957 1.496-1.4957.826 0 1.496.67 1.496 1.4957z'/%3e%3cpath d='m4.17065 24.2137c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957 0-.8257.67008-1.4957 1.49573-1.4957.82564 0 1.49572.67 1.49572 1.4957z'/%3e%3cpath d='m11.3501 24.2137c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957 0-.8257.67009-1.4957 1.49573-1.4957.82563 0 1.49573.67 1.49573 1.4957z'/%3e%3cpath d='m18.5295 24.2137c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m25.709 24.2137c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m32.8884 24.2137c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4957 1.4957-1.4957s1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m40.0681 24.2137c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4957 1.4957-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m47.2476 24.2137c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m54.427 24.2137c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m61.6064 24.2137c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m68.7859 24.2137c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m75.9656 24.2137c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m83.145 24.2137c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4957 1.4957-1.4957s1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m90.3245 24.2137c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m97.5039 24.2137c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4957 1.4957-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m104.683 24.2137c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4957 1.496-1.4957.825 0 1.495.67 1.495 1.4957z'/%3e%3cpath d='m111.863 24.2137c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.8257.67-1.4957 1.496-1.4957s1.496.67 1.496 1.4957z'/%3e%3cpath d='m119.042 24.2137c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4957 1.496-1.4957.825 0 1.495.67 1.495 1.4957z'/%3e%3cpath d='m126.222 24.2137c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957 0-.8257.671-1.4957 1.496-1.4957.826 0 1.496.67 1.496 1.4957z'/%3e%3cpath d='m4.17065 31.3932c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957 0-.8257.67008-1.4958 1.49573-1.4958.82564 0 1.49572.6701 1.49572 1.4958z'/%3e%3cpath d='m18.5295 31.3932c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m25.709 31.3932c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m32.8884 31.3932c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m40.0681 31.3932c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m47.2476 31.3932c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m54.427 31.3932c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m61.6064 31.3932c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m68.7859 31.3932c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m75.9656 31.3932c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m83.145 31.3932c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m90.3245 31.3932c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m97.5039 31.3932c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m104.683 31.3932c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4958 1.496-1.4958.825 0 1.495.6701 1.495 1.4958z'/%3e%3cpath d='m111.863 31.3932c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.8257.67-1.4958 1.496-1.4958s1.496.6701 1.496 1.4958z'/%3e%3cpath d='m126.222 31.3932c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957 0-.8257.671-1.4958 1.496-1.4958.826 0 1.496.6701 1.496 1.4958z'/%3e%3cpath d='m4.17065 38.5727c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957 0-.8257.67008-1.4958 1.49573-1.4958.82564 0 1.49572.6701 1.49572 1.4958z'/%3e%3cpath d='m11.3501 38.5727c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957 0-.8257.67009-1.4958 1.49573-1.4958.82563 0 1.49573.6701 1.49573 1.4958z'/%3e%3cpath d='m18.5295 38.5727c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m25.709 38.5727c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m32.8884 38.5727c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m40.0681 38.5727c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m47.2476 38.5727c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m54.427 38.5727c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m61.6064 38.5727c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m68.7859 38.5727c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m75.9656 38.5727c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m83.145 38.5727c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m90.3245 38.5727c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m97.5039 38.5727c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m104.683 38.5727c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4958 1.496-1.4958.825 0 1.495.6701 1.495 1.4958z'/%3e%3cpath d='m111.863 38.5727c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.8257.67-1.4958 1.496-1.4958s1.496.6701 1.496 1.4958z'/%3e%3cpath d='m119.042 38.5727c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4958 1.496-1.4958.825 0 1.495.6701 1.495 1.4958z'/%3e%3cpath d='m126.222 38.5727c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957 0-.8257.671-1.4958 1.496-1.4958.826 0 1.496.6701 1.496 1.4958z'/%3e%3cpath d='m11.3501 45.7521c0 .8257-.6701 1.4958-1.49573 1.4958-.82564 0-1.49573-.6701-1.49573-1.4958 0-.8256.67009-1.4957 1.49573-1.4957.82563 0 1.49573.6701 1.49573 1.4957z'/%3e%3cpath d='m18.5295 45.7521c0 .8257-.67 1.4958-1.4957 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m25.709 45.7521c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4958-.6701-1.4958-1.4958 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m32.8884 45.7521c0 .8257-.6701 1.4958-1.4957 1.4958s-1.4957-.6701-1.4957-1.4958c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m40.0681 45.7521c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4957-.6701-1.4957-1.4958 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m47.2476 45.7521c0 .8257-.6701 1.4958-1.4958 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m54.427 45.7521c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4958-.6701-1.4958-1.4958 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m61.6064 45.7521c0 .8257-.67 1.4958-1.4957 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m68.7859 45.7521c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4958-.6701-1.4958-1.4958 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m75.9656 45.7521c0 .8257-.6701 1.4958-1.4958 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m83.145 45.7521c0 .8257-.6701 1.4958-1.4957 1.4958s-1.4957-.6701-1.4957-1.4958c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m90.3245 45.7521c0 .8257-.6701 1.4958-1.4958 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m97.5039 45.7521c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4957-.6701-1.4957-1.4958 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m104.683 45.7521c0 .8257-.67 1.4958-1.495 1.4958-.826 0-1.496-.6701-1.496-1.4958 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m111.863 45.7521c0 .8257-.67 1.4958-1.496 1.4958s-1.496-.6701-1.496-1.4958c0-.8256.67-1.4957 1.496-1.4957s1.496.6701 1.496 1.4957z'/%3e%3cpath d='m119.042 45.7521c0 .8257-.67 1.4958-1.495 1.4958-.826 0-1.496-.6701-1.496-1.4958 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m4.17065 52.9316c0 .8257-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.67-1.49573-1.4957 0-.8256.67008-1.4957 1.49573-1.4957.82564 0 1.49572.6701 1.49572 1.4957z'/%3e%3cpath d='m11.3501 52.9316c0 .8257-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.67-1.49573-1.4957 0-.8256.67009-1.4957 1.49573-1.4957.82563 0 1.49573.6701 1.49573 1.4957z'/%3e%3cpath d='m18.5295 52.9316c0 .8257-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m25.709 52.9316c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.67-1.4958-1.4957 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m32.8884 52.9316c0 .8257-.6701 1.4957-1.4957 1.4957s-1.4957-.67-1.4957-1.4957c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m40.0681 52.9316c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.67-1.4957-1.4957 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m47.2476 52.9316c0 .8257-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m54.427 52.9316c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.67-1.4958-1.4957 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m61.6064 52.9316c0 .8257-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m68.7859 52.9316c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.67-1.4958-1.4957 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m75.9656 52.9316c0 .8257-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m83.145 52.9316c0 .8257-.6701 1.4957-1.4957 1.4957s-1.4957-.67-1.4957-1.4957c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m90.3245 52.9316c0 .8257-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m97.5039 52.9316c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.67-1.4957-1.4957 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m104.683 52.9316c0 .8257-.67 1.4957-1.495 1.4957-.826 0-1.496-.67-1.496-1.4957 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m111.863 52.9316c0 .8257-.67 1.4957-1.496 1.4957s-1.496-.67-1.496-1.4957c0-.8256.67-1.4957 1.496-1.4957s1.496.6701 1.496 1.4957z'/%3e%3cpath d='m119.042 52.9316c0 .8257-.67 1.4957-1.495 1.4957-.826 0-1.496-.67-1.496-1.4957 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m126.222 52.9316c0 .8257-.67 1.4957-1.496 1.4957-.825 0-1.496-.67-1.496-1.4957 0-.8256.671-1.4957 1.496-1.4957.826 0 1.496.6701 1.496 1.4957z'/%3e%3cpath d='m4.17065 60.1111c0 .8257-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.67-1.49573-1.4957 0-.8256.67008-1.4957 1.49573-1.4957.82564 0 1.49572.6701 1.49572 1.4957z'/%3e%3cpath d='m11.3501 60.1111c0 .8257-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.67-1.49573-1.4957 0-.8256.67009-1.4957 1.49573-1.4957.82563 0 1.49573.6701 1.49573 1.4957z'/%3e%3cpath d='m18.5295 60.1111c0 .8257-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m25.709 60.1111c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.67-1.4958-1.4957 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m32.8884 60.1111c0 .8257-.6701 1.4957-1.4957 1.4957s-1.4957-.67-1.4957-1.4957c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m40.0681 60.1111c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.67-1.4957-1.4957 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m47.2476 60.1111c0 .8257-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m54.427 60.1111c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.67-1.4958-1.4957 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m61.6064 60.1111c0 .8257-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m68.7859 60.1111c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.67-1.4958-1.4957 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m75.9656 60.1111c0 .8257-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m83.145 60.1111c0 .8257-.6701 1.4957-1.4957 1.4957s-1.4957-.67-1.4957-1.4957c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m90.3245 60.1111c0 .8257-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.67-1.4957-1.4957 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m97.5039 60.1111c0 .8257-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.67-1.4957-1.4957 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m104.683 60.1111c0 .8257-.67 1.4957-1.495 1.4957-.826 0-1.496-.67-1.496-1.4957 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m111.863 60.1111c0 .8257-.67 1.4957-1.496 1.4957s-1.496-.67-1.496-1.4957c0-.8256.67-1.4957 1.496-1.4957s1.496.6701 1.496 1.4957z'/%3e%3cpath d='m119.042 60.1111c0 .8257-.67 1.4957-1.495 1.4957-.826 0-1.496-.67-1.496-1.4957 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m126.222 60.1111c0 .8257-.67 1.4957-1.496 1.4957-.825 0-1.496-.67-1.496-1.4957 0-.8256.671-1.4957 1.496-1.4957.826 0 1.496.6701 1.496 1.4957z'/%3e%3cpath d='m4.17065 67.2906c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957 0-.8257.67008-1.4957 1.49573-1.4957.82564 0 1.49572.67 1.49572 1.4957z'/%3e%3cpath d='m11.3501 67.2906c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957 0-.8257.67009-1.4957 1.49573-1.4957.82563 0 1.49573.67 1.49573 1.4957z'/%3e%3cpath d='m18.5295 67.2906c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m25.709 67.2906c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m32.8884 67.2906c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4957 1.4957-1.4957s1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m40.0681 67.2906c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4957 1.4957-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m47.2476 67.2906c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m54.427 67.2906c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m61.6064 67.2906c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m68.7859 67.2906c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4957 1.4958-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m75.9656 67.2906c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m83.145 67.2906c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4957 1.4957-1.4957s1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m90.3245 67.2906c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4957 1.4957-1.4957.8257 0 1.4958.67 1.4958 1.4957z'/%3e%3cpath d='m97.5039 67.2906c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4957 1.4957-1.4957.8256 0 1.4957.67 1.4957 1.4957z'/%3e%3cpath d='m104.683 67.2906c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4957 1.496-1.4957.825 0 1.495.67 1.495 1.4957z'/%3e%3cpath d='m111.863 67.2906c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.8257.67-1.4957 1.496-1.4957s1.496.67 1.496 1.4957z'/%3e%3cpath d='m119.042 67.2906c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4957 1.496-1.4957.825 0 1.495.67 1.495 1.4957z'/%3e%3cpath d='m126.222 67.2906c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957 0-.8257.671-1.4957 1.496-1.4957.826 0 1.496.67 1.496 1.4957z'/%3e%3cpath d='m4.17065 74.4701c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957s.67008-1.4957 1.49573-1.4957c.82564 0 1.49572.6701 1.49572 1.4957z'/%3e%3cpath d='m11.3501 74.4701c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957s.67009-1.4957 1.49573-1.4957c.82563 0 1.49573.6701 1.49573 1.4957z'/%3e%3cpath d='m18.5295 74.4701c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957s.6701-1.4957 1.4957-1.4957c.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m25.709 74.4701c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957s.6701-1.4957 1.4958-1.4957c.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m32.8884 74.4701c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957.6701-1.4957 1.4957-1.4957 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m40.0681 74.4701c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957s.67-1.4957 1.4957-1.4957c.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m47.2476 74.4701c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957s.6701-1.4957 1.4957-1.4957c.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m54.427 74.4701c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957s.6701-1.4957 1.4958-1.4957c.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m61.6064 74.4701c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957s.6701-1.4957 1.4957-1.4957c.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m68.7859 74.4701c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957s.6701-1.4957 1.4958-1.4957c.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m75.9656 74.4701c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957s.6701-1.4957 1.4957-1.4957c.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m83.145 74.4701c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957.6701-1.4957 1.4957-1.4957 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m90.3245 74.4701c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957s.6701-1.4957 1.4957-1.4957c.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m97.5039 74.4701c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957s.67-1.4957 1.4957-1.4957c.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m104.683 74.4701c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957s.67-1.4957 1.496-1.4957c.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m111.863 74.4701c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957.67-1.4957 1.496-1.4957 1.496.6701 1.496 1.4957z'/%3e%3cpath d='m119.042 74.4701c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957s.67-1.4957 1.496-1.4957c.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m126.222 74.4701c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957s.671-1.4957 1.496-1.4957c.826 0 1.496.6701 1.496 1.4957z'/%3e%3cpath d='m11.3501 81.6496c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957 0-.8257.67009-1.4958 1.49573-1.4958.82563 0 1.49573.6701 1.49573 1.4958z'/%3e%3cpath d='m18.5295 81.6496c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m25.709 81.6496c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m32.8884 81.6496c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m40.0681 81.6496c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m47.2476 81.6496c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m54.427 81.6496c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m61.6064 81.6496c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m68.7859 81.6496c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m75.9656 81.6496c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m83.145 81.6496c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m90.3245 81.6496c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m97.5039 81.6496c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m104.683 81.6496c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4958 1.496-1.4958.825 0 1.495.6701 1.495 1.4958z'/%3e%3cpath d='m111.863 81.6496c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.8257.67-1.4958 1.496-1.4958s1.496.6701 1.496 1.4958z'/%3e%3cpath d='m119.042 81.6496c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4958 1.496-1.4958.825 0 1.495.6701 1.495 1.4958z'/%3e%3cpath d='m4.17065 88.8291c0 .8256-.67008 1.4957-1.49572 1.4957-.82565 0-1.49573-.6701-1.49573-1.4957 0-.8257.67008-1.4958 1.49573-1.4958.82564 0 1.49572.6701 1.49572 1.4958z'/%3e%3cpath d='m11.3501 88.8291c0 .8256-.6701 1.4957-1.49573 1.4957-.82564 0-1.49573-.6701-1.49573-1.4957 0-.8257.67009-1.4958 1.49573-1.4958.82563 0 1.49573.6701 1.49573 1.4958z'/%3e%3cpath d='m18.5295 88.8291c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m25.709 88.8291c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m32.8884 88.8291c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m40.0681 88.8291c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m47.2476 88.8291c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m54.427 88.8291c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m61.6064 88.8291c0 .8256-.67 1.4957-1.4957 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m68.7859 88.8291c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4958-.6701-1.4958-1.4957 0-.8257.6701-1.4958 1.4958-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m75.9656 88.8291c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m83.145 88.8291c0 .8256-.6701 1.4957-1.4957 1.4957s-1.4957-.6701-1.4957-1.4957c0-.8257.6701-1.4958 1.4957-1.4958s1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m90.3245 88.8291c0 .8256-.6701 1.4957-1.4958 1.4957-.8256 0-1.4957-.6701-1.4957-1.4957 0-.8257.6701-1.4958 1.4957-1.4958.8257 0 1.4958.6701 1.4958 1.4958z'/%3e%3cpath d='m97.5039 88.8291c0 .8256-.6701 1.4957-1.4957 1.4957-.8257 0-1.4957-.6701-1.4957-1.4957 0-.8257.67-1.4958 1.4957-1.4958.8256 0 1.4957.6701 1.4957 1.4958z'/%3e%3cpath d='m104.683 88.8291c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4958 1.496-1.4958.825 0 1.495.6701 1.495 1.4958z'/%3e%3cpath d='m111.863 88.8291c0 .8256-.67 1.4957-1.496 1.4957s-1.496-.6701-1.496-1.4957c0-.8257.67-1.4958 1.496-1.4958s1.496.6701 1.496 1.4958z'/%3e%3cpath d='m119.042 88.8291c0 .8256-.67 1.4957-1.495 1.4957-.826 0-1.496-.6701-1.496-1.4957 0-.8257.67-1.4958 1.496-1.4958.825 0 1.495.6701 1.495 1.4958z'/%3e%3cpath d='m126.222 88.8291c0 .8256-.67 1.4957-1.496 1.4957-.825 0-1.496-.6701-1.496-1.4957 0-.8257.671-1.4958 1.496-1.4958.826 0 1.496.6701 1.496 1.4958z'/%3e%3cpath d='m4.17065 96.0085c0 .8257-.67008 1.4958-1.49572 1.4958-.82565 0-1.49573-.6701-1.49573-1.4958 0-.8256.67008-1.4957 1.49573-1.4957.82564 0 1.49572.6701 1.49572 1.4957z'/%3e%3cpath d='m18.5295 96.0085c0 .8257-.67 1.4958-1.4957 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m25.709 96.0085c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4958-.6701-1.4958-1.4958 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m32.8884 96.0085c0 .8257-.6701 1.4958-1.4957 1.4958s-1.4957-.6701-1.4957-1.4958c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m40.0681 96.0085c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4957-.6701-1.4957-1.4958 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m47.2476 96.0085c0 .8257-.6701 1.4958-1.4958 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m54.427 96.0085c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4958-.6701-1.4958-1.4958 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m61.6064 96.0085c0 .8257-.67 1.4958-1.4957 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m68.7859 96.0085c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4958-.6701-1.4958-1.4958 0-.8256.6701-1.4957 1.4958-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m75.9656 96.0085c0 .8257-.6701 1.4958-1.4958 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m83.145 96.0085c0 .8257-.6701 1.4958-1.4957 1.4958s-1.4957-.6701-1.4957-1.4958c0-.8256.6701-1.4957 1.4957-1.4957s1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m90.3245 96.0085c0 .8257-.6701 1.4958-1.4958 1.4958-.8256 0-1.4957-.6701-1.4957-1.4958 0-.8256.6701-1.4957 1.4957-1.4957.8257 0 1.4958.6701 1.4958 1.4957z'/%3e%3cpath d='m97.5039 96.0085c0 .8257-.6701 1.4958-1.4957 1.4958-.8257 0-1.4957-.6701-1.4957-1.4958 0-.8256.67-1.4957 1.4957-1.4957.8256 0 1.4957.6701 1.4957 1.4957z'/%3e%3cpath d='m104.683 96.0085c0 .8257-.67 1.4958-1.495 1.4958-.826 0-1.496-.6701-1.496-1.4958 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m111.863 96.0085c0 .8257-.67 1.4958-1.496 1.4958s-1.496-.6701-1.496-1.4958c0-.8256.67-1.4957 1.496-1.4957s1.496.6701 1.496 1.4957z'/%3e%3cpath d='m119.042 96.0085c0 .8257-.67 1.4958-1.495 1.4958-.826 0-1.496-.6701-1.496-1.4958 0-.8256.67-1.4957 1.496-1.4957.825 0 1.495.6701 1.495 1.4957z'/%3e%3cpath d='m126.222 96.0085c0 .8257-.67 1.4958-1.496 1.4958-.825 0-1.496-.6701-1.496-1.4958 0-.8256.671-1.4957 1.496-1.4957.826 0 1.496.6701 1.496 1.4957z'/%3e%3cpath d='m4.17065 103.188c0 .826-.67008 1.496-1.49572 1.496-.82565 0-1.49573-.67-1.49573-1.496s.67008-1.496 1.49573-1.496c.82564 0 1.49572.67 1.49572 1.496z'/%3e%3cpath d='m11.3501 103.188c0 .826-.6701 1.496-1.49573 1.496-.82564 0-1.49573-.67-1.49573-1.496s.67009-1.496 1.49573-1.496c.82563 0 1.49573.67 1.49573 1.496z'/%3e%3cpath d='m18.5295 103.188c0 .826-.67 1.496-1.4957 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m25.709 103.188c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4958-.67-1.4958-1.496s.6701-1.496 1.4958-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m32.8884 103.188c0 .826-.6701 1.496-1.4957 1.496s-1.4957-.67-1.4957-1.496.6701-1.496 1.4957-1.496 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m40.0681 103.188c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4957-.67-1.4957-1.496s.67-1.496 1.4957-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m47.2476 103.188c0 .826-.6701 1.496-1.4958 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m54.427 103.188c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4958-.67-1.4958-1.496s.6701-1.496 1.4958-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m61.6064 103.188c0 .826-.67 1.496-1.4957 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m68.7859 103.188c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4958-.67-1.4958-1.496s.6701-1.496 1.4958-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m75.9656 103.188c0 .826-.6701 1.496-1.4958 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m83.145 103.188c0 .826-.6701 1.496-1.4957 1.496s-1.4957-.67-1.4957-1.496.6701-1.496 1.4957-1.496 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m90.3245 103.188c0 .826-.6701 1.496-1.4958 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m97.5039 103.188c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4957-.67-1.4957-1.496s.67-1.496 1.4957-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m104.683 103.188c0 .826-.67 1.496-1.495 1.496-.826 0-1.496-.67-1.496-1.496s.67-1.496 1.496-1.496c.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m111.863 103.188c0 .826-.67 1.496-1.496 1.496s-1.496-.67-1.496-1.496.67-1.496 1.496-1.496 1.496.67 1.496 1.496z'/%3e%3cpath d='m119.042 103.188c0 .826-.67 1.496-1.495 1.496-.826 0-1.496-.67-1.496-1.496s.67-1.496 1.496-1.496c.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m126.222 103.188c0 .826-.67 1.496-1.496 1.496-.825 0-1.496-.67-1.496-1.496s.671-1.496 1.496-1.496c.826 0 1.496.67 1.496 1.496z'/%3e%3cpath d='m4.17065 110.368c0 .825-.67008 1.495-1.49572 1.495-.82565 0-1.49573-.67-1.49573-1.495 0-.826.67008-1.496 1.49573-1.496.82564 0 1.49572.67 1.49572 1.496z'/%3e%3cpath d='m11.3501 110.368c0 .825-.6701 1.495-1.49573 1.495-.82564 0-1.49573-.67-1.49573-1.495 0-.826.67009-1.496 1.49573-1.496.82563 0 1.49573.67 1.49573 1.496z'/%3e%3cpath d='m18.5295 110.368c0 .825-.67 1.495-1.4957 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m25.709 110.368c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4958-.67-1.4958-1.495 0-.826.6701-1.496 1.4958-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m32.8884 110.368c0 .825-.6701 1.495-1.4957 1.495s-1.4957-.67-1.4957-1.495c0-.826.6701-1.496 1.4957-1.496s1.4957.67 1.4957 1.496z'/%3e%3cpath d='m40.0681 110.368c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4957-.67-1.4957-1.495 0-.826.67-1.496 1.4957-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m47.2476 110.368c0 .825-.6701 1.495-1.4958 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m54.427 110.368c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4958-.67-1.4958-1.495 0-.826.6701-1.496 1.4958-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m61.6064 110.368c0 .825-.67 1.495-1.4957 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m68.7859 110.368c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4958-.67-1.4958-1.495 0-.826.6701-1.496 1.4958-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m75.9656 110.368c0 .825-.6701 1.495-1.4958 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m83.145 110.368c0 .825-.6701 1.495-1.4957 1.495s-1.4957-.67-1.4957-1.495c0-.826.6701-1.496 1.4957-1.496s1.4957.67 1.4957 1.496z'/%3e%3cpath d='m90.3245 110.368c0 .825-.6701 1.495-1.4958 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m97.5039 110.368c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4957-.67-1.4957-1.495 0-.826.67-1.496 1.4957-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m104.683 110.368c0 .825-.67 1.495-1.495 1.495-.826 0-1.496-.67-1.496-1.495 0-.826.67-1.496 1.496-1.496.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m111.863 110.368c0 .825-.67 1.495-1.496 1.495s-1.496-.67-1.496-1.495c0-.826.67-1.496 1.496-1.496s1.496.67 1.496 1.496z'/%3e%3cpath d='m119.042 110.368c0 .825-.67 1.495-1.495 1.495-.826 0-1.496-.67-1.496-1.495 0-.826.67-1.496 1.496-1.496.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m126.222 110.368c0 .825-.67 1.495-1.496 1.495-.825 0-1.496-.67-1.496-1.495 0-.826.671-1.496 1.496-1.496.826 0 1.496.67 1.496 1.496z'/%3e%3cpath d='m4.17065 117.547c0 .826-.67008 1.496-1.49572 1.496-.82565 0-1.49573-.67-1.49573-1.496s.67008-1.496 1.49573-1.496c.82564 0 1.49572.67 1.49572 1.496z'/%3e%3cpath d='m11.3501 117.547c0 .826-.6701 1.496-1.49573 1.496-.82564 0-1.49573-.67-1.49573-1.496s.67009-1.496 1.49573-1.496c.82563 0 1.49573.67 1.49573 1.496z'/%3e%3cpath d='m18.5295 117.547c0 .826-.67 1.496-1.4957 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m25.709 117.547c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4958-.67-1.4958-1.496s.6701-1.496 1.4958-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m40.0681 117.547c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4957-.67-1.4957-1.496s.67-1.496 1.4957-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m47.2476 117.547c0 .826-.6701 1.496-1.4958 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m54.427 117.547c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4958-.67-1.4958-1.496s.6701-1.496 1.4958-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m61.6064 117.547c0 .826-.67 1.496-1.4957 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m68.7859 117.547c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4958-.67-1.4958-1.496s.6701-1.496 1.4958-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m75.9656 117.547c0 .826-.6701 1.496-1.4958 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m83.145 117.547c0 .826-.6701 1.496-1.4957 1.496s-1.4957-.67-1.4957-1.496.6701-1.496 1.4957-1.496 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m90.3245 117.547c0 .826-.6701 1.496-1.4958 1.496-.8256 0-1.4957-.67-1.4957-1.496s.6701-1.496 1.4957-1.496c.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m97.5039 117.547c0 .826-.6701 1.496-1.4957 1.496-.8257 0-1.4957-.67-1.4957-1.496s.67-1.496 1.4957-1.496c.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m104.683 117.547c0 .826-.67 1.496-1.495 1.496-.826 0-1.496-.67-1.496-1.496s.67-1.496 1.496-1.496c.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m111.863 117.547c0 .826-.67 1.496-1.496 1.496s-1.496-.67-1.496-1.496.67-1.496 1.496-1.496 1.496.67 1.496 1.496z'/%3e%3cpath d='m119.042 117.547c0 .826-.67 1.496-1.495 1.496-.826 0-1.496-.67-1.496-1.496s.67-1.496 1.496-1.496c.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m126.222 117.547c0 .826-.67 1.496-1.496 1.496-.825 0-1.496-.67-1.496-1.496s.671-1.496 1.496-1.496c.826 0 1.496.67 1.496 1.496z'/%3e%3cpath d='m4.17065 124.727c0 .825-.67008 1.495-1.49572 1.495-.82565 0-1.49573-.67-1.49573-1.495 0-.826.67008-1.496 1.49573-1.496.82564 0 1.49572.67 1.49572 1.496z'/%3e%3cpath d='m11.3501 124.727c0 .825-.6701 1.495-1.49573 1.495-.82564 0-1.49573-.67-1.49573-1.495 0-.826.67009-1.496 1.49573-1.496.82563 0 1.49573.67 1.49573 1.496z'/%3e%3cpath d='m18.5295 124.727c0 .825-.67 1.495-1.4957 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m25.709 124.727c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4958-.67-1.4958-1.495 0-.826.6701-1.496 1.4958-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m32.8884 124.727c0 .825-.6701 1.495-1.4957 1.495s-1.4957-.67-1.4957-1.495c0-.826.6701-1.496 1.4957-1.496s1.4957.67 1.4957 1.496z'/%3e%3cpath d='m40.0681 124.727c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4957-.67-1.4957-1.495 0-.826.67-1.496 1.4957-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m54.427 124.727c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4958-.67-1.4958-1.495 0-.826.6701-1.496 1.4958-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m61.6064 124.727c0 .825-.67 1.495-1.4957 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m68.7859 124.727c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4958-.67-1.4958-1.495 0-.826.6701-1.496 1.4958-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m75.9656 124.727c0 .825-.6701 1.495-1.4958 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m90.3245 124.727c0 .825-.6701 1.495-1.4958 1.495-.8256 0-1.4957-.67-1.4957-1.495 0-.826.6701-1.496 1.4957-1.496.8257 0 1.4958.67 1.4958 1.496z'/%3e%3cpath d='m97.5039 124.727c0 .825-.6701 1.495-1.4957 1.495-.8257 0-1.4957-.67-1.4957-1.495 0-.826.67-1.496 1.4957-1.496.8256 0 1.4957.67 1.4957 1.496z'/%3e%3cpath d='m104.683 124.727c0 .825-.67 1.495-1.495 1.495-.826 0-1.496-.67-1.496-1.495 0-.826.67-1.496 1.496-1.496.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m111.863 124.727c0 .825-.67 1.495-1.496 1.495s-1.496-.67-1.496-1.495c0-.826.67-1.496 1.496-1.496s1.496.67 1.496 1.496z'/%3e%3cpath d='m119.042 124.727c0 .825-.67 1.495-1.495 1.495-.826 0-1.496-.67-1.496-1.495 0-.826.67-1.496 1.496-1.496.825 0 1.495.67 1.495 1.496z'/%3e%3cpath d='m126.222 124.727c0 .825-.67 1.495-1.496 1.495-.825 0-1.496-.67-1.496-1.495 0-.826.671-1.496 1.496-1.496.826 0 1.496.67 1.496 1.496z'/%3e%3c/g%3e%3c/g%3e%3cg clip-path='url(%23a)'%3e%3cpath clip-rule='evenodd' d='m90.8618 43.9028c1.1608-1.1884 3.0602-1.2058 4.2425-.039 1.0747 1.0608 1.1867 2.7351.3261 3.9236l-.2874.3408-40.9977 41.969c-1.0622 1.0874-2.7411 1.1934-3.9234.3131l-.3387-.2937-16.9891-17.0798c-1.1714-1.1777-1.1713-3.087.0004-4.2646 1.0651-1.0704 2.7318-1.1676 3.9062-.2916l.3364.292 14.8463 14.9287z' fill='%23008323' fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e";
var COPY$5 = {
  title: {
    id: 'OpenEndedCoding.TrainingFinished.title',
    defaultMessage: 'Auto-tagging complete',
    description: '[Type: Header][Vis: med] - training complete'
  },
  responses: {
    id: 'OpenEndedCoding.TrainingFinished.responses',
    defaultMessage: '{ autoTaggedCount } responses were tagged with your themes',
    description: '[Type: Header][Vis: med] - responses tagged'
  },
  responsesTodo: {
    id: 'OpenEndedCoding.TrainingFinished.responsesTodo',
    defaultMessage: "{ untaggedCount } responses didn't fit any themes",
    description: '[Type: Header][Vis: med] - responses not tagged'
  }
};
var useStyles$4 = createUseStyles(function (theme) {
  return {
    logo: {
      display: 'block',
      width: theme.spacing[9],
      height: theme.spacing[9],
      paddingTop: theme.spacing[5],
      paddingBottom: theme.spacing[5]
    }
  };
});
var IconRow = function IconRow(_ref104) {
  var text = _ref104.text;
  return /*#__PURE__*/jsxs(Box, {
    children: [/*#__PURE__*/jsx(IconCheck, {
      title: text,
      size: "sm"
    }), /*#__PURE__*/jsx(Box, {
      display: "inline",
      ml: 2,
      children: /*#__PURE__*/jsx(Typography, {
        component: "span",
        variant: "body",
        children: text
      })
    })]
  });
};
var TrainingFinished = function TrainingFinished(_ref105) {
  var _ref105$counts = _ref105.counts,
    autoTaggedCount = _ref105$counts.autoTaggedCount,
    untaggedCount = _ref105$counts.untaggedCount;
  var classes = useStyles$4();
  return /*#__PURE__*/jsxs(Box, {
    display: "flex",
    flexJustify: "center",
    flexAlign: "center",
    children: [/*#__PURE__*/jsx(Box, {
      mb: 3,
      mr: 5,
      children: /*#__PURE__*/jsx("img", {
        src: img,
        alt: "finished logo",
        className: classes.logo
      })
    }), /*#__PURE__*/jsx(Box, {
      mb: 3,
      ml: 5,
      children: /*#__PURE__*/jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        children: [/*#__PURE__*/jsx(Box, {
          mb: 3,
          children: /*#__PURE__*/jsx(Typography, {
            component: "h4",
            variant: "sectionTitle",
            children: /*#__PURE__*/jsx(T, {
              desc: COPY$5.title
            })
          })
        }), /*#__PURE__*/jsxs(Box, {
          mb: 3,
          ml: 2,
          children: [/*#__PURE__*/jsx(IconRow, {
            text: t(COPY$5.responses, {
              autoTaggedCount: autoTaggedCount
            })
          }), /*#__PURE__*/jsx(IconRow, {
            text: t(COPY$5.responsesTodo, {
              untaggedCount: untaggedCount
            })
          })]
        })]
      })
    })]
  });
};
var COPY$4 = {
  error: {
    id: 'OpenEndedCoding.TrainingFlow.error',
    defaultMessage: 'An error occurred during training',
    description: '[Type: Header][Vis: med] - OEC training error'
  }
};
var useStyles$3 = createUseStyles(function (theme) {
  return {
    container: {
      width: '500px',
      margin: theme.spacing[9]
    }
  };
});
var TrainingError = function TrainingError() {
  var classes = useStyles$3();
  return /*#__PURE__*/jsx(Box, {
    className: classes.container,
    children: /*#__PURE__*/jsx(FiveHundredError, {
      title: t(COPY$4.error)
    })
  });
};
var getStatus = function getStatus(status) {
  var trainingStep = {
    isTraining: status === TRAINING_STEP.TRAINING_IN_PROGRESS,
    isTrainingError: status === TRAINING_STEP.TRAINING_ERROR,
    isTrained: status === TRAINING_STEP.TRAINING_FINISHED,
    isGenerating: status === TRAINING_STEP.KEYWORD_GENERATION,
    isFetching: status === TRAINING_STEP.KEYWORD_FETCHING,
    isLoaded: status === TRAINING_STEP.KEYWORDS_LOADED,
    isViewing: status === TRAINING_STEP.KEYWORDS_VIEWING,
    isDisabled: false,
    isTagging: false,
    isExtracting: false
  };
  trainingStep.isDisabled = trainingStep.isGenerating || trainingStep.isTraining || trainingStep.isFetching || trainingStep.isViewing;
  trainingStep.isTagging = trainingStep.isTraining || trainingStep.isTrained || trainingStep.isTrainingError;
  trainingStep.isExtracting = trainingStep.isGenerating || trainingStep.isFetching;
  return trainingStep;
};
var COPY$3 = {
  backButton: {
    id: 'OpenEndedCoding.TrainingFlow.backButton',
    defaultMessage: 'Back to all responses',
    description: '[Type: Header][Vis: med] - Back button keywords'
  },
  backLabel: {
    id: 'OpenEndedCoding.TrainingFlow.backLabel',
    defaultMessage: 'Back button',
    description: '[Type: Header][Vis: med] - Back button keywords'
  },
  startButton: {
    id: 'OpenEndedCoding.TrainingFlow.startButton',
    defaultMessage: 'Start auto-tagging',
    description: '[Type: Header][Vis: med] - Start auto tagging'
  },
  finishedButton: {
    id: 'OpenEndedCoding.TrainingFlow.finishedButton',
    defaultMessage: 'Go to thematic analysis',
    description: '[Type: Header][Vis: med] - Finished auto tagging'
  }
};
var useStyles$2 = createUseStyles(function (theme) {
  return {
    footer: {
      display: 'flex',
      width: '100%',
      paddingY: theme.spacing[3],
      justifyContent: 'space-between'
    }
  };
});
var Footer = function Footer(_ref106) {
  var status = _ref106.status,
    keywords = _ref106.keywords,
    handleNext = _ref106.handleNext,
    onClose = _ref106.onClose;
  var classes = useStyles$2();
  var _useGeneral12 = useGeneral(),
    surveyId = _useGeneral12.surveyId,
    questionId = _useGeneral12.questionId,
    isSolutions = _useGeneral12.isSolutions;
  var _getStatus = getStatus(status),
    isTagging = _getStatus.isTagging,
    isDisabled = _getStatus.isDisabled,
    isTraining = _getStatus.isTraining;
  var isError = keywords.filter(function (k) {
    return k.error;
  }).length > 0;
  return /*#__PURE__*/jsxs(Box, {
    className: classes.footer,
    children: [/*#__PURE__*/jsxs(Button, {
      label: t(COPY$3.backLabel),
      disabled: isTraining,
      variant: "text",
      color: "secondary",
      onClick: onClose,
      children: [/*#__PURE__*/jsx(IconArrowLeft, {
        title: t(COPY$3.backLabel),
        size: "sm"
      }), /*#__PURE__*/jsx(T, {
        desc: COPY$3.backButton
      })]
    }), /*#__PURE__*/jsx(Button, {
      "data-testid": "Footer__StartButton",
      disabled: isDisabled || isError,
      onClick: function onClick() {
        handleNext();

        // tracking
        trackAmplitudeEvent({
          amplitudeEvent: isTagging ? 'open-ended coding viewed results' : 'open-ended coding started training',
          data: {
            surveyId: surveyId,
            questionId: questionId,
            pageName: isSolutions ? 'ctm' : 'analyze'
          }
        });
      },
      children: isTagging ? /*#__PURE__*/jsx(T, {
        desc: COPY$3.finishedButton
      }) : /*#__PURE__*/jsx(T, {
        desc: COPY$3.startButton
      })
    })]
  });
};
var COPY$2 = {
  title: {
    id: 'OpenEndedCoding.TrainingFlow.title',
    defaultMessage: 'Review keywords',
    description: '[Type: Header][Vis: med] - Header for open ended coding view keywords selection'
  },
  titleExtracting: {
    id: 'OpenEndedCoding.TrainingFlow.titleExtracting',
    defaultMessage: 'Extracting keywords',
    description: '[Type: Header][Vis: med] - Header for open ended coding view keywords extraction'
  },
  titleTagging: {
    id: 'OpenEndedCoding.TrainingFlow.titleTagging',
    defaultMessage: 'Auto-tagging',
    description: '[Type: Header][Vis: med] - Header for open ended coding auto tagging'
  }
};
var useStyles$1 = createUseStyles(function (theme) {
  var border = "2px solid ".concat(theme.palette.border.main);
  return {
    header: {
      borderBottom: border,
      display: 'flex',
      padding: "".concat(theme.spacing[6], "px ").concat(theme.spacing[7], "px"),
      justifyContent: 'center'
    }
  };
});
var Header = function Header(_ref107) {
  var status = _ref107.status;
  var classes = useStyles$1();
  var _getStatus2 = getStatus(status),
    isTagging = _getStatus2.isTagging,
    isExtracting = _getStatus2.isExtracting;
  return /*#__PURE__*/jsx(Box, {
    className: classes.header,
    children: /*#__PURE__*/jsx(Typography, {
      component: "h4",
      variant: "sectionTitle",
      children: /*#__PURE__*/jsx("strong", {
        children: isTagging ? /*#__PURE__*/jsx(T, {
          desc: COPY$2.titleTagging
        }) : isExtracting ? /*#__PURE__*/jsx(T, {
          desc: COPY$2.titleExtracting
        }) : /*#__PURE__*/jsx(T, {
          desc: COPY$2.title
        })
      })
    })
  });
};
var COPY$1 = {
  toastTitle: {
    id: 'OpenEndedCoding.OpenEndedCodingModal.toastTitle',
    defaultMessage: "Sorry, that didn't work",
    description: '[Type: Header][Vis: med] - title for open ending coding error'
  },
  toastBody: {
    id: 'OpenEndedCoding.OpenEndedCodingModal.toastBody',
    defaultMessage: 'Please try again.',
    description: '[Type: Header][Vis: med] - body for open ending coding error'
  }
};
var ErrorToast = function ErrorToast(_ref108) {
  var show = _ref108.show,
    _ref108$autoClose = _ref108.autoClose,
    _autoClose = _ref108$autoClose === void 0 ? false : _ref108$autoClose,
    _ref108$dismissible = _ref108.dismissible,
    _dismissible = _ref108$dismissible === void 0 ? false : _ref108$dismissible,
    onClose = _ref108.onClose;
  return /*#__PURE__*/jsxs(Toast, {
    show: show,
    autoClose: _autoClose,
    dismissible: _dismissible,
    color: "warning",
    onClose: onClose,
    children: [/*#__PURE__*/jsx(Toast.Title, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$1.toastTitle
      })
    }), /*#__PURE__*/jsx(Toast.Body, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY$1.toastBody
      })
    })]
  });
};
var _$e = function _$e(t) {
    return t;
  },
  _t$e;
var keywordsForQuestion = gql(_t$e || (_t$e = _$e(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  query keywordsForQuestion($surveyId: ID!, $questionId: ID!) {\n    getOecKeywords(surveyId: $surveyId, questionId: $questionId) {\n      id\n      label\n      keywords\n    }\n  }\n"])))));
var _$d = function _$d(t) {
    return t;
  },
  _t$d;
var generateOecKeywordTags = gql(_t$d || (_t$d = _$d(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  mutation generateOecKeywords($input: GenerateOecKeywordTagsInput!) {\n    generateOecKeywordTags(input: $input) {\n      predictionId\n      success\n    }\n  }\n"])))));
var _$c = function _$c(t) {
    return t;
  },
  _t$c;
var updateOecKeywordTags = gql(_t$c || (_t$c = _$c(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  mutation updateOecKeywords($input: UpdateOecKeywordTagsInput!) {\n    updateOecKeywordTags(input: $input) {\n      success\n    }\n  }\n"])))));
var _$b = function _$b(t) {
    return t;
  },
  _t$b;
var createOecJob = gql(_t$b || (_t$b = _$b(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  mutation createTrainingJob($input: CreateJobDataInput!) {\n    createOecJob(input: $input) {\n      success\n      job {\n        jobId: id\n        state\n        status\n        type\n        predictionId\n      }\n    }\n  }\n"])))));
var _$a = function _$a(t) {
    return t;
  },
  _t$a;
var getOecJobs = gql(_t$a || (_t$a = _$a(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  query getTrainingJobs($surveyId: ID!, $questionId: ID!) {\n    getOecJobs(surveyId: $surveyId, questionId: $questionId) {\n      jobs {\n        jobId: id\n        state\n        predictionId\n      }\n    }\n  }\n"])))));
var _$9 = function _$9(t) {
    return t;
  },
  _t$9;
var getOecResponseSummary = gql(_t$9 || (_t$9 = _$9(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  query trainingCounts($surveyId: ID!, $questionId: ID!, $isSolutions: Boolean) {\n    getOecResponseSummary(surveyId: $surveyId, questionId: $questionId, isSolutions: $isSolutions) {\n      counts {\n        responseCount\n        themesCount\n        autoTaggedCount\n        manualTaggedCount\n        untaggedCount\n      }\n    }\n  }\n"])))));
var _$8 = function _$8(t) {
    return t;
  },
  _t$8;
var sendOecKeywordFeedback = gql(_t$8 || (_t$8 = _$8(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  mutation sendKwFeedback($input: SendKeywordFeedbackInput!) {\n    sendOecKeywordFeedback(input: $input) {\n      success\n    }\n  }\n"])))));
var COPY = {
  header: {
    id: 'OpenEndedCoding.DiscardKeywordsModal.header',
    defaultMessage: 'Discard changes?',
    description: '[Type: Header][Vis: med] - Header for Discard Keywords Modal'
  },
  description: {
    id: 'OpenEndedCoding.DiscardKeywordsModal.description',
    defaultMessage: 'Leaving this page will discard any changes you made to your keywords.',
    description: '[Type: Header][Vis: med] - Discard Keywords Modal description'
  },
  cancel: {
    id: 'OpenEndedCoding.DiscardKeywordsModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Discard Keywords Modal cancel button'
  },
  discard: {
    id: 'OpenEndedCoding.DiscardKeywordsModal.discard',
    defaultMessage: 'Discard changes',
    description: '[Type: Header][Vis: med] - Discard Keywords Modal delete button'
  }
};
var DiscardKeywordsModal = function DiscardKeywordsModal(_ref109) {
  var show = _ref109.show,
    onDiscard = _ref109.onDiscard,
    onCancel = _ref109.onCancel;
  return /*#__PURE__*/jsxs(Modal, {
    "data-testid": "DiscardKeywordsModal__OEC",
    show: show,
    onClose: onCancel,
    children: [/*#__PURE__*/jsx(Modal.Header, {
      header: t(COPY.header)
    }), /*#__PURE__*/jsx(Modal.Body, {
      children: /*#__PURE__*/jsx(T, {
        desc: COPY.description
      })
    }), /*#__PURE__*/jsxs(Modal.Footer, {
      align: "right",
      children: [/*#__PURE__*/jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: onCancel,
        children: /*#__PURE__*/jsx(T, {
          desc: COPY.cancel
        })
      }), /*#__PURE__*/jsx(Button, {
        color: "warning",
        onClick: function onClick() {
          onDiscard();
        },
        children: /*#__PURE__*/jsx(T, {
          desc: COPY.discard
        })
      })]
    })]
  });
};
var FETCH_KEYWORDS_INTERVAL = 3000;
var FETCH_JOBS_INTERVAL = 10000;
var FETCH_KEYWORDS_RETRY_LIMIT = 5;

// We want to ensure the modal has a fixed height.
// and doesn't increase in size once responses are loaded.
var bodyHeight = '90vh';
var useStyles = createUseStyles({
  container: {
    height: bodyHeight,
    display: 'flex',
    justifyContent: 'center'
  }
});
var TrainingFlow = function TrainingFlow(_ref110) {
  var show = _ref110.show,
    questionText = _ref110.questionText;
  var classes = useStyles();
  var _useContext7 = useContext(OpenEndedCodingContext),
    reloadResponses = _useContext7.reloadResponses,
    handleTrainingFinished = _useContext7.handleTrainingFinished,
    setShowOecModal = _useContext7.setShowOecModal;
  var _useGeneral13 = useGeneral(),
    surveyId = _useGeneral13.surveyId,
    questionId = _useGeneral13.questionId,
    isSolutions = _useGeneral13.isSolutions,
    showDiscardKeywordsModal = _useGeneral13.showDiscardKeywordsModal;
  var _useFeedback = useFeedback(),
    jobId = _useFeedback.jobId,
    keywordPredictionId = _useFeedback.keywordPredictionId;
  var _useThemes9 = useThemes(),
    themes = _useThemes9.themes,
    keywords = _useThemes9.keywords;
  var _useTraining = useTraining(),
    summaryCounts = _useTraining.summaryCounts,
    trainingStep = _useTraining.trainingStep,
    unsavedKeywords = _useTraining.unsavedKeywords,
    generatedKeywords = _useTraining.generatedKeywords,
    showTrainingErrorToast = _useTraining.showTrainingErrorToast;
  var _useTrainingActions4 = useTrainingActions(),
    setTrainingStep = _useTrainingActions4.setTrainingStep,
    setSummaryCounts = _useTrainingActions4.setSummaryCounts,
    setShowTrainingErrorToast = _useTrainingActions4.setShowTrainingErrorToast,
    setUnsavedKeywords = _useTrainingActions4.setUnsavedKeywords,
    setShowTrainingScreen = _useTrainingActions4.setShowTrainingScreen,
    setMultipleTrainingFields = _useTrainingActions4.setMultiple;
  var _useThemesActions = useThemesActions(),
    setKeywords = _useThemesActions.setKeywords;
  var _useRetrainingActions2 = useRetrainingActions(),
    setTrainingStatus = _useRetrainingActions2.setTrainingStatus;
  var _useGeneralActions3 = useGeneralActions(),
    setShowDiscardKeywordsModal = _useGeneralActions3.setShowDiscardKeywordsModal;
  var _useFeedbackActions = useFeedbackActions(),
    setKeywordPredictionId = _useFeedbackActions.setKeywordPredictionId,
    setJobId = _useFeedbackActions.setJobId,
    setAutotaggingPredictionId = _useFeedbackActions.setAutotaggingPredictionId;

  // to make sure we don't make duplicate requests
  var _useState53 = useState(false),
    _useState54 = _slicedToArray(_useState53, 2),
    isGeneratingKeywords = _useState54[0],
    setIsGeneratingKeywords = _useState54[1];
  var _useState55 = useState(false),
    _useState56 = _slicedToArray(_useState55, 2),
    isFetchingKeywords = _useState56[0],
    setIsFetchingKeywords = _useState56[1];
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    isFetchingCounts = _useState58[0],
    setIsFetchingCounts = _useState58[1];
  var fetchKeywordsAttempts = useRef(0);
  var keywordsChanged = haveKeywordsChanged({
    generatedKeywords: transformKeywords({
      keywords: keywords
    }),
    unsavedKeywords: unsavedKeywords
  });
  var _getStatus3 = getStatus(trainingStep),
    isFetching = _getStatus3.isFetching,
    isGenerating = _getStatus3.isGenerating,
    isTraining = _getStatus3.isTraining,
    isLoaded = _getStatus3.isLoaded,
    isViewing = _getStatus3.isViewing,
    isTrained = _getStatus3.isTrained,
    isTrainingError = _getStatus3.isTrainingError;

  // queries
  var _useLazyQuery3 = useLazyQuery(keywordsForQuestion, {
      fetchPolicy: 'no-cache',
      onCompleted: function onCompleted(_ref111) {
        var newKeywords = _ref111.getOecKeywords;
        setIsFetchingKeywords(false);
        // update keywords here
        var hasKeywords = hasKeywordsPresent(newKeywords);
        if (hasKeywords) {
          var kw = newKeywords.map(function (k) {
            return formatKeywords(k);
          });
          // update state to loaded only if fetch is following a generate request.
          // disable the button start auto-tagging if user's intent is to view keywords.
          setMultipleTrainingFields({
            trainingStep: isViewing ? TRAINING_STEP.KEYWORDS_VIEWING : TRAINING_STEP.KEYWORDS_LOADED,
            unsavedKeywords: transformKeywords({
              keywords: kw
            }),
            generatedKeywords: newKeywords.map(function (k) {
              return {
                id: k.id,
                label: k.label,
                keywords: k.keywords
              };
            })
          });
          setKeywords(kw);
        }
      },
      onError: function onError() {
        // we want to keep polling if there was an error
        // fetching keywords until we hit a retry limit
        if (fetchKeywordsAttempts.current >= FETCH_KEYWORDS_RETRY_LIMIT) {
          setTrainingStep(TRAINING_STEP.TRAINING_ERROR);
        } else {
          fetchKeywordsAttempts.current += 1;
        }
      }
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    fetchKeywords = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    keywordsLoading = _useLazyQuery4$.loading,
    fetchKeywordsCalled = _useLazyQuery4$.called;
  var _useLazyQuery5 = useLazyQuery(getOecJobs, {
      fetchPolicy: 'no-cache',
      onCompleted: function onCompleted(_ref112) {
        var data = _ref112.getOecJobs;
        // job we just triggered
        var job = data.jobs.find(function (j) {
          return j.jobId === jobId;
        });

        // if the job has finished
        if ((job == null ? void 0 : job.state) === OECJobState.SUCCESS) {
          if (handleTrainingFinished) {
            handleTrainingFinished();
          }
          setTrainingStep(TRAINING_STEP.TRAINING_FINISHED);
          setTrainingStatus(OECTrainingStatus.TRAINING_COMPLETE);
          setAutotaggingPredictionId(job.predictionId);
        }

        // job error
        if ((job == null ? void 0 : job.state) === OECJobState.FAILED) {
          setTrainingStep(TRAINING_STEP.TRAINING_ERROR);
        }
      },
      onError: function onError() {
        setTrainingStep(TRAINING_STEP.TRAINING_ERROR);
      }
    }),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 1),
    fetchTrainingJobs = _useLazyQuery6[0];
  var _useLazyQuery7 = useLazyQuery(getOecResponseSummary, {
      onCompleted: function onCompleted(_ref113) {
        var counts = _ref113.getOecResponseSummary.counts;
        setIsFetchingCounts(false);
        setSummaryCounts(counts);
      },
      onError: function onError() {
        setShowTrainingErrorToast(true);
      }
    }),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 1),
    fetchSummaryCounts = _useLazyQuery8[0];

  // mutations
  var _useMutation5 = useMutation(generateOecKeywordTags, {
      onCompleted: function onCompleted(_ref114) {
        var _ref114$generateOecKe = _ref114.generateOecKeywordTags,
          predictionId = _ref114$generateOecKe.predictionId,
          success = _ref114$generateOecKe.success;
        if (success) {
          setIsGeneratingKeywords(false);
          setTrainingStep(TRAINING_STEP.KEYWORD_FETCHING);
          setKeywordPredictionId(predictionId);
        }
      },
      onError: function onError() {
        // show an error screen if there is an error generating keywords
        setTrainingStep(TRAINING_STEP.TRAINING_ERROR);
      }
    }),
    _useMutation6 = _slicedToArray(_useMutation5, 1),
    generateKeywords = _useMutation6[0];
  var _useMutation7 = useMutation(createOecJob, {
      onCompleted: function onCompleted(_ref115) {
        var job = _ref115.createOecJob.job;
        setTrainingStep(TRAINING_STEP.TRAINING_IN_PROGRESS);
        setJobId(job.jobId);
      },
      onError: function onError() {
        setShowTrainingErrorToast(true);
      }
    }),
    _useMutation8 = _slicedToArray(_useMutation7, 1),
    createTrainingJob = _useMutation8[0];
  var _useMutation9 = useMutation(updateOecKeywordTags, {
      onCompleted: function onCompleted(_ref116) {
        var success = _ref116.updateOecKeywordTags.success;
        if (success) {
          void createTrainingJob({
            variables: {
              input: {
                surveyId: surveyId,
                oecData: {
                  questionId: questionId
                }
              }
            }
          });
        }
      },
      onError: function onError() {
        // should create an error state here, train the model anyways
      }
    }),
    _useMutation10 = _slicedToArray(_useMutation9, 1),
    updateKeywords = _useMutation10[0];
  var _useMutation11 = useMutation(sendOecKeywordFeedback, {
      onCompleted: function onCompleted() {},
      onError: function onError() {}
    }),
    _useMutation12 = _slicedToArray(_useMutation11, 1),
    sendKeywordFeedback = _useMutation12[0];
  useEffect(function () {
    if (!show && isTrained) {
      setShowTrainingScreen(false);
    }
  }, [show, isTrained, setShowTrainingScreen]);

  // periodically fetch keywords
  useInterval(function () {
    if (!isFetching) {
      return;
    }
    fetchKeywords({
      variables: {
        surveyId: surveyId,
        questionId: questionId
      }
    });
  }, isFetching ? FETCH_KEYWORDS_INTERVAL : 0);

  // periodically fetch jobs
  useInterval(function () {
    if (!isTraining) {
      return;
    }
    fetchTrainingJobs({
      variables: {
        surveyId: surveyId,
        questionId: questionId
      }
    });
  }, isTraining ? FETCH_JOBS_INTERVAL : 0);

  // generate keywords initially
  if (isGenerating && !isGeneratingKeywords) {
    setIsGeneratingKeywords(true);
    void generateKeywords({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          tagIds: themes.map(function (theme) {
            return theme.id;
          })
        }
      }
    });
  }
  if (isViewing && keywords.length === 0 && !isFetchingKeywords && !fetchKeywordsCalled) {
    setIsFetchingKeywords(true);
    void fetchKeywords({
      variables: {
        surveyId: surveyId,
        questionId: questionId
      }
    });
  }

  // fetch counts when training finished
  if (isTrained && !isFetchingCounts && !summaryCounts) {
    setIsFetchingCounts(true);
    void fetchSummaryCounts({
      variables: {
        surveyId: surveyId,
        questionId: questionId,
        isSolutions: isSolutions
      }
    });
  }
  var handleValidKeywords = function handleValidKeywords(validatedKeywords) {
    var transformedKeywords = transformBackKeywords({
      keywords: validatedKeywords
    });
    var savedKeywords = formatKeywordsForPersistence({
      themes: themes,
      keywords: transformedKeywords
    });

    // Persist keywords in the backend
    void updateKeywords({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          tags: savedKeywords
        }
      }
    })
    // Send keyword feedback to the backend
    .then(function () {
      // sometimes a keyword prediction ID isn't present
      if (keywordPredictionId) {
        void sendKeywordFeedback({
          variables: {
            input: {
              predictionId: keywordPredictionId,
              surveyId: surveyId,
              questionId: questionId,
              autoGeneratedState: generatedKeywords,
              modifiedState: savedKeywords
            }
          }
        });
      }
    });

    // Update the global keywords
    setKeywords(transformedKeywords);
  };
  var handleNext = function handleNext() {
    // On final screen
    if (isTrained || isTrainingError) {
      setShowTrainingScreen(false);
      if (isTrained) {
        reloadResponses();
      }
    }

    // On keyword verification screen
    if (isLoaded) {
      var validatedKeywords = validateKeywords({
        keywords: unsavedKeywords
      });
      var validationError = validatedKeywords.filter(function (k) {
        return k.error;
      }).length > 0;

      // Don't continue if there is an issue with the keywords entered
      if (validationError) {
        setUnsavedKeywords(validatedKeywords);
      } else {
        handleValidKeywords(validatedKeywords);
      }
    }
  };
  var onUpdateKeywords = function onUpdateKeywords(_ref117) {
    var newKeywords = _ref117.newKeywords,
      themeId = _ref117.themeId;
    var currentKeywords = validateKeywordsForTheme({
      keywords: unsavedKeywords,
      newKeywords: newKeywords,
      themeId: themeId
    });
    setMultipleTrainingFields({
      unsavedKeywords: currentKeywords,
      trainingStep: !isEqual(keywords, transformBackKeywords({
        keywords: currentKeywords
      })) ? TRAINING_STEP.KEYWORDS_LOADED : TRAINING_STEP.KEYWORDS_VIEWING
    });
  };
  var TrainingFlowComponent = function TrainingFlowComponent() {
    if (isGenerating || isFetching) {
      return /*#__PURE__*/jsx(KeywordGeneration, {});
    }
    if (isLoaded || isViewing) {
      return /*#__PURE__*/jsx(KeywordSelection, {
        questionText: questionText,
        themes: themes,
        keywords: unsavedKeywords,
        keywordsLoading: keywordsLoading,
        setKeywords: onUpdateKeywords
      });
    }
    if (isTraining) {
      return /*#__PURE__*/jsx(TrainingInProgress, {});
    }
    if (isTrainingError) {
      return /*#__PURE__*/jsx(TrainingError, {});
    }
    if (summaryCounts) {
      return /*#__PURE__*/jsx(TrainingFinished, {
        counts: summaryCounts
      });
    }
    return /*#__PURE__*/jsx(TrainingInProgress, {});
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Header, {
      status: trainingStep
    }), /*#__PURE__*/jsx(Modal.Body, {
      padding: false,
      children: /*#__PURE__*/jsx(Box, {
        className: classes.container,
        children: TrainingFlowComponent()
      })
    }), /*#__PURE__*/jsx(Modal.Footer, {
      children: /*#__PURE__*/jsx(Footer, {
        status: trainingStep,
        handleNext: handleNext,
        onClose: function onClose() {
          if (keywordsChanged) {
            setShowDiscardKeywordsModal(OECDiscardKeywordsModal.SHOW_KEYWORDS_MODAL_BACK);
          } else if (isTrained) {
            reloadResponses();
            setShowTrainingScreen(false);
          } else {
            setShowTrainingScreen(false);
          }
        },
        keywords: unsavedKeywords
      })
    }), /*#__PURE__*/jsx(ErrorToast, {
      show: showTrainingErrorToast,
      dismissible: true,
      onClose: function onClose() {
        return setShowTrainingErrorToast(false);
      }
    }), /*#__PURE__*/jsx(DiscardKeywordsModal, {
      show: showDiscardKeywordsModal !== OECDiscardKeywordsModal.HIDE_KEYWORDS_MODAL,
      onCancel: function onCancel() {
        setShowDiscardKeywordsModal(OECDiscardKeywordsModal.HIDE_KEYWORDS_MODAL);
      },
      onDiscard: function onDiscard() {
        // reset keywords
        setMultipleTrainingFields({
          unsavedKeywords: transformKeywords({
            keywords: keywords
          }),
          showTrainingScreen: false
        });
        setShowDiscardKeywordsModal(OECDiscardKeywordsModal.HIDE_KEYWORDS_MODAL);

        // user intended to close OEC flow
        if (showDiscardKeywordsModal === OECDiscardKeywordsModal.SHOW_KEYWORDS_MODAL_CLOSED) {
          setShowOecModal(false);
        }
      }
    })]
  });
};
var _$7 = function _$7(t) {
    return t;
  },
  _t$7;
var themesForQuestion = gql(_t$7 || (_t$7 = _$7(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  query themesForQuestion($surveyId: ID!, $questionId: ID!) {\n    getOecQuestionTags(surveyId: $surveyId, questionId: $questionId) {\n      id\n      label\n      tagType\n      responseTextIds\n      autogeneratedTag {\n        id\n        responseTextIds\n      }\n    }\n  }\n"])))));
var _$6 = function _$6(t) {
    return t;
  },
  _t$6;
var createThemeForQuestion = gql(_t$6 || (_t$6 = _$6(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  mutation createThemeForQuestion($input: CreateTagDataInput!) {\n    createOecQuestionTag(input: $input) {\n      tag {\n        id\n        label\n        tagType\n        responseTextIds\n      }\n      trainingStatus\n    }\n  }\n"])))));
var _$5 = function _$5(t) {
    return t;
  },
  _t$5;
var deleteThemeForQuestion = gql(_t$5 || (_t$5 = _$5(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  mutation deleteThemeForQuestion($input: DeleteTagDataInput!) {\n    deleteOecQuestionTag(input: $input) {\n      success\n      tagId\n      trainingStatus\n    }\n  }\n"])))));
var _$4 = function _$4(t) {
    return t;
  },
  _t$4;
var editThemeForQuestion = gql(_t$4 || (_t$4 = _$4(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  mutation editThemeForQuestion($input: EditTagDataInput!) {\n    editOecQuestionTag(input: $input) {\n      tag {\n        id\n        label\n        tagType\n        responseTextIds\n      }\n      trainingStatus\n    }\n  }\n"])))));
var _$3 = function _$3(t) {
    return t;
  },
  _t$3;
var responsesForQuestion = gql(_t$3 || (_t$3 = _$3(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  query responsesForQuestion(\n    $surveyId: ID!\n    $questionId: ID!\n    $page: Int!\n    $pageSize: Int!\n    $searchPhrase: String\n    $isSolutions: Boolean\n    $includeSuggestedTags: Boolean\n    $sortBy: OecResponseSortBy\n    $selectedThemes: [ID!]\n    $selectedStimuli: [ID!]\n    $selectedSentiment: [OecSentiment!]\n  ) {\n    getOecResponses(\n      surveyId: $surveyId\n      questionId: $questionId\n      page: $page\n      pageSize: $pageSize\n      searchPhrase: $searchPhrase\n      isSolutions: $isSolutions\n      includeSuggestedTags: $includeSuggestedTags\n      selectedThemes: $selectedThemes\n      selectedStimuli: $selectedStimuli\n      sortBy: $sortBy\n      selectedSentiment: $selectedSentiment\n    ) {\n      saStats {\n        negative\n        neutral\n        positive\n        undetected\n      }\n      totalCount\n      optedIn\n      saEnabled\n      items {\n        id\n        stimulusId\n        respondentId\n        questionId\n        optionId\n        stimulus\n        content\n        tagIds\n        createdAt\n        suggestedTags\n        sentiment\n      }\n    }\n  }\n"])))));
var _$2 = function _$2(t) {
    return t;
  },
  _t$2;
var createTagsForResponse = gql(_t$2 || (_t$2 = _$2(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  mutation createTagsForResponse($input: OecTagResponseInput!) {\n    createOecTagsForResponse(input: $input) {\n      tagIds\n      responseTextId\n      success\n      trainingStatus\n    }\n  }\n"])))));
var _$1 = function _$1(t) {
    return t;
  },
  _t$1;
var deleteTagsForResponse = gql(_t$1 || (_t$1 = _$1(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  mutation deleteTagsForResponse($input: OecTagResponseInput!) {\n    deleteOecTagsForResponse(input: $input) {\n      tagIds\n      responseTextId\n      success\n      trainingStatus\n    }\n  }\n"])))));
var _ = function _(t) {
    return t;
  },
  _t;
var sendThemeFeedback = gql(_t || (_t = _(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  mutation sendThemeFeedback($input: SendTagFeedbackInput!) {\n    sendOecTagFeedback(input: $input) {\n      success\n    }\n  }\n"])))));
var OpenEndedCodingModal = function OpenEndedCodingModal(_ref118) {
  var show = _ref118.show,
    questionText = _ref118.questionText,
    jobId = _ref118.jobId,
    surveyId = _ref118.surveyId,
    questionId = _ref118.questionId,
    predictionId = _ref118.predictionId,
    _ref118$stimuli = _ref118.stimuli,
    _stimuli = _ref118$stimuli === void 0 ? [] : _ref118$stimuli,
    _ref118$autotrainingS = _ref118.autotrainingStatus,
    _autotrainingStatus = _ref118$autotrainingS === void 0 ? OECTrainingStatus.NOT_TRAINED : _ref118$autotrainingS,
    _ref118$isSolutions = _ref118.isSolutions,
    _isSolutions = _ref118$isSolutions === void 0 ? false : _ref118$isSolutions,
    setShouldRefetch = _ref118.setShouldRefetch,
    handleClose = _ref118.handleClose,
    handleTrainingFinished = _ref118.handleTrainingFinished,
    setShow = _ref118.setShow;
  // state
  var _useGeneral14 = useGeneral(),
    error = _useGeneral14.error,
    updateAutotaggingModalSeenCount = _useGeneral14.updateAutotaggingModalSeenCount;
  var _useResponses9 = useResponses(),
    responses = _useResponses9.responses,
    responsesTotal = _useResponses9.responsesTotal,
    responsesLoading = _useResponses9.responsesLoading,
    responsesError = _useResponses9.responsesError,
    significantChangesResponses = _useResponses9.significantChangesResponses;
  var _useFilters3 = useFilters(),
    selectedThemes = _useFilters3.selectedThemes;
  var _useThemes10 = useThemes(),
    themes = _useThemes10.themes,
    keywords = _useThemes10.keywords,
    initialThemes = _useThemes10.initialThemes,
    themesLoading = _useThemes10.themesLoading,
    themesError = _useThemes10.themesError,
    keywordsLoading = _useThemes10.keywordsLoading,
    keywordsError = _useThemes10.keywordsError,
    themesAdded = _useThemes10.themesAdded,
    themesDeleted = _useThemes10.themesDeleted;
  var _useFeedback2 = useFeedback(),
    autotaggingPredictionId = _useFeedback2.autotaggingPredictionId;
  var _useTraining2 = useTraining(),
    trainingStep = _useTraining2.trainingStep,
    showTrainingScreen = _useTraining2.showTrainingScreen,
    shouldRefetchOnOpen = _useTraining2.shouldRefetchOnOpen,
    unsavedKeywords = _useTraining2.unsavedKeywords;
  var _useRetraining4 = useRetraining(),
    notEnoughThemesCreatedStep = _useRetraining4.notEnoughThemesCreatedStep,
    notEnoughResponsesTaggedStep = _useRetraining4.notEnoughResponsesTaggedStep,
    applyThemeToMoreResponsesStep = _useRetraining4.applyThemeToMoreResponsesStep,
    trainingStatus = _useRetraining4.trainingStatus,
    notEnoughThemesCreated = _useRetraining4.notEnoughThemesCreated,
    notEnoughResponsesTagged = _useRetraining4.notEnoughResponsesTagged,
    applyThemeToMoreResponses = _useRetraining4.applyThemeToMoreResponses;

  // actions
  var _useGeneralActions4 = useGeneralActions(),
    setError = _useGeneralActions4.setError,
    setShowDiscardKeywordsModal = _useGeneralActions4.setShowDiscardKeywordsModal,
    setMultipleFieldsGeneral = _useGeneralActions4.setMultiple;
  var _useRetrainingActions3 = useRetrainingActions(),
    setTrainingStatus = _useRetrainingActions3.setTrainingStatus,
    setMultipleFieldsRetraining = _useRetrainingActions3.setMultiple;
  var _useTrainingActions5 = useTrainingActions(),
    setShouldRefetchOnOpen = _useTrainingActions5.setShouldRefetchOnOpen,
    setMultipleFieldsTraining = _useTrainingActions5.setMultiple;
  var _useThemesActions2 = useThemesActions(),
    setKeywords = _useThemesActions2.setKeywords,
    setInitialThemes = _useThemesActions2.setInitialThemes,
    setThemes = _useThemesActions2.setThemes,
    setThemesError = _useThemesActions2.setThemesError,
    setThemesLoading = _useThemesActions2.setThemesLoading,
    setKeywordsError = _useThemesActions2.setKeywordsError,
    setKeywordsLoading = _useThemesActions2.setKeywordsLoading,
    setMultipleFieldsThemes = _useThemesActions2.setMultiple;
  var _useResponsesActions = useResponsesActions(),
    setResponses = _useResponsesActions.setResponses,
    setResponsesPage = _useResponsesActions.setResponsesPage,
    setResponsesError = _useResponsesActions.setResponsesError,
    setResponsesLoading = _useResponsesActions.setResponsesLoading,
    setMultipleFieldsResponses = _useResponsesActions.setMultiple;
  var _useFiltersActions3 = useFiltersActions(),
    setSelectedThemes = _useFiltersActions3.setSelectedThemes,
    setMultipleFieldsFilters = _useFiltersActions3.setMultiple;
  var _useFeedbackActions2 = useFeedbackActions(),
    setAutotaggingPredictionId = _useFeedbackActions2.setAutotaggingPredictionId,
    setJobId = _useFeedbackActions2.setJobId;
  var _useThemesReuseAction3 = useThemesReuseActions(),
    setSuggestedThemes = _useThemesReuseAction3.setSuggestedThemes;
  var themesPerResponse = useMemo(function () {
    return getThemesPerResponse({
      responses: responses
    });
  }, [responses]);
  var firstPage = 0;

  // Queries
  var _useLazyQuery9 = useLazyQuery(responsesForQuestion, {
      variables: {
        surveyId: surveyId,
        questionId: questionId,
        page: firstPage,
        pageSize: RESPONSE_PAGE_SIZE,
        searchPhrase: '',
        isSolutions: _isSolutions,
        sortBy: SORT_BY.DATE,
        includeSuggestedTags: true
      },
      notifyOnNetworkStatusChange: true
    }),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    fetchResponses = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    responseData = _useLazyQuery10$.data,
    responsesDataError = _useLazyQuery10$.error,
    responsesDataLoading = _useLazyQuery10$.loading,
    fetchResponsesCalled = _useLazyQuery10$.called,
    refetchResponses = _useLazyQuery10$.refetch,
    fetchMoreResponses = _useLazyQuery10$.fetchMore;
  var _useLazyQuery11 = useLazyQuery(themesForQuestion, {
      variables: {
        surveyId: surveyId,
        questionId: questionId
      },
      notifyOnNetworkStatusChange: true
    }),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    fetchThemes = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    themeData = _useLazyQuery12$.data,
    themesDataError = _useLazyQuery12$.error,
    themesDataLoading = _useLazyQuery12$.loading,
    fetchThemesCalled = _useLazyQuery12$.called,
    refetchThemes = _useLazyQuery12$.refetch;
  var _useLazyQuery13 = useLazyQuery(keywordsForQuestion, {
      variables: {
        surveyId: surveyId,
        questionId: questionId
      },
      notifyOnNetworkStatusChange: true
    }),
    _useLazyQuery14 = _slicedToArray(_useLazyQuery13, 2),
    getKeywords = _useLazyQuery14[0],
    _useLazyQuery14$ = _useLazyQuery14[1],
    keywordsData = _useLazyQuery14$.data,
    keywordsDataLoading = _useLazyQuery14$.loading,
    keywordsDataError = _useLazyQuery14$.error;

  // Mutations
  var _useMutation13 = useMutation(createThemeForQuestion, {
      onCompleted: function onCompleted(_ref119) {
        var _ref119$createOecQues = _ref119.createOecQuestionTag,
          tag = _ref119$createOecQues.tag,
          status = _ref119$createOecQues.trainingStatus;
        if (!tag) {
          setError(true);
        }
        var formattedTheme = formatTheme(tag);

        // Theme created successfully, update state
        setMultipleFieldsThemes({
          themes: [].concat(_toConsumableArray(themes), [formattedTheme]),
          keywords: [].concat(_toConsumableArray(keywords), [createKeywords({
            theme: formattedTheme
          })])
        });
        setSelectedThemes([].concat(_toConsumableArray(selectedThemes), [formattedTheme.id]));
        setShouldRefetch(true);

        // User can enter a retraining state
        if (status === OECTrainingStatus.REQUIRES_RETRAINING) {
          setTrainingStatus(status);
        }
      },
      onError: function onError() {
        setError(true);
      }
    }),
    _useMutation14 = _slicedToArray(_useMutation13, 1),
    createOECTheme = _useMutation14[0];
  var _useMutation15 = useMutation(deleteThemeForQuestion, {
      onCompleted: function onCompleted(_ref120) {
        var _ref120$deleteOecQues = _ref120.deleteOecQuestionTag,
          success = _ref120$deleteOecQues.success,
          tagId = _ref120$deleteOecQues.tagId,
          status = _ref120$deleteOecQues.trainingStatus;
        if (!success) {
          setError(true);
        }

        // Theme deleted successfully, update state
        setMultipleFieldsThemes({
          themes: deleteTheme({
            themes: themes,
            themeId: tagId
          }),
          keywords: deleteKeywords({
            keywords: keywords,
            themeId: tagId
          })
        });
        setShouldRefetch(true);

        // User can enter a retraining state
        if (status === OECTrainingStatus.REQUIRES_RETRAINING) {
          setTrainingStatus(status);
        }
      },
      onError: function onError() {
        setError(true);
      }
    }),
    _useMutation16 = _slicedToArray(_useMutation15, 1),
    deleteOECTheme = _useMutation16[0];
  var _useMutation17 = useMutation(editThemeForQuestion, {
      onCompleted: function onCompleted(_ref121) {
        var _ref121$editOecQuesti = _ref121.editOecQuestionTag,
          tag = _ref121$editOecQuesti.tag,
          status = _ref121$editOecQuesti.trainingStatus;
        if (!tag) {
          setError(true);
        }

        // Theme updated successfully, update state
        setThemes(updateTheme({
          themes: themes,
          themeId: tag.id,
          name: tag.label
        }));
        setShouldRefetch(true);

        // User can enter a retraining state
        if (status === OECTrainingStatus.REQUIRES_RETRAINING) {
          setTrainingStatus(status);
        }
      },
      onError: function onError() {
        setError(true);
      }
    }),
    _useMutation18 = _slicedToArray(_useMutation17, 1),
    editOECTheme = _useMutation18[0];
  var _useMutation19 = useMutation(sendThemeFeedback, {
      onCompleted: function onCompleted() {},
      onError: function onError() {}
    }),
    _useMutation20 = _slicedToArray(_useMutation19, 1),
    sendOECThemeFeedback = _useMutation20[0];
  var sendTagFeedback = function sendTagFeedback(updatedResponses, updatedThemes, responseTextId) {
    var responseThemes = getResponseThemeIds({
      responses: updatedResponses,
      responseTextId: responseTextId
    });
    var predictedThemes = getPredictedThemes({
      themes: updatedThemes,
      responseThemes: responseThemes
    });
    void sendOECThemeFeedback({
      variables: {
        input: {
          predictionId: autotaggingPredictionId,
          surveyId: surveyId,
          responseTextId: responseTextId,
          responseText: getResponseText({
            responses: updatedResponses,
            responseTextId: responseTextId
          }),
          questionId: questionId,
          predictedThemes: predictedThemes,
          reviewedThemes: getThemeNames({
            themes: updatedThemes,
            themeIds: responseThemes
          })
        }
      }
    });
  };
  var _useMutation21 = useMutation(createTagsForResponse, {
      onCompleted: function onCompleted(_ref122) {
        var _ref122$createOecTags = _ref122.createOecTagsForResponse,
          success = _ref122$createOecTags.success,
          tagIds = _ref122$createOecTags.tagIds,
          responseTextId = _ref122$createOecTags.responseTextId,
          status = _ref122$createOecTags.trainingStatus;
        if (!success) {
          setError(true);
        }
        var updatedResponses = addThemesToResponse({
          responses: responses,
          themeIds: tagIds,
          responseTextId: responseTextId
        });
        var updatedThemes = addResponseToTheme({
          themes: themes,
          themeIds: tagIds,
          responseTextId: responseTextId
        });
        setResponses(updatedResponses);
        setThemes(updatedThemes);
        setShouldRefetch(true);
        if (autotaggingPredictionId) {
          sendTagFeedback(updatedResponses, updatedThemes, responseTextId);
        }

        // User can enter a retraining state
        if (status === OECTrainingStatus.REQUIRES_RETRAINING) {
          setTrainingStatus(status);
        }
      },
      onError: function onError() {
        setError(true);
      }
    }),
    _useMutation22 = _slicedToArray(_useMutation21, 1),
    createOECThemesForResponse = _useMutation22[0];
  var _useMutation23 = useMutation(deleteTagsForResponse, {
      onCompleted: function onCompleted(_ref123) {
        var _ref123$deleteOecTags = _ref123.deleteOecTagsForResponse,
          success = _ref123$deleteOecTags.success,
          tagIds = _ref123$deleteOecTags.tagIds,
          responseTextId = _ref123$deleteOecTags.responseTextId,
          status = _ref123$deleteOecTags.trainingStatus;
        if (!success) {
          setError(true);
        }
        var updatedResponses = removeThemesFromResponse({
          responses: responses,
          themeId: tagIds[0],
          responseTextId: responseTextId
        });
        var updatedThemes = removeResponseFromTheme({
          themes: themes,
          themeIds: tagIds,
          responseTextId: responseTextId
        });
        setResponses(updatedResponses);
        setThemes(updatedThemes);
        setShouldRefetch(true);
        if (autotaggingPredictionId) {
          sendTagFeedback(updatedResponses, updatedThemes, responseTextId);
        }

        // User can enter a retraining state
        if (status === OECTrainingStatus.REQUIRES_RETRAINING) {
          setTrainingStatus(status);
        }
      },
      onError: function onError() {
        setError(true);
      }
    }),
    _useMutation24 = _slicedToArray(_useMutation23, 1),
    removeOECThemesForResponse = _useMutation24[0];
  var deleteThemeHandler = function deleteThemeHandler(themeId) {
    void deleteOECTheme({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          tagId: themeId
        }
      }
    });
  };
  var updateThemeHandler = function updateThemeHandler(themeId, name) {
    void editOECTheme({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          tagId: themeId,
          label: name
        }
      }
    });
  };
  var createThemeHandler = function createThemeHandler(name) {
    void createOECTheme({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          label: name
        }
      }
    });
  };
  var handleRemoveThemesFromResponse = function handleRemoveThemesFromResponse(themeId, responseTextId) {
    void removeOECThemesForResponse({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          tagIds: [themeId],
          responseTextId: responseTextId
        }
      }
    });
  };
  var handleAddThemesToResponse = function handleAddThemesToResponse(themeIds, responseTextId) {
    void createOECThemesForResponse({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          tagIds: themeIds,
          responseTextId: responseTextId
        }
      }
    });
  };
  var handleCreateThemeForResponse = function handleCreateThemeForResponse(name, responseTextId) {
    // Create the theme
    void createOECTheme({
      variables: {
        input: {
          surveyId: surveyId,
          questionId: questionId,
          label: name
        }
      }
    })
    // Apply the theme to the response
    .then(function (_ref124) {
      var data = _ref124.data;
      var _data$createOecQuesti;
      var tagId = (data == null || (_data$createOecQuesti = data.createOecQuestionTag) == null ? void 0 : _data$createOecQuesti.tag.id) || '';
      setSelectedThemes([].concat(_toConsumableArray(selectedThemes), [tagId]));
      void createOECThemesForResponse({
        variables: {
          input: {
            surveyId: surveyId,
            questionId: questionId,
            tagIds: [tagId],
            responseTextId: responseTextId
          }
        }
      });
    });
  };
  var setResponsesPagination = function setResponsesPagination(page) {
    var _responseData$getOecR;
    setResponsesPage(page);
    var responsesLoaded = responseData == null || (_responseData$getOecR = responseData.getOecResponses) == null ? void 0 : _responseData$getOecR.items.length;
    var lastPage = responsesLoaded / RESPONSE_PAGE_SIZE - 1;

    // only fetch more responses if it's a new page
    if (page > lastPage) {
      void fetchMoreResponses({
        variables: {
          page: page,
          pageSize: RESPONSE_PAGE_SIZE
        },
        updateQuery: function updateQuery(prevData, _ref125) {
          var newData = _ref125.fetchMoreResult;
          if (!newData) {
            return prevData;
          }
          return mergePaginatedResponses({
            prevData: prevData,
            newData: newData,
            themesPerResponse: themesPerResponse
          });
        }
      });
    }
  };
  var searchResponses = function searchResponses(_ref126) {
    var search = _ref126.search,
      sortBy = _ref126.sortBy,
      themeIds = _ref126.themeIds,
      stimulusIds = _ref126.stimulusIds,
      sentiments = _ref126.sentiments;
    // need to use quotes to make it an exact search for responses

    void refetchResponses(Object.assign({}, {
      surveyId: surveyId,
      questionId: questionId,
      page: firstPage,
      pageSize: RESPONSE_PAGE_SIZE,
      searchPhrase: search,
      isSolutions: _isSolutions,
      sortBy: sortBy,
      includeSuggestedTags: true
    }, themeIds && {
      selectedThemes: themeIds
    }, stimulusIds && {
      selectedStimuli: stimulusIds
    }, sentiments && {
      selectedSentiment: sentiments
    })).then(function () {
      setResponsesPage(firstPage);
    });
  };
  var reload = useCallback(function (_ref127) {
    var _ref127$resetInitialT = _ref127.resetInitialThemes,
      _resetInitialThemes = _ref127$resetInitialT === void 0 ? false : _ref127$resetInitialT;
    // when reloading need to reset the filters/pagination
    setMultipleFieldsFilters({
      searchInput: '',
      sortValue: SORT_BY.DATE,
      filterDisabled: false,
      selectedThemes: [ALL_FILTER_ID].concat(_toConsumableArray(themes.map(function (_ref128) {
        var id = _ref128.id;
        return id;
      }))),
      selectedStimuli: _stimuli.map(function (_ref129) {
        var id = _ref129.id;
        return id;
      })
    });
    setResponsesPage(firstPage);
    if (_resetInitialThemes) {
      setInitialThemes([]);
    }
    void refetchResponses(Object.assign({
      surveyId: surveyId,
      questionId: questionId,
      page: firstPage,
      pageSize: RESPONSE_PAGE_SIZE,
      searchPhrase: '',
      isSolutions: _isSolutions,
      sortBy: SORT_BY.DATE,
      includeSuggestedTags: true
    }, {
      selectedThemes: undefined,
      selectedStimuli: undefined,
      selectedSentiment: undefined
    }));

    // Need to refetch themes as these include the new autogenerated tag IDs
    void refetchThemes();
    getKeywords();
  }, [_isSolutions, questionId, _stimuli, surveyId, themes, getKeywords, refetchResponses, refetchThemes, setInitialThemes, setMultipleFieldsFilters, setResponsesPage]);

  // execute queries on open
  useEffect(function () {
    if (show) {
      if (!fetchResponsesCalled) {
        fetchResponses();
      }
      if (!fetchThemesCalled) {
        fetchThemes();
      }
    }
  }, [show, fetchResponsesCalled, fetchThemesCalled, fetchResponses, fetchThemes]);

  // handle responses being fetched
  useEffect(function () {
    var result = responseData == null ? void 0 : responseData.getOecResponses;

    // loading
    if (!!responsesDataLoading !== responsesLoading) {
      setResponsesLoading(!!responsesDataLoading);
    }

    // error
    if (!!responsesDataError !== responsesError) {
      setResponsesError(!!responsesDataError);
    }
    if (result && 'items' in result && !responsesDataLoading) {
      var formattedResponses = result.items.map(function (r) {
        return formatResponse(r);
      });
      setMultipleFieldsResponses(Object.assign({}, {
        responses: formattedResponses,
        responsesCount: result.totalCount
      }, !responsesTotal && {
        responsesTotal: result.totalCount
      }, {
        showSA: result.optedIn && result.saEnabled
      }, {
        saStats: result.saStats
      }));

      // if there are suggested tags, update them for each response
      var suggested = result.items.reduce(function (acc, r) {
        var id = r.id,
          suggestedTags = r.suggestedTags;
        if (suggestedTags) {
          return Object.assign({}, acc, _defineProperty({}, id, suggestedTags));
        }
        return acc;
      }, {});
      setSuggestedThemes(suggested);
    }
  }, [responseData, responsesDataLoading, responsesDataError, responsesLoading, responsesError, responsesTotal, setMultipleFieldsResponses, setResponsesLoading, setResponsesError, setSuggestedThemes]);

  // handle themes being fetched
  useEffect(function () {
    var result = themeData == null ? void 0 : themeData.getOecQuestionTags;

    // loading
    if (!!themesDataLoading !== themesLoading) {
      setThemesLoading(!!themesDataLoading);
    }

    // error
    if (!!themesDataError !== themesError) {
      setThemesError(!!themesDataError);
    }
    if (result && result.length > 0 && !themesDataLoading) {
      var formattedThemes = result.map(function (t) {
        return formatTheme(t);
      });
      setMultipleFieldsThemes(Object.assign({
        themes: formattedThemes
      }, initialThemes.length === 0 && {
        initialThemes: formattedThemes
      }));
      setSelectedThemes([ALL_FILTER_ID].concat(_toConsumableArray(formattedThemes.map(function (t) {
        return t.id;
      }))));
    }
  }, [themeData, themesDataLoading, themesDataError, themesLoading, themesError, initialThemes, setMultipleFieldsThemes, setSelectedThemes, setThemesLoading, setThemesError]);

  // handle keywords being fetched
  useEffect(function () {
    var result = keywordsData == null ? void 0 : keywordsData.getOecKeywords;

    // loading
    if (!!keywordsDataLoading !== keywordsLoading) {
      setKeywordsLoading(!!keywordsDataLoading);
    }

    // error
    if (!!keywordsDataError !== keywordsError) {
      setKeywordsError(!!keywordsDataError);
    }
    if (result && !keywordsDataLoading) {
      var kw = result.map(function (k) {
        return formatKeywords(k);
      });
      setKeywords(kw);
    }
  }, [keywordsData, keywordsDataLoading, keywordsDataError, keywordsLoading, keywordsError, setKeywords, setMultipleFieldsThemes, setKeywordsError, setKeywordsLoading]);

  // handle setting initially autotaggingPredictionId
  useEffect(function () {
    if (!autotaggingPredictionId && predictionId) {
      setAutotaggingPredictionId(predictionId);
    }
  }, [autotaggingPredictionId, predictionId, setAutotaggingPredictionId]);

  // if a job id is passed, there is a currently running autotagging job
  useEffect(function () {
    if (!jobId) {
      return;
    }
    setJobId(jobId);
    setMultipleFieldsTraining({
      showTrainingScreen: true,
      trainingStep: TRAINING_STEP.TRAINING_IN_PROGRESS
    });
  }, [jobId, setJobId, setMultipleFieldsTraining]);

  // ensure training status is synced
  useEffect(function () {
    // the user hasn't completed autotagging
    if (!isAutoTaggingComplete(_autotrainingStatus)) {
      return;
    }

    // the training status needs to be synced as autotagging is complete
    if (!isAutoTaggingComplete(trainingStatus)) {
      setTrainingStatus(_autotrainingStatus);
    }
  }, [_autotrainingStatus, trainingStatus, setTrainingStatus]);

  // retraining stuff
  useEffect(function () {
    var status = getStatus$1({
      responsesTotal: responsesTotal,
      themes: themes
    });
    setMultipleFieldsRetraining({
      applyThemeToMoreResponses: status.applyThemeToMoreResponses,
      notEnoughResponsesTagged: status.notEnoughResponsesTagged,
      notEnoughThemesCreated: status.notEnoughThemesCreated
    });
  }, [responsesTotal, themes, setMultipleFieldsRetraining]);

  // retraining stuff
  useEffect(function () {
    var retrainData = getRetrainData({
      prevThemes: initialThemes,
      newThemes: themes
    });
    setMultipleFieldsThemes({
      themesAdded: retrainData.themesAdded,
      themesChanged: retrainData.themesChanged,
      themesDeleted: retrainData.themesDeleted
    });
    setMultipleFieldsResponses({
      significantChangesResponses: retrainData.significantChangesResponses,
      responsesChanged: retrainData.responsesChanged
    });
  }, [themes, initialThemes, setMultipleFieldsThemes, setMultipleFieldsResponses]);
  useEffect(function () {
    // we need to refetch themes and responses
    if (show && shouldRefetchOnOpen) {
      setShouldRefetchOnOpen(false);
      reload({});
    }
  }, [show, shouldRefetchOnOpen, setShouldRefetchOnOpen, reload]);

  // TODO: Extract to separate functions or another file + test
  var handleOecModalClose = function handleOecModalClose() {
    var keywordsChanged = haveKeywordsChanged({
      generatedKeywords: transformKeywords({
        keywords: keywords
      }),
      unsavedKeywords: unsavedKeywords
    });

    // 1. Check should we show the discard keywords modal
    if (keywordsChanged && showTrainingScreen) {
      setShowDiscardKeywordsModal(OECDiscardKeywordsModal.SHOW_KEYWORDS_MODAL_CLOSED);
      return;
    }
    var retrainAllowed = isRetrainAllowed({
      trainingStatus: trainingStatus,
      themesAdded: themesAdded,
      themesDeleted: themesDeleted,
      significantChangesResponses: significantChangesResponses,
      applyThemeToMoreResponses: applyThemeToMoreResponses,
      notEnoughResponsesTagged: notEnoughResponsesTagged,
      notEnoughThemesCreated: notEnoughThemesCreated,
      notEnoughThemesCreatedStep: notEnoughThemesCreatedStep,
      notEnoughResponsesTaggedStep: notEnoughResponsesTaggedStep,
      applyThemeToMoreResponsesStep: applyThemeToMoreResponsesStep
    });

    // 2. Check should we show the update autotagging modal
    if (trainingStatus !== OECTrainingStatus.NOT_TRAINED && retrainAllowed && !showTrainingScreen && updateAutotaggingModalSeenCount < MAX_SEEN_COUNT_UPDATE_AUTOTAGGING_MODAL) {
      setMultipleFieldsGeneral({
        updateAutotaggingModalSeenCount: updateAutotaggingModalSeenCount + 1,
        showUpdateAutotaggingModal: true
      });
      return;
    }

    // 3. Run any parent on close handlers
    handleClose();

    // 4. Need to refetch when opening, and show the manual tagging screen
    if (isAutoTaggingComplete(trainingStatus) && trainingStep === TRAINING_STEP.TRAINING_FINISHED) {
      setMultipleFieldsTraining({
        shouldRefetchOnOpen: true,
        showTrainingScreen: false,
        trainingStep: TRAINING_STEP.KEYWORD_GENERATION
      });
    }

    // 5. Trigger an amplitude event for the user closing the modal
    trackAmplitudeEvent({
      amplitudeEvent: 'open-ended coding exited modal',
      data: {
        surveyId: surveyId,
        questionId: questionId,
        pageName: _isSolutions ? 'ctm' : 'analyze'
      }
    });
  };
  return /*#__PURE__*/jsx(OpenEndedCodingContext.Provider, {
    value: {
      // handlers
      filterResponses: searchResponses,
      setShowOecModal: setShow,
      setResponsesPage: setResponsesPagination,
      deleteThemeHandler: deleteThemeHandler,
      updateThemeHandler: updateThemeHandler,
      createThemeHandler: createThemeHandler,
      handleRemoveThemesFromResponse: handleRemoveThemesFromResponse,
      handleAddThemesToResponse: handleAddThemesToResponse,
      handleCreateThemeForResponse: handleCreateThemeForResponse,
      handleTrainingFinished: handleTrainingFinished,
      reloadResponses: function reloadResponses() {
        return reload({
          resetInitialThemes: true
        });
      },
      getKeywords: getKeywords,
      setShouldRefetch: setShouldRefetch
    },
    children: /*#__PURE__*/jsxs(Modal, {
      show: show,
      size: "full",
      "data-testid": "OpenEndedCoding",
      onClose: handleOecModalClose,
      elevation: Z_INDEX,
      children: [!showTrainingScreen ? /*#__PURE__*/jsx(ManualTagging, {
        questionText: questionText,
        handleClose: handleClose
      }) : /*#__PURE__*/jsx(TrainingFlow, {
        questionText: questionText,
        show: show
      }), /*#__PURE__*/jsx(ErrorToast, {
        show: error,
        autoClose: true,
        onClose: function onClose() {
          setError(false);
        }
      })]
    })
  });
};
var setApolloClient = function setApolloClient(graphQLClientConfig) {
  if (!graphQLClientConfig.graphQLUri) {
    throw new Error('GraphQL Uri not provided');
  }
  return createBrowserApolloClient({
    uri: graphQLClientConfig.graphQLUri,
    cacheHydration: {},
    pageRequestId: graphQLClientConfig.pageRequestId,
    linkOptions: {
      credentials: 'include',
      batchInterval: 30
    },
    metadata: {
      appName: graphQLClientConfig.appName,
      appVersion: graphQLClientConfig.appVersion
    },
    availableLoggedOutPaths: []
  });
};
var _excluded = ["includeClient", "clientConfig"];
var OpenEndedCodingWrapper = function OpenEndedCodingWrapper(props) {
  var values = {
    isSolutions: props.isSolutions,
    surveyId: props.surveyId,
    questionId: props.questionId,
    themes: [],
    responses: [],
    keywords: [],
    stimuli: props.stimuli ? props.stimuli : [],
    showTrainingScreen: false,
    showSA: false,
    responsesPage: 0,
    responsesCount: 0,
    totalResponsesCount: 0,
    autotaggingPredictionId: props.predictionId,
    error: false,
    shouldRefetchOnOpen: false,
    // state for filters
    searchInput: '',
    sortValue: SORT_BY.DATE,
    filterDisabled: false,
    selectedThemes: [],
    // need to fetch themes first
    selectedSentiment: [],
    selectedStimuli: props.stimuli ? props.stimuli.map(function (_ref130) {
      var id = _ref130.id;
      return id;
    }) : [],
    // state for training
    trainingStep: TRAINING_STEP.KEYWORD_GENERATION,
    unsavedKeywords: [],
    keywordPredictionId: null,
    generatedKeywords: [],
    jobId: props.jobId ? props.jobId : null,
    summaryCounts: null,
    showTrainingErrorToast: false,
    trainingStatus: props.autotrainingStatus,
    showDiscardKeywordsModal: OECDiscardKeywordsModal.HIDE_KEYWORDS_MODAL,
    // retraining state
    initialThemes: [],
    notEnoughThemesCreatedStep: OECRetrainStepProgress.HIDE_STEP,
    notEnoughResponsesTaggedStep: OECRetrainStepProgress.HIDE_STEP,
    applyThemeToMoreResponsesStep: OECRetrainStepProgress.HIDE_STEP,
    showUpdateAutotaggingModal: false,
    updateAutotaggingModalSeenCount: 0,
    // themes reuse state
    previouslyUsedThemes: [],
    suggestedThemes: {},
    useCases: Object.keys(USE_CASES),
    selectedUseCase: null,
    selectedReusedThemes: []
  };
  var includeClient = props.includeClient,
    clientConfig = props.clientConfig,
    actualProps = _objectWithoutPropertiesLoose(props, _excluded);
  var oecApp = /*#__PURE__*/jsx(ThemeProvider, {
    theme: WrenchTheme,
    children: /*#__PURE__*/jsx(Provider, {
      values: values,
      children: /*#__PURE__*/jsx(OpenEndedCodingModal, Object.assign({}, actualProps))
    })
  });
  if (includeClient && !!clientConfig) {
    var apolloClient = setApolloClient(clientConfig);
    return /*#__PURE__*/jsx(ApolloProvider, {
      client: apolloClient,
      children: oecApp
    });
  }
  return oecApp;
};
export { OECJobState, OECTrainingStatus, OpenEndedCodingWrapper as OpenEndedCodingModal };